<template>

    <div class="co-root text-white">
        <!-- Famiglia icone condivisa con ServicesFlow: griglia 24, stroke 1.8,
             terminali tondi. Definite una volta, richiamate con <use>. -->
        <svg width="0" height="0" class="co-icon-defs" aria-hidden="true" focusable="false">
            <symbol id="co-back" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6" /></symbol>
            <symbol id="co-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7" /></symbol>
            <symbol id="co-next" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 5.5l6.5 6.5-6.5 6.5" /></symbol>
            <symbol id="co-user" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3.2" /><path d="M5 19.5v-1.2a5.2 5.2 0 0 1 5.2-5.2h3.6a5.2 5.2 0 0 1 5.2 5.2v1.2" /></symbol>
            <symbol id="co-qr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3.2" y="3.2" width="7" height="7" rx="1.6" /><rect x="13.8" y="3.2" width="7" height="7" rx="1.6" /><rect x="3.2" y="13.8" width="7" height="7" rx="1.6" /><path d="M13.8 13.8h3.2v3.2M20.8 17v3.8M13.8 20.8h.01M17 20.8h.01" /></symbol>
            <symbol id="co-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4.6" y="10.4" width="14.8" height="9.4" rx="2.4" /><path d="M8.2 10.4V7.8a3.8 3.8 0 0 1 7.6 0v2.6" /></symbol>
        </svg>

        <!-- Toast Container -->
        <div class="toast-container">
            <div v-for="(toast, index) in toasts" :key="index" :class="['toast', `toast-${toast.type}`, 'show']">
                {{ toast.message }}
            </div>
        </div>

        <!-- Barra superiore: indietro a sinistra, logo ancorato a destra cosi'
             non si sposta quando il tasto compare o sparisce. -->
        <div class="co-topbar">
            <button type="button" class="co-back" @click="$router.go(-1)" aria-label="Torna indietro">
                <svg><use href="#co-back" /></svg>
            </button>
            <div class="user-info-nav" v-if="userFullName" @click="toggleMenu">
                <span class="user-name">
                    <span class="user-name-label">Hai effettuato l'accesso come</span>
                    <span class="user-name-value">{{userFullName.replace(/\b\w/g, c => c.toUpperCase())}}</span>
                </span>
                <div v-show="menuVisible" class="dropdown-menu">
                    <a href="/account" class="menu-item">Account</a>
                    <a href="/logout" class="menu-item">Logout</a>
                </div>
            </div>
            <div class="co-topbar-right">
                <img src="/elite-logo-white.png" alt="Elite Fitness" class="co-logo" />
            </div>
        </div>

    <div class="container text-center" v-if="productNotFound || isServiceDisabled">
            <h1>
                <i class="fa-solid fa-xmark"></i>
            </h1>
            <h3 class="fw-bold">Il prodotto che cerchi non esiste o non è disponibile.</h3>
            <router-link to="https://elitefitness.it/app">
                <button class="btn btn-custom">Torna all'App</button>
            </router-link>
        </div>
    <div v-if="selectedProduct && !productNotFound && !isServiceDisabled" class="co-shell">

            <div class="co-body">
                <!-- Left column with steps -->
                <div class="co-col-main">
                <!-- Barra dei passi: sostituisce i quattro .step-header sparsi e la
                     numerazione aritmetica ripetuta inline in ogni blocco. -->
                <div class="co-progress co-progress--inline" v-if="!freeTrial">
                    <span class="co-pill" :class="{ 'is-now': step === 1, 'is-done': step > 1 }">
                        <span class="co-dot">
                            <svg v-if="step > 1"><use href="#co-check" /></svg>
                            <template v-else>1</template>
                        </span>
                        <span class="co-pill-label">Piano</span>
                    </span>
                    <span class="co-progress-sep"></span>
                    <span class="co-pill" :class="{ 'is-now': step === 2, 'is-done': step > 2 }">
                        <span class="co-dot">
                            <svg v-if="step > 2"><use href="#co-check" /></svg>
                            <template v-else>2</template>
                        </span>
                        <span class="co-pill-label">I tuoi dati</span>
                    </span>
                    <span class="co-progress-sep"></span>
                    <span class="co-pill" :class="{ 'is-now': step >= 3 }">
                        <span class="co-dot">3</span>
                        <span class="co-pill-label">Pagamento</span>
                    </span>
                </div>
                    <div class="step-container">
                        <!-- Selezione del trainer per BIA -->
                        <div v-if="showBIATrainerSelection" class="step active" id="step-1-bia">
                            <h2 class="co-step-title">Scegli il trainer</h2>
                            <div class="step-content">
                                <div class="trainer-grid">
                                    <div :class="['trainer-option', { selected: selectedBIATrainerId == (trainer.id || trainer.trainerId) }]"
                                        @click="selectBIATrainer(trainer)" v-for="trainer in trainersForCheckout" :key="trainer.id || trainer.trainerId">
                                        <div class="trainer-title">{{ trainer.fullName }}</div>
                                        <div v-if="selectedBIATrainerId == trainer.id" class="checkmark">&#10004;</div>
                                    </div>
                                </div>
                                <div v-if="selectedBIATrainerId != null" class="text-center">
                                    <button @click="goNextAfterBIA" class="btn btn-custom mt-4">Avanti</button>
                                </div>
                            </div>

                        </div>
                        <!-- Step 1 -->
                        <div v-if="showVariationStep" class="step" :class="{ active: step === 1 }" id="step-1">
                            <h2 class="co-step-title" v-if="step === 1">Scegli il piano</h2>
                            <transition name="fade">
                                <div v-if="step === 1" class="step-content">
                                    <!-- Alert: Login required for discount code -->
                                    <div v-if="!userLogged && discountCode?.length > 0 && !promoCode && !discountCodeFromUrl && !isGiftCard" class="alert alert-danger d-flex align-items-center" role="alert" style="margin-bottom: 12px;">
                                        <i class="fa-solid fa-triangle-exclamation"></i>
                                        <span style="margin-left: 10px;">Per applicare un codice sconto, devi
                                            <router-link :to="getLoginLink()">
                                                <a style="color:white" href="#">effettuare l'accesso</a>
                                            </router-link>
                                        </span>
                                    </div>
                                    <!-- Mobile-only: Remaining seats info for course-type services -->
                                    <div class="d-xl-none" v-if="remainingCount != null" style="margin-bottom: 12px;">
                                        <div v-if="remainingCount > 0" class="alert alert-primary d-flex align-items-center" role="alert">
                                            <i class="fa-solid fa-circle-info"></i>
                                            <span style="margin-left: 10px;">Rimangono {{ remainingCount }} posti disponibili.</span>
                                        </div>
                                        <div v-else class="alert alert-danger d-flex align-items-center" role="alert">
                                            <i class="fa-solid fa-triangle-exclamation"></i>
                                            <span style="margin-left: 10px;">Non ci sono posti disponibili.</span>
                                        </div>
                                    </div>
                                    <!-- Selezione centro (solo Sala Pesi / Fitness Lover) - sempre visibile -->
                                    <div v-if="productIsFitnessLover && !isFollowPaidListPromo" class="center-select-box mb-4">
                                        <label for="centerSelect" class="center-select-label"><strong>Scegli centro</strong></label>
                                        <p class="center-select-hint">I prezzi e le promozioni variano a seconda della sede selezionata.</p>
                                        <select id="centerSelect" :value="selectedCenterId"
                                            :disabled="!!smartOffer && !!selectedCenterId"
                                            @change="onCenterSelectChange($event)"
                                            class="form-select custom-select center-select-input"
                                            :class="{ 'form-select-selected': selectedCenterId }">
                                            <option value="">Tutti</option>
                                            <option v-for="c in getServiceCenters()" :key="c.id" :value="c.id">
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <!-- Con una promo attiva le durate si dividono in due gruppi invece di
                                         comparire in un elenco unico con quelle escluse in grigio: il grigio dice
                                         «rotto», non «non in offerta», e nasconderle del tutto toglierebbe al socio
                                         un acquisto che potrebbe comunque volere. -->
                                    <p v-if="hasDurateFuoriOfferta" class="duration-group-title">La tua offerta</p>
                                    <div class="duration-grid">
                                        <div v-for="variation in durateInOfferta"
                                            :key="variation.variationName"
                                            @click="onVariationClick(variation)"
                                            :class="['duration-option', { selected: selectedVariationName === variation.variationName }]">
                                            <div class="duration-title">{{ variation.variationName }}</div>
                                            <div v-if="variationOffer(variation).sconto > 0" class="duration-price">
                                                <span class="duration-price-list">{{ variationOffer(variation).listino.toFixed(2) }}€</span>
                                                <span>{{ variationOffer(variation).scontato.toFixed(2) }}€</span>
                                            </div>
                                            <div v-else class="duration-price">{{ Number(variation.price || 0).toFixed(2) }}€</div>
                                            <div v-if="variationGiftLabel(variation)" class="duration-gift">{{ variationGiftLabel(variation) }}</div>
                                            <div v-if="selectedVariationName === variation.variationName"
                                                class="checkmark">&#10004;</div>
                                        </div>
                                    </div>
                                    <template v-if="hasDurateFuoriOfferta">
                                        <p class="duration-group-title duration-group-title--muted">
                                            Altri abbonamenti <span>— a prezzo di listino</span>
                                        </p>
                                        <div class="duration-grid">
                                            <div v-for="variation in durateFuoriOfferta"
                                                :key="variation.variationName"
                                                @click="onVariationClick(variation)"
                                                :class="['duration-option', { selected: selectedVariationName === variation.variationName }]">
                                                <div class="duration-title">{{ variation.variationName }}</div>
                                                <div class="duration-price">{{ Number(variation.price || 0).toFixed(2) }}€</div>
                                                <div v-if="selectedVariationName === variation.variationName"
                                                    class="checkmark">&#10004;</div>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- Iniziative commerciali (#210/#211): prezzo deciso dal server e proposta di durata superiore. -->
                                    <div v-if="initiativeNote" class="initiative-note" role="status">
                                        <strong>{{ initiativeNote.label }}</strong>:
                                        <span class="duration-price-list">{{ initiativeNote.list.toFixed(2) }}€</span>
                                        <span>{{ initiativeNote.price.toFixed(2) }}€</span>
                                    </div>
                                    <div v-if="showUpgradeProposal" class="upgrade-proposal" role="dialog" aria-label="Proposta di upgrade">
                                        <strong>{{ upgradeProposal.title }}</strong>
                                        <p v-if="upgradeProposal.body">{{ upgradeProposal.body }}</p>
                                        <p v-if="upgradeProposal.price">
                                            {{ upgradeProposal.proposedDuration }}: <strong>{{ Number(upgradeProposal.price).toFixed(2) }}€</strong>
                                        </p>
                                        <div class="upgrade-proposal-actions">
                                            <button type="button" class="upgrade-proposal-cta" @click="acceptUpgradeProposal">
                                                {{ upgradeProposal.primaryLabel || ('Passa al ' + String(upgradeProposal.proposedDuration || '').toLowerCase()) }}
                                            </button>
                                            <button type="button" class="upgrade-proposal-later" @click="dismissUpgradeProposal">
                                                {{ upgradeProposal.secondaryLabel || 'Continua così' }}
                                            </button>
                                        </div>
                                    </div>
                                    <div style="margin-top: 20px;" v-if="selectedProduct?.metadata?.freeTrial == true && selectedProduct?.type !== 'REGISTRATION'"
                                        @click="toggleFreeTrialMode"
                                        :class="['duration-option', { selected: freeTrial }]">
                                        <div class="duration-title">Prova Gratuita</div>
                                        <div class="duration-price">0€</div>
                                        <div v-if="freeTrial" class="checkmark">&#10004;</div>
                                    </div>
                                    <div class="checkbox-container"
                                        v-if="(selectedProduct?.metadata?.stopngo == true) && (!freeTrial) && (selectedProduct?.type !== 'REGISTRATION')">
                                        <input type="checkbox" id="stopAndGo" class="custom-checkbox"
                                            v-model="requiresStopAndGo"
                                            @change="onStopAndGoChange($event.target.checked)" />
                                        <div class="text-container">
                                            <label for="stopAndGo" class="custom-label">STOP & GO</label>
                                            <p class="custom-description">Il servizio Stop & Go consente di sospendere
                                                temporaneamente il tuo abbonamento.</p>
                                        </div>
                                    </div>
                                    <!-- Data di inizio abbonamento -->
                                    <div class="start-date-container"
                                        v-if="allowStartDate && (!freeTrial) && (selectedProduct?.type !== 'REGISTRATION') && !isGiftMode"
                                        :class="{ 'has-selected-date': customStartDate !== null }">
                                        <div class="start-date-header">
                                            <h3 class="start-date-title">Vuoi scegliere la data di inizio?</h3>
                                            <p class="start-date-description">Puoi scegliere quando far partire il tuo abbonamento</p>
                                        </div>
                                        <div class="start-date-selector">
                                            <div class="start-date-picker-wrapper">
                                                <Datepicker 
                                                    v-model="customStartDateObject"
                                                    :format="format"
                                                    :placeholder="customStartDate === null ? 'Subito' : formatStartDate(customStartDate)"
                                                    :enable-time-picker="false"
                                                    :auto-apply="true"
                                                    :teleport="true"
                                                    :min-date="minStartDateObject"
                                                    input-class-name="start-date-picker-input"
                                                    :preview-format="previewFormat"
                                                    :clearable="true"
                                                    @update:model-value="onStartDateChange">
                                                    <template #action-select>
                                                        <span class="action-select">Seleziona</span>
                                                    </template>
                                                </Datepicker>
                                            </div>
                                        </div>
                                    </div>
                                    <label style="padding-top:20px;" v-if="productIsPersonal || productIsTarget"
                                        for="personalTrainerSelect" class="form-label  mt-2">Seleziona un
                                        Trainer</label>
                                    <select v-if="productIsPersonal" id="personalTrainerSelect"
                                        v-model="selectedPersonalTrainerId"
                                        @change="() => updatePricesByTrainerInfo(selectedPersonalTrainerId)"
                                        class="form-select custom-select"
                                        :class="[{ 'form-select-selected': selectedPersonalTrainerId }]">
                                        <option v-for="trainer in trainersForCheckout" :key="trainer.id || trainer.trainerId" :value="trainer.id || trainer.trainerId">
                                            {{ formatTrainerOptionForPersonalStandalone(trainer) }}
                                        </option>
                                    </select>

                                    <select v-if="productIsTarget" id="targetTrainerSelect"
                                        v-model="selectedTargetTrainerId"
                                        @change="() => updatePricesByTrainerInfo(selectedTargetTrainerId)"
                                        class="form-select custom-select"
                                        :class="[{ 'form-select-selected': selectedTargetTrainerId }]">
                                        <option v-for="trainer in trainersForCheckout" :key="trainer.id || trainer.trainerId" :value="trainer.id || trainer.trainerId">
                                            {{ formatTrainerOption(trainer, 'target') }}
                                        </option>
                                    </select>

                                    <!-- Gift Card fields -->
                                    <div v-if="isGiftCard && (selectedVariationName || !showVariationStep)" class="mt-4">
                                        <div class="mb-3">
                                            <label for="giftCardRecipientEmail" class="form-label">
                                                Email del destinatario <span class="text-danger">*</span>
                                            </label>
                                            <input 
                                                type="email" 
                                                id="giftCardRecipientEmail"
                                                v-model="giftCardRecipientEmail"
                                                class="form-control"
                                                placeholder="esempio@email.com"
                                                required
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <label for="giftCardMessage" class="form-label">
                                                Messaggio (opzionale)
                                            </label>
                                            <textarea 
                                                id="giftCardMessage"
                                                v-model="giftCardMessage"
                                                class="form-control"
                                                rows="3"
                                                placeholder="Scrivi un messaggio personalizzato per il destinatario..."
                                            ></textarea>
                                        </div>
                                    </div>

                                    <!-- Separatore sottile prima degli upsell -->
                                    <div v-if="(selectedVariationName || !showVariationStep)" class="divider-dots" aria-hidden="true">···</div>
                                    <!-- Upsell (spostati dallo storico pannello di destra) -->
                                    <div v-if="(selectedVariationName || !showVariationStep) && (selectedProduct?.type !== 'REGISTRATION') && !isGiftCard" class="mt-4">
                                        <h4 class="fw-bold mb-3">
                                            Acquista insieme
                                            <small v-if="requiresMandatoryUpsell" class="text-warning" style="font-weight: normal;">
                                                (include elementi obbligatori)
                                            </small>
                                        </h4>
                                        <!-- Mandatory Service if present -->
                                        <div v-if="requiresMandatoryUpsell && mandatoryProduct != null"
                                            class="row justify-content-between mb-4 upsell-box mandatory-upsell-box">
                                            <div class="col-10">
                                                <!-- Opzione A: abbonamento al servizio padre -->
                                                <div class="upsell-checkbox-container">
                                                    <input type="checkbox" id="upsell-mandatory" class="custom-checkbox"
                                                        :checked="mandatoryChoice === 'subscription'"
                                                        :disabled="!mandatoryEntryPackProduct"
                                                        @change="setMandatoryChoice('subscription', $event)" />
                                                    <div class="text-container">
                                                        <label for="upsell-mandatory" class="custom-label ">{{ mandatoryProduct.name
                                                            }}</label>
                                                        <p class="custom-description d-none d-sm-block">
                                                            {{ mandatoryEntryPackProduct
                                                                ? 'Obbligatorio per il piano scelto: scegli l\'abbonamento oppure il pacchetto di ingressi.'
                                                                : 'Questo servizio è obbligatorio per il piano scelto.' }}</p>
                                                        <label
                                                            v-if="mandatoryChoice === 'subscription' && this.mandatoryProduct.variations && this.mandatoryProduct.variations.length > 0"
                                                            for="variationSelect" class="form-label  mt-2">Seleziona una
                                                            variazione</label>
                                                        <select
                                                            v-if="mandatoryChoice === 'subscription' && this.mandatoryProduct.variations && this.mandatoryProduct.variations.length > 0"
                                                            id="variationSelect" v-model="selectedMandatoryVariation"
                                                            class="form-select custom-select">
                                                            <option
                                                                v-for="variation in this.mandatoryProduct.variations.filter(v => v.active === true)"
                                                                :key="variation.variationName" :value="variation">
                                                                {{ variation.variationName }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <!-- Opzione B: Pacchetto Ingressi (Dipendenza ingressi) -->
                                                <div v-if="mandatoryEntryPackProduct" class="upsell-checkbox-container mt-3">
                                                    <input type="checkbox" id="upsell-mandatory-entries" class="custom-checkbox"
                                                        :checked="mandatoryChoice === 'entries'"
                                                        @change="setMandatoryChoice('entries', $event)" />
                                                    <div class="text-container">
                                                        <label for="upsell-mandatory-entries" class="custom-label ">{{
                                                            mandatoryEntryPackProduct.name }}</label>
                                                        <p class="custom-description d-none d-sm-block">In alternativa
                                                            all'abbonamento: un pacchetto di ingressi da usare quando vuoi.</p>
                                                        <label
                                                            v-if="mandatoryChoice === 'entries' && this.mandatoryEntryPackProduct.variations && this.mandatoryEntryPackProduct.variations.length > 0"
                                                            for="entryPackVariationSelect" class="form-label  mt-2">Seleziona una
                                                            variazione</label>
                                                        <select
                                                            v-if="mandatoryChoice === 'entries' && this.mandatoryEntryPackProduct.variations && this.mandatoryEntryPackProduct.variations.length > 0"
                                                            id="entryPackVariationSelect" v-model="selectedMandatoryVariation"
                                                            class="form-select custom-select">
                                                            <option
                                                                v-for="variation in this.mandatoryEntryPackProduct.variations.filter(v => v.active === true)"
                                                                :key="variation.variationName" :value="variation">
                                                                {{ variation.variationName }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="selectedMandatoryVariation"
                                                class="col-2 d-flex align-items-center justify-content-end">
                                                <span class="highlight">
                                                    {{ selectedMandatoryVariation?.price }}€
                                                </span>
                                            </div>
                                        </div>

                                        <!-- BIA Upsell -->
                                        <div v-if="biaUpsellEnabled" class="row justify-content-between mb-4 upsell-box">
                                            <div class="col-10">
                                                <div class="upsell-checkbox-container">
                                                    <input type="checkbox" id="upsell-bia" class="custom-checkbox"
                                                        v-model="requiresBIA" @change="onBIAUpsell($event.target.checked)" />
                                                    <div class="text-container">
                                                        <label for="upsell-bia" class="custom-label ">BIA</label>
                                                        <p class="custom-description d-none d-sm-block">Il servizio BIA ti permette
                                                            di monitorare e
                                                            analizzare la composizione corporea in modo rapido e preciso.</p>
                                                        <label v-if="requiresBIA" for="biaTrainerSelect"
                                                            class="form-label  mt-2">Seleziona un
                                                            Trainer</label>
                                                        <select v-if="requiresBIA" id="biaTrainerSelect" v-model="selectedBIATrainerId"
                                                            class="form-select custom-select"
                                                            @change="() => updatePricesByTrainerInfo(selectedBIATrainerId)">
                                                            <option v-for="trainer in trainersForCheckout" :key="trainer.id || trainer.trainerId"
                                                                :value="trainer.id || trainer.trainerId">
                                                                {{ formatTrainerOption(trainer, 'bia') }}
                                                            </option>
                                                        </select>
                                                        <BiaPackPicker v-if="requiresBIA" v-model="selectedBiaPackName" :packs="biaPacks"
                                                            :single-price="biaProduct?.price || 0" />
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-2 d-flex align-items-center justify-content-end">
                                                <span class="highlight">
                                                    {{ biaBasePriceValue.toFixed(2) }}€
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Target Upsell -->
                                        <div v-if="targetUpsellEnabled" class="row justify-content-between mb-4 upsell-box"
                                            :class="{ 'upsell-box-free': isFreeTargetUpsell }">
                                            <div class="col-10">
                                                <div class="upsell-checkbox-container">
                                                    <input type="checkbox" id="upsell-target" class="custom-checkbox"
                                                        v-model="requiresTarget" @change="onTargetUpsell($event.target.checked)"
                                                        :disabled="isFreeTargetUpsell" />
                                                    <div class="text-container">
                                                        <label for="upsell-target" class="custom-label ">Target Training</label>
                                                        <p class="custom-description d-none d-sm-block">Allenamento guidato su
                                                            scheda personalizzata, studiato per obiettivi specifici di forza e
                                                            resistenza.</p>
                                                        <p v-if="isFreeTargetUpsell" class="form-text text-success mb-0 mt-1">
                                                            Incluso gratuitamente per questo centro. Sceglierai il trainer nell'app.
                                                        </p>
                                                        <label v-if="requiresTarget && !isFreeTargetUpsell" for="targetTrainerSelectUpsell"
                                                            class="form-label  mt-2">Seleziona un
                                                            Trainer</label>
                                                        <select v-if="requiresTarget && !isFreeTargetUpsell" id="targetTrainerSelectUpsell"
                                                            v-model="selectedTargetTrainerId" class="form-select custom-select"
                                                            @change="() => updatePricesByTrainerInfo(selectedTargetTrainerId)">
                                                            <option v-for="trainer in trainersForCheckout" :key="trainer.id || trainer.trainerId"
                                                                :value="trainer.id || trainer.trainerId">
                                                                {{ formatTrainerOption(trainer, 'target') }}
                                                            </option>
                                                        </select>
                                                        <TargetPackPicker v-if="requiresTarget && !isFreeTargetUpsell && selectedTargetTrainerId"
                                                            v-model="selectedTargetPackCode" :packs="targetPacks"
                                                            :single-price="targetProduct?.price || 0" />
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-2 d-flex align-items-center justify-content-end">
                                                <span class="highlight">
                                                    {{ isFreeTargetUpsell ? '0,00' : (targetBasePriceValue.toFixed(2)) }}€
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Elite Personal (PERSONAL_TRAINING) upsell -->
                                        <div v-if="personalUpsellEnabled" class="row justify-content-between mb-4 upsell-box">
                                            <div class="col-10">
                                                <div class="upsell-checkbox-container">
                                                    <input type="checkbox" id="upsell-personal" class="custom-checkbox"
                                                        v-model="requiresPersonal" @change="onPersonalUpsell($event.target.checked)" />
                                                    <div class="text-container">
                                                        <label for="upsell-personal" class="custom-label ">Elite Personal</label>
                                                        <p class="custom-description d-none d-sm-block">Pacchetto ingressi con personal trainer dedicato.</p>
                                                        <label v-if="requiresPersonal && personalProduct?.variations?.length > 1"
                                                            for="personalUpsellVariationSelect" class="form-label mt-2">Scegli il pacchetto</label>
                                                        <select v-if="requiresPersonal && personalProduct?.variations?.length > 1"
                                                            id="personalUpsellVariationSelect"
                                                            v-model="selectedPersonalUpsellVariationName"
                                                            class="form-select custom-select"
                                                            @change="onPersonalUpsellVariationChange">
                                                            <option v-for="variation in personalProduct.variations.filter(v => v.active !== false)"
                                                                :key="variation.variationName" :value="variation.variationName">
                                                                {{ variation.variationName }}
                                                            </option>
                                                        </select>
                                                        <label v-if="requiresPersonal" for="personalTrainerSelectUpsell"
                                                            class="form-label mt-2">Seleziona un Trainer</label>
                                                        <select v-if="requiresPersonal" id="personalTrainerSelectUpsell"
                                                            v-model="selectedPersonalUpsellTrainerId" class="form-select custom-select"
                                                            @change="() => updatePricesByTrainerInfo(selectedPersonalUpsellTrainerId)">
                                                            <option v-for="trainer in trainersForCheckout" :key="trainer.id || trainer.trainerId"
                                                                :value="trainer.id || trainer.trainerId">
                                                                {{ formatTrainerOptionForPersonalUpsell(trainer) }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-2 d-flex align-items-center justify-content-end">
                                                <span class="highlight">
                                                    {{ personalDisplayPrice?.toFixed(2) }}€
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Precision Training upsell -->
                                        <div v-if="precisionUpsellEnabled" class="row justify-content-between mb-4 upsell-box">
                                            <div class="col-10">
                                                <div class="upsell-checkbox-container">
                                                    <input type="checkbox" id="upsell-precision" class="custom-checkbox"
                                                        v-model="requiresPrecision" @change="onPrecisionUpsell($event.target.checked)" />
                                                    <div class="text-container">
                                                        <label for="upsell-precision" class="custom-label ">Precision Training</label>
                                                        <p class="custom-description d-none d-sm-block">Allenati meglio con valutazione
                                                            completa, test, periodizzazione e programma costruito su misura.</p>
                                                        <label v-if="requiresPrecision" for="precisionTrainerSelectUpsell"
                                                            class="form-label mt-2">Seleziona un Trainer</label>
                                                        <select v-if="requiresPrecision" id="precisionTrainerSelectUpsell"
                                                            v-model="selectedPrecisionUpsellTrainerId" class="form-select custom-select"
                                                            @change="() => updatePricesByTrainerInfo(selectedPrecisionUpsellTrainerId)">
                                                            <option v-for="trainer in trainersForCheckout" :key="trainer.id || trainer.trainerId"
                                                                :value="trainer.id || trainer.trainerId">
                                                                {{ formatTrainerOption(trainer, 'precision') }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-2 d-flex align-items-center justify-content-end">
                                                <span class="highlight">
                                                    {{ precisionProduct?.price?.toFixed(2) ?? '0,00' }}€
                                                </span>
                                            </div>
                                        </div>
                                    </div>



                                    <div v-if="!(freeTrial && userLogged)" class="text-center">
                                        <button @click="nextStep" class="btn btn-custom mt-4">Avanti</button>
                                    </div>
                                </div>
                            </transition>
                        </div>

                        <!-- Step 2 -->
                        <div v-if="!userLogged" class="step" :class="{ active: step === 2 }" id="step-2">
                            <h2 class="co-step-title" v-if="step === 2">I tuoi dati</h2>
                            <transition name="fade">
                                <div v-if="step === 2" class="step-content">
                                    <!-- Scelta rapida: Accedi (rosso) o Registrati (stile bianco esistente) -->
                                    <div class="auth-choice d-flex gap-2 mb-3">
                                        <div class="flex-fill">
                                            <router-link
                                                :to="getLoginLink()">
                                                <button type="button" class="btn btn-danger auth-btn w-100"
                                                    :class="{ 'is-muted': showRegistrationForm }">Accedi</button>
                                            </router-link>
                                        </div>
                                        <div class="flex-fill" v-if="selectedProduct?.type !== 'REGISTRATION'">
                                            <!-- Al totem la registrazione si fa dal telefono: il form anagrafico
                                                 non è compilabile su un touch screen non presidiato. -->
                                            <button
                                                v-if="isKiosk"
                                                type="button"
                                                class="btn white-container auth-btn w-100"
                                                @click="startKioskRegistration">
                                                Registrati dal telefono
                                            </button>
                                            <button
                                                v-else
                                                type="button"
                                                class="btn white-container auth-btn w-100"
                                                :class="{ 'is-current': showRegistrationForm }"
                                                @click="showRegistrationForm = true">
                                                Registrati
                                            </button>
                                        </div>
                                    </div>

                                    <QuickSignupForm v-if="quickCheckoutActive && showRegistrationForm"
                                        @signed-up="onQuickSignedUp" @unavailable="quickCheckoutUnavailable = true" />

                                    <form v-if="!quickCheckoutActive && !isKiosk && showRegistrationForm && selectedProduct?.type !== 'REGISTRATION'" @submit.prevent="nextStep" class="registration-form">

                                        <div class="d-flex justify-content-between align-items-center mb-1 mt-3">
                                            <h4>
                                                <b>1.</b> Informazioni Personali
                                            </h4>
                                        </div>

                                        <div>
                                            <div class="form-group">
                                                <input v-model="user.firstName" name="firstName" type="text"
                                                    placeholder="Nome *" class="form-control" required @input="onFirstNameChange" />
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.lastName" name="lastName" type="text"
                                                    placeholder="Cognome *" class="form-control" required @input="onLastNameChange" />
                                            </div>
                                            <div class="form-group" style="margin-bottom: 15px;">
                                                <Datepicker name="dateOfBirth" v-model="user.dateOfBirth"
                                                    :format="format" :placeholder="'Data di nascita *'"
                                                    :enable-time-picker="false" :auto-apply="true" :teleport="true"
                                                    input-class-name="form-control" :preview-format="previewFormat"
                                                    @update:model-value="updateDateOfBirth">
                                                    <template #action-select>
                                                        <span class="action-select">Seleziona</span>
                                                    </template>
                                                </Datepicker>
                                            </div>
                                            <div class="form-group">
                                                <GenderSelect v-model="user.gender" @update:model-value="onGenderChange"></GenderSelect>
                                            </div>
                                            <div class="form-group position-relative">
                                                <div class="country-dropdown-container" ref="countryContainer" @click.stop="toggleCountryDropdown">
                                                    <input 
                                                        :value="selectedCountryName"
                                                        type="text" 
                                                        placeholder="Nazione *"
                                                        class="form-control" 
                                                        required 
                                                        readonly
                                                        @click.stop="toggleCountryDropdown"
                                                        @focus.prevent
                                                        ref="countryInput"
                                                    />
                                                    <i class="fa fa-chevron-down country-dropdown-icon" :class="{ 'open': showCountryDropdown }" @click.stop="toggleCountryDropdown"></i>
                                                </div>
                                                <!-- Dropdown nazione con ricerca -->
                                                <div v-if="showCountryDropdown" 
                                                     class="country-dropdown-search"
                                                     ref="countryDropdown"
                                                     @mousedown.prevent
                                                     @click.stop>
                                                    <input 
                                                        type="text"
                                                        v-model="countrySearchQuery"
                                                        placeholder="Cerca nazione..."
                                                        class="form-control country-search-input"
                                                        @input="filterCountries"
                                                        @keydown.esc="closeCountryDropdown"
                                                        @click.stop
                                                        ref="countrySearchInput"
                                                    />
                                                    <div class="country-dropdown-list">
                                                        <div v-if="filteredCountries.length === 0 && !isLoadingCountries" class="no-results">
                                                            Nessun risultato trovato
                                                        </div>
                                                        <div v-if="isLoadingCountries" class="no-results">
                                                            <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                        </div>
                                                    <div v-for="country in filteredCountries" 
                                                         :key="country.code"
                                                         class="country-dropdown-item"
                                                         :class="{ 'selected': user.country === country.name }"
                                                         @mousedown.prevent="selectCountry(country, $event)"
                                                         @click.stop="selectCountry(country, $event)">
                                                        {{ country.name }}
                                                    </div>
                                                    </div>
                                                </div>
                                                <!-- Loading indicator -->
                                                <div v-if="isLoadingCountries && !showCountryDropdown" class="country-loading">
                                                    <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                </div>
                                            </div>
                                            <div class="form-group position-relative">
                                                <input 
                                                    v-model="user.placeOfBirth" 
                                                    name="placeOfBirth" 
                                                    type="text"
                                                    placeholder="Luogo di nascita (opzionale)" 
                                                    class="form-control"
                                                    @input="onPlaceOfBirthInput"
                                                    @focus="onPlaceOfBirthFocus"
                                                    @blur="onPlaceOfBirthBlur"
                                                    ref="placeOfBirthInput"
                                                />
                                                <!-- Dropdown suggerimenti luogo di nascita -->
                                                <div v-if="showPlaceOfBirthSuggestions && placeOfBirthSuggestions.length > 0" 
                                                     class="place-of-birth-suggestions-dropdown">
                                                    <div v-for="(suggestion, index) in placeOfBirthSuggestions" 
                                                         :key="index"
                                                         class="suggestion-item"
                                                         @mousedown="selectPlaceOfBirth(suggestion)"
                                                         @click="selectPlaceOfBirth(suggestion)">
                                                        {{ suggestion.nome }}
                                                    </div>
                                                </div>
                                                <!-- Loading indicator -->
                                                <div v-if="isLoadingPlaceOfBirth" class="place-of-birth-loading">
                                                    <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                </div>
                                            </div>
                                            <div class="form-group position-relative">
                                                <input 
                                                    v-model="user.taxCode" 
                                                    name="taxCode" 
                                                    type="text"
                                                    placeholder="Codice Fiscale *" 
                                                    class="form-control"
                                                    :class="{ 'is-invalid': taxCodeError }"
                                                    required 
                                                    @input="onTaxCodeInput"
                                                    @blur="onTaxCodeBlur"
                                                    style="text-transform: uppercase;"
                                                />
                                                <span v-if="taxCodeError" class="text-danger small d-block mt-1">
                                                    <i class="fa fa-exclamation-circle"></i> {{ taxCodeError }}
                                                </span>
                                                <span v-else-if="user.taxCode && isItaly && user.taxCode.length === 16 && !taxCodeError" class="text-success small d-block mt-1">
                                                    <i class="fa fa-check-circle"></i> Codice fiscale valido
                                                </span>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-1 mt-3">
                                            <h4><b>2.</b> Recapiti</h4>
                                        </div>
                                        <div>
                                            <div class="form-group position-relative">
                                                <input v-model="user.address" type="text"
                                                    placeholder="Indirizzo (opzionale)" class="form-control" />
                                            </div>
                                            <div class="form-group position-relative">
                                                <input 
                                                    v-model="user.city" 
                                                    type="text" 
                                                    placeholder="Città *"
                                                    class="form-control" 
                                                    required 
                                                    @input="onCityInput"
                                                    @focus="onCityFocus"
                                                    @blur="onCityBlur"
                                                    ref="cityInput"
                                                />
                                                <!-- Dropdown suggerimenti città ISTAT -->
                                                <div v-if="showCitySuggestions && citySuggestions.length > 0" 
                                                     class="city-suggestions-dropdown">
                                                    <div v-for="(suggestion, index) in citySuggestions" 
                                                         :key="index"
                                                         class="suggestion-item"
                                                         @mousedown="selectCity(suggestion)"
                                                         @click="selectCity(suggestion)">
                                                        {{ suggestion.nome }}
                                                    </div>
                                                </div>
                                                <!-- Loading indicator -->
                                                <div v-if="isLoadingCities" class="city-loading">
                                                    <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                </div>
                                            </div>
                                            <div class="form-group position-relative">
                                                <input 
                                                    v-model="user.postalCode" 
                                                    type="text" 
                                                    placeholder="CAP *"
                                                    class="form-control" 
                                                    required 
                                                    @input="onPostalCodeInput"
                                                    @focus="onPostalCodeFocus"
                                                    @blur="onPostalCodeBlur"
                                                    ref="postalCodeInput"
                                                />
                                                <!-- Dropdown suggerimenti CAP -->
                                                <div v-if="showPostalCodeSuggestions && postalCodeSuggestions.length > 0" 
                                                     class="postal-code-suggestions-dropdown">
                                                    <div v-for="(suggestion, index) in postalCodeSuggestions" 
                                                         :key="index"
                                                         class="suggestion-item"
                                                         @mousedown="selectPostalCode(suggestion)"
                                                         @click="selectPostalCode(suggestion)">
                                                        {{ suggestion.codice }}
                                                    </div>
                                                </div>
                                                <!-- Loading indicator -->
                                                <div v-if="isLoadingPostalCodes" class="postal-code-loading">
                                                    <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                </div>
                                            </div>
                                            <div class="form-group position-relative">
                                                <input 
                                                    v-model="user.province" 
                                                    type="text" 
                                                    placeholder="Provincia *"
                                                    class="form-control" 
                                                    required 
                                                    @input="onProvinceInput"
                                                    @focus="onProvinceFocus"
                                                    @blur="onProvinceBlur"
                                                    ref="provinceInput"
                                                />
                                                <!-- Dropdown suggerimenti provincia -->
                                                <div v-if="showProvinceSuggestions && provinceSuggestions.length > 0" 
                                                     class="province-suggestions-dropdown">
                                                    <div v-for="(suggestion, index) in provinceSuggestions" 
                                                         :key="index"
                                                         class="suggestion-item"
                                                         @mousedown="selectProvince(suggestion)"
                                                         @click="selectProvince(suggestion)">
                                                        {{ suggestion.nome }}
                                                    </div>
                                                </div>
                                                <!-- Loading indicator -->
                                                <div v-if="isLoadingProvinces" class="province-loading">
                                                    <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.phoneNumber" type="text" placeholder="Telefono *"
                                                    class="form-control" required />
                                            </div>
                                        </div>
                                        <!-- Sezione Tutore legale: visibile solo se minorenne -->
                                        <div v-if="isMinor" class="d-flex justify-content-between align-items-center mb-1 mt-3">
                                            <h4><b>3.</b> Tutore legale</h4>
                                        </div>
                                        <div v-if="isMinor">
                                            <div class="form-group">
                                                <input v-model="user.legalGuardian.firstName" type="text" placeholder="Nome tutore *" class="form-control" :required="isMinor" />
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.legalGuardian.lastName" type="text" placeholder="Cognome tutore *" class="form-control" :required="isMinor" />
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.legalGuardian.taxCode" type="text" placeholder="Codice fiscale tutore *" class="form-control" :required="isMinor" />
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.legalGuardian.relationship" type="text" placeholder="Relazione con il minore (es. Genitore) *" class="form-control" :required="isMinor" />
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.legalGuardian.email" type="email" placeholder="Email tutore *" class="form-control" :required="isMinor" />
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.legalGuardian.phoneNumber" type="text" placeholder="Telefono tutore *" class="form-control" :required="isMinor" />
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.legalGuardian.address" type="text" placeholder="Indirizzo (opzionale)" class="form-control" />
                                            </div>
                                            <div class="form-group position-relative">
                                                <input 
                                                    v-model="user.legalGuardian.city" 
                                                    type="text" 
                                                    placeholder="Città (opzionale)" 
                                                    class="form-control"
                                                    @input="onLegalGuardianCityInput"
                                                    @focus="onLegalGuardianCityFocus"
                                                    @blur="onLegalGuardianCityBlur"
                                                    ref="legalGuardianCityInput"
                                                />
                                                <!-- Dropdown suggerimenti città tutore -->
                                                <div v-if="showLegalGuardianCitySuggestions && legalGuardianCitySuggestions.length > 0" 
                                                     class="legal-guardian-city-suggestions-dropdown">
                                                    <div v-for="(suggestion, index) in legalGuardianCitySuggestions" 
                                                         :key="index"
                                                         class="suggestion-item"
                                                         @mousedown="selectLegalGuardianCity(suggestion)"
                                                         @click="selectLegalGuardianCity(suggestion)">
                                                        {{ suggestion.nome }}
                                                    </div>
                                                </div>
                                                <!-- Loading indicator -->
                                                <div v-if="isLoadingLegalGuardianCities" class="legal-guardian-city-loading">
                                                    <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                </div>
                                            </div>
                                            <div class="form-group position-relative">
                                                <input 
                                                    v-model="user.legalGuardian.postalCode" 
                                                    type="text" 
                                                    placeholder="CAP (opzionale)" 
                                                    class="form-control"
                                                    @input="onLegalGuardianPostalCodeInput"
                                                    @focus="onLegalGuardianPostalCodeFocus"
                                                    @blur="onLegalGuardianPostalCodeBlur"
                                                    ref="legalGuardianPostalCodeInput"
                                                />
                                                <!-- Dropdown suggerimenti CAP tutore -->
                                                <div v-if="showLegalGuardianPostalCodeSuggestions && legalGuardianPostalCodeSuggestions.length > 0" 
                                                     class="legal-guardian-postal-code-suggestions-dropdown">
                                                    <div v-for="(suggestion, index) in legalGuardianPostalCodeSuggestions" 
                                                         :key="index"
                                                         class="suggestion-item"
                                                         @mousedown="selectLegalGuardianPostalCode(suggestion)"
                                                         @click="selectLegalGuardianPostalCode(suggestion)">
                                                        {{ suggestion.codice }}
                                                    </div>
                                                </div>
                                                <!-- Loading indicator -->
                                                <div v-if="isLoadingLegalGuardianPostalCodes" class="legal-guardian-postal-code-loading">
                                                    <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                </div>
                                            </div>
                                            <div class="form-group position-relative">
                                                <input 
                                                    v-model="user.legalGuardian.province" 
                                                    type="text" 
                                                    placeholder="Provincia (opzionale)" 
                                                    class="form-control"
                                                    @input="onLegalGuardianProvinceInput"
                                                    @focus="onLegalGuardianProvinceFocus"
                                                    @blur="onLegalGuardianProvinceBlur"
                                                    ref="legalGuardianProvinceInput"
                                                />
                                                <!-- Dropdown suggerimenti provincia tutore -->
                                                <div v-if="showLegalGuardianProvinceSuggestions && legalGuardianProvinceSuggestions.length > 0" 
                                                     class="legal-guardian-province-suggestions-dropdown">
                                                    <div v-for="(suggestion, index) in legalGuardianProvinceSuggestions" 
                                                         :key="index"
                                                         class="suggestion-item"
                                                         @mousedown="selectLegalGuardianProvince(suggestion)"
                                                         @click="selectLegalGuardianProvince(suggestion)">
                                                        {{ suggestion.nome }}
                                                    </div>
                                                </div>
                                                <!-- Loading indicator -->
                                                <div v-if="isLoadingLegalGuardianProvinces" class="legal-guardian-province-loading">
                                                    <i class="fa fa-spinner fa-spin"></i> Caricamento...
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.legalGuardian.country" type="text" placeholder="Nazione (opzionale)" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-1 mt-3">
                                            <h4><b>{{ isMinor ? '4.' : '3.' }}</b> Crea un account</h4>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <input v-model="user.email" type="email" placeholder="Email *"
                                                    class="form-control" @blur="checkEmailExists"
                                                    :class="{ 'is-invalid': emailError }" required />
                                                <span v-if="emailError" class="text-danger">{{ emailError }}</span>
                                            </div>
                                            <div class="form-group">
                                                <input v-model="user.password"
                                                    :type="showPassword ? 'text' : 'password'" placeholder="Password *"
                                                    class="form-control" @blur="checkPassword"
                                                    :class="{ 'is-invalid': passwordError }" required />
                                                <button type="button" class="toggle-password"
                                                    @click="togglePasswordVisibility">
                                                    {{ showPassword ? 'Nascondi' : 'Mostra' }}
                                                </button>
                                            </div>
                                            <span v-if="passwordError" class="text-danger">{{ passwordError
                                                }}</span>

                                            <button type="button" class="terms-select-all terms-select-all--light"
                                                @click="toggleAllTermsSignup">
                                                <span class="terms-select-all-box" :class="{ 'is-on': hasAcceptedTermsSignup }">
                                                    <svg viewBox="0 0 24 24" aria-hidden="true"><use href="#co-check" /></svg>
                                                </span>
                                                {{ hasAcceptedTermsSignup ? 'Deseleziona tutti' : 'Seleziona tutti' }}
                                            </button>

                                            <div class="terms-section" id="terms-section">
                                                <!-- 1. Termini e condizioni -->
                                                <div class="terms-checkbox">
                                                    <input type="checkbox" id="terms" class="custom-checkbox terms-cb"
                                                        v-model="acceptTermsSignup" />
                                                    <div class="text-container">
                                                        <label for="terms" class="terms-label">
                                                            Confermo di aver preso visione ed accetto i
                                                            <a href="https://elitefitness.it/terms/"
                                                                target="_blank">Termini
                                                                e condizioni</a>
                                                        </label>
                                                    </div>
                                                </div>

                                                <!-- 2. Informativa privacy -->
                                                <div class="terms-checkbox">
                                                    <input type="checkbox" id="privacy" class="custom-checkbox terms-cb"
                                                        v-model="acceptPrivacyPolicySignup" />
                                                    <div class="text-container">
                                                        <label for="privacy" class="terms-label">
                                                            Confermo di aver preso visione dell'
                                                            <a href="https://elitefitness.it/privacy/"
                                                                target="_blank">Informativa Privacy</a>
                                                            ai sensi del Regolamento (UE) 2016/679 (GDPR)
                                                        </label>
                                                    </div>
                                                </div>

                                                <!-- 3. Regolamento -->
                                                <div class="terms-checkbox">
                                                    <input type="checkbox" id="regulationSignup" class="custom-checkbox terms-cb"
                                                        v-model="acceptRegulationSignup" />
                                                    <div class="text-container">
                                                        <label for="regulationSignup" class="terms-label">
                                                            Confermo di aver preso visione ed accetto il
                                                            <a href="https://elitefitness.it/regulation/"
                                                                target="_blank">Regolamento Interno di Elite
                                                                Fitness SSD</a>
                                                        </label>
                                                    </div>
                                                </div>

                                                <!-- 4. Codice etico -->
                                                <div class="terms-checkbox">
                                                    <input type="checkbox" id="medicalCert"
                                                        class="custom-checkbox terms-cb"
                                                        v-model="acceptMedicalCertDeclarationSignup" />
                                                    <div class="text-container">
                                                        <label for="medicalCert" class="terms-label">
                                                            Confermo di aver preso visione del
                                                            <a href="https://elitefitness.it/ethical-code/"
                                                                target="_blank">Codice Etico</a>
                                                        </label>
                                                    </div>
                                                </div>

                                                <!-- 5. Documenti di identità -->
                                                <div class="terms-checkbox">
                                                    <input type="checkbox" id="identityDocs"
                                                        class="custom-checkbox terms-cb"
                                                        v-model="acceptIdentityDocsDeclarationSignup" />
                                                    <div class="text-container">
                                                        <label for="identityDocs" class="terms-label">
                                                            Confermo di aver preso visione della
                                                            <a href="https://elitefitness.it/dichiarazione-documenti-di-identita/"
                                                                target="_blank">Dichiarazione
                                                                Relativa ai Documenti di
                                                                Identità</a>
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="text-center">
                                                <span v-if="!hasAcceptedTermsSignup" class="terms-warning">Per
                                                    proseguire,
                                                    devi
                                                    accettare i termini e le
                                                    condizioni.</span>
                                            </div>
                                        </div>

                                        <div class="text-center mt-4">
                                            <button type="submit" class="btn btn-custom"
                                                :disabled="isLoading || !hasAcceptedTermsSignup"
                                                :class="{ 'loading': isLoading }">
                                                <span v-if="!isLoading">Registrati</span>
                                                <span v-else>
                                                    <span class="loading-dots">
                                                        <span>.</span>
                                                        <span>.</span>
                                                        <span>.</span>
                                                    </span>
                                                </span>
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            </transition>
                        </div>

                        <!-- Step 3: Gift (solo se in modalità gift) -->
                        <div v-if="isGiftMode && !freeTrial" class="step" :class="{ active: step === 3 }" id="step-3-gift">
                            <h2 class="co-step-title" v-if="step === 3 && isGiftMode">Regalo</h2>
                            <transition name="fade">
                                <div v-if="step === 3 && isGiftMode" class="step-content">
                                    <div class="gift-section">
                                        <h3 class="mb-3">Vuoi inviare una notifica email al destinatario?</h3>
                                        <p class="mb-4">Puoi scegliere se inviare automaticamente una email al destinatario con il codice gift, oppure riceverlo tu e condividerlo manualmente.</p>
                                        
                                        <div class="gift-radio-container mb-4" :class="{ 'radio-selected': sendEmailToGiftRecipient === true }" @click="sendEmailToGiftRecipient = true">
                                            <input class="custom-radio" type="radio" name="sendEmailOption" 
                                                id="sendEmailYes" value="yes" 
                                                :checked="sendEmailToGiftRecipient === true"
                                                @change="sendEmailToGiftRecipient = true">
                                            <label class="gift-radio-label" for="sendEmailYes">
                                                Sì, invia email al destinatario
                                            </label>
                                        </div>
                                        
                                        <div class="gift-radio-container mb-4" :class="{ 'radio-selected': sendEmailToGiftRecipient === false }" @click="sendEmailToGiftRecipient = false">
                                            <input class="custom-radio" type="radio" name="sendEmailOption" 
                                                id="sendEmailNo" value="no" 
                                                :checked="sendEmailToGiftRecipient === false"
                                                @change="sendEmailToGiftRecipient = false">
                                            <label class="gift-radio-label" for="sendEmailNo">
                                                No, ricevo io il codice e lo condivido manualmente
                                            </label>
                                        </div>

                                        <div v-if="sendEmailToGiftRecipient" class="gift-recipient-fields mt-4">
                                            <div class="mb-3">
                                                <label for="giftRecipientEmail" class="form-label">
                                                    Email del destinatario <span class="text-danger">*</span>
                                                </label>
                                                <input 
                                                    type="email" 
                                                    id="giftRecipientEmail"
                                                    v-model="giftRecipientEmail"
                                                    class="form-control"
                                                    placeholder="esempio@email.com"
                                                    required
                                                />
                                            </div>
                                            <div class="mb-3">
                                                <label for="giftMessage" class="form-label">
                                                    Messaggio personalizzato (opzionale)
                                                </label>
                                                <textarea 
                                                    id="giftMessage"
                                                    v-model="giftMessage"
                                                    class="form-control"
                                                    rows="3"
                                                    placeholder="Scrivi un messaggio personalizzato per il destinatario..."
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div class="mt-4">
                                            <button type="button" class="btn btn-custom" @click="goToNextStep">
                                                Continua
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>

                        <!-- Step 3/4: Pagamento -->
                        <div v-if="!freeTrial" class="step" :class="{ active: step === (isGiftMode ? 4 : 3) }" :id="isGiftMode ? 'step-4' : 'step-3'">
                            <h2 class="co-step-title" v-if="step === (isGiftMode ? 4 : 3)">Pagamento</h2>
                            <transition name="fade">
                                <div v-if="step === (isGiftMode ? 4 : 3)" class="step-content">
                                    
                                    <!-- ✅ AGGIUNTO: Messaggio se i termini non sono accettati -->
                                    <div v-if="!hasAcceptedTerms" class="terms-required-message">
                                        <div class="terms-icon">
                                            <i class="fa-solid fa-exclamation-circle"></i>
                                        </div>
                                        <h4>Accetta i termini per continuare</h4>
                                        <p>Per procedere con il pagamento, devi prima accettare tutti i termini e le condizioni.</p>
                                        <!-- RIMOSSA freccia rossa e istruzione mobile -->

                                        <button type="button" class="terms-select-all" @click="toggleAllTerms">
                                            <span class="terms-select-all-box" :class="{ 'is-on': hasAcceptedTerms }">
                                                <svg viewBox="0 0 24 24" aria-hidden="true"><use href="#co-check" /></svg>
                                            </span>
                                            {{ hasAcceptedTerms ? 'Deseleziona tutti' : 'Seleziona tutti' }}
                                        </button>

                                        <!-- ✅ Checkboxes Termini spostate qui -->
                                        <div class="terms-section mt-3" id="terms-section">
                                            <!-- 1. Termini e condizioni -->
                                            <div class="terms-checkbox">
                                                <input type="checkbox" id="terms" class="custom-checkbox terms-cb"
                                                    v-model="acceptTerms" />
                                                <div class="text-container">
                                                    <label for="terms" class="terms-label">
                                                        Confermo di aver preso visione ed accetto i
                                                        <a href="https://elitefitness.it/terms/" target="_blank">Termini e condizioni</a>
                                                    </label>
                                                </div>
                                            </div>

                                            <!-- 2. Informativa privacy -->
                                            <div class="terms-checkbox">
                                                <input type="checkbox" id="privacy" class="custom-checkbox terms-cb"
                                                    v-model="acceptPrivacyPolicy" />
                                                <div class="text-container">
                                                    <label for="privacy" class="terms-label">
                                                        Confermo di aver preso visione dell'
                                                        <a href="https://elitefitness.it/privacy/" target="_blank">Informativa Privacy</a>
                                                        ai sensi del Regolamento (UE) 2016/679 (GDPR)
                                                    </label>
                                                </div>
                                            </div>

                                            <!-- 3. Regolamento -->
                                            <div class="terms-checkbox">
                                                <input type="checkbox" id="regulation" class="custom-checkbox terms-cb"
                                                    v-model="acceptRegulation" />
                                                <div class="text-container">
                                                    <label for="regulation" class="terms-label">
                                                        Confermo di aver preso visione ed accetto il
                                                        <a href="https://elitefitness.it/regulation/" target="_blank">Regolamento
                                                            Interno di Elite Fitness SSD</a>
                                                    </label>
                                                </div>
                                            </div>

                                            <!-- 4. Codice etico -->
                                            <div class="terms-checkbox">
                                                <input type="checkbox" id="medicalCert" class="custom-checkbox terms-cb"
                                                    v-model="acceptMedicalCertDeclaration" />
                                                <div class="text-container">
                                                    <label for="medicalCert" class="terms-label">
                                                        Confermo di aver preso visione del
                                                        <a href="https://elitefitness.it/ethical-code/"
                                                            target="_blank">Codice Etico</a>
                                                    </label>
                                                </div>
                                            </div>

                                            <!-- 5. Documenti di identità -->
                                            <div class="terms-checkbox">
                                                <input type="checkbox" id="identityDocs" class="custom-checkbox terms-cb"
                                                    v-model="acceptIdentityDocsDeclaration" />
                                                <div class="text-container">
                                                    <label for="identityDocs" class="terms-label">
                                                        Confermo di aver preso visione della
                                                        <a href="https://elitefitness.it/dichiarazione-documenti-di-identita/"
                                                            target="_blank">Dichiarazione Relativa ai Documenti di Identità</a>
                                                    </label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <!-- ✅ MODIFICATO: Contenuto pagamenti visibile solo se termini accettati -->
                                    <div v-if="hasAcceptedTerms">
                                        <!-- Se l'ordine è gratuito, mostra solo il messaggio di completamento -->
                                        <div v-if="isFreeOrder" class="free-order-message">
                                            <div class="free-order-icon">
                                                <i class="fa-solid fa-check-circle"></i>
                                            </div>
                                            <h4>Completamento gratuito dell'ordine</h4>
                                            <p>Il tuo ordine è completamente gratuito grazie al codice sconto applicato. Clicca sul pulsante per completare l'ordine.</p>
                                        </div>

                                        <!-- Se l'ordine non è gratuito, mostra i metodi di pagamento -->
                                        <div v-else>
                                            <!-- Mobile-only discount code bar -->
                                            <div class="d-xl-none" v-if="(selectedVariationName || !showVariationStep) && !isGiftCard">
                                                <div v-if="userLogged" class="input-group co-discount-bar mb-3">
                                                    <input type="text" v-model="discountCode"
                                                           class="form-control discount custom-placeholder"
                                                           placeholder="INSERISCI IL CODICE SCONTO"
                                                           aria-label="Codice Sconto"
                                                           aria-describedby="button-addon2"
                                                           :disabled="!!promoCode || smartExcludesPromo">
                                                    <button v-if="!promoCode" class="btn btn-danger rounded-0" type="button"
                                                            :disabled="smartExcludesPromo"
                                                            @click="applyDiscount">APPLICA</button>
                                                    <button v-else class="btn btn-outline-danger rounded-0" type="button"
                                                            @click="removeDiscount">RIMUOVI</button>
                                                </div>
                                                <div v-if="userLogged && smartExcludesPromo" class="discount-exclusive-note mb-3" role="status">
                                                    <i class="fa-solid fa-circle-info"></i>
                                                    <span>{{ smartPromoNote }}</span>
                                                </div>
                                                <div v-else-if="discountCode?.length > 0 && !promoCode && !discountCodeFromUrl" class="alert alert-danger d-flex align-items-center" role="alert">
                                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                                    <span style="margin-left: 10px;">Per applicare un codice sconto, devi
                                                        <router-link :to="getLoginLink()">
                                                            <a style="color:white" href="#">effettuare l'accesso</a>
                                                        </router-link>
                                                    </span>
                                                </div>
                                            </div>

                                        <!-- Wallet Credit Section (visibile solo se saldo > 0) -->
                                        <div v-if="userLogged && !walletLoading && walletBalance > 0" class="wallet-credit-section">
                                            <div class="wallet-credit-box">
                                                <div class="wallet-credit-header">
                                                    <i class="fa-solid fa-wallet" style="margin-right: 8px; color: #4ade80;"></i>
                                                    <span>Credito Wallet disponibile</span>
                                                </div>
                                                <div class="wallet-credit-balance">
                                                    {{ walletBalance.toFixed(2) }}€
                                                </div>
                                                <div class="wallet-credit-checkbox">
                                                    <input 
                                                        type="checkbox" 
                                                        id="useWalletCredit" 
                                                        class="custom-checkbox" 
                                                        v-model="useWalletCredit"
                                                    />
                                                    <label for="useWalletCredit" class="wallet-credit-label">
                                                        Usa il credito Wallet per questo acquisto
                                                    </label>
                                                </div>
                                                <div v-if="useWalletCredit" class="wallet-credit-info">
                                                    <span v-if="walletCoversFullAmount">
                                                        Il tuo credito Wallet copre l'intero importo!
                                                    </span>
                                                    <span v-else>
                                                        Userai {{ walletAmountToUse.toFixed(2) }}€ dal Wallet. 
                                                        Rimangono {{ remainingAfterWallet.toFixed(2) }}€ da pagare.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Mostra metodi di pagamento solo se il wallet non copre tutto -->
                                        <div v-if="!walletCoversFullAmount || !useWalletCredit" class="payment-method-section">
                                            <h4 class="payment-section-title">Metodo di pagamento</h4>
                                            <div class="payment-grid">
                                                <div v-for="method in paymentMethods" :key="method.value"
                                                    @click="selectPaymentMethod(method)"
                                                    :class="['payment-option', { selected: selectedPayment === method.value }]">
                                                    <div class="payment-title">
                                                        <i v-if="method.icon" :class="['fa', method.iconType === 'brands' ? 'fa-brands' : 'fa-solid', method.icon]" style="margin-right: 8px; font-size: 1.2em;"></i>
                                                        <span>{{ method.label }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Messaggio per contanti -->
                                        <!--div class="payment-info" :class="[{ 'd-none': selectedPayment != 'CASH' }]">
                                            Disponibile dalle 17:00 alle 22:00
                                        </div-->

                                        <!-- Stripe Credit Card Payment (nascosto se wallet copre tutto) -->
                                            <div class="payment-card-section" :class="[{ 'd-none': selectedPayment != 'CARD' || (walletCoversFullAmount && useWalletCredit) }]">
                                                <h4 class="payment-section-title">Carta di credito</h4>
                                                <div id="card-element" class="form-control mb-3"></div>
                                                <!--div id="payment-element" class="form-control mb-3"></div-->
                                            </div>
                                            <!-- Bottone per Apple Pay e Google Pay (nascosto se wallet copre tutto) -->
                                            <div class="payment-request-section" :class="[{ 'd-none': selectedPayment != 'CARD' || (walletCoversFullAmount && useWalletCredit) }]" style="padding-top:20px;">
                                                <div id="payment-request-button-container"></div>
                                            </div>
                                            
                                            <!-- Pulsante PayPal (nascosto se wallet copre tutto) -->
                                            <div class="paypal-payment-section" :class="[{ 'd-none': selectedPayment != 'PAYPAL' || (walletCoversFullAmount && useWalletCredit) }]" style="padding-top:20px;">
                                                <button @click="avviaPayPalDalPulsante" class="paypal-button w-100" :disabled="!enablePaymentButton">
                                                    <img src="https://www.paypalobjects.com/webstatic/icon/pp258.png" alt="PayPal" />
                                                    Paga con PayPal
                                                </button>
                                                <div class="paypal-installment-info" style="margin-top: 12px; font-size: 0.875rem; color: #ffffff; text-align: center; line-height: 1.4; font-style: italic;">
                                                    {{ paypalInstallmentMessage }}
                                                </div>
                                            </div>
                                        </div>

                                            <!-- ✅ Pulsante Completa Pagamento/Ordine -->
                                        <div class="payment-submit-section text-center mt-4" :class="[{ 'd-none': selectedPayment === 'PAYPAL' && !(walletCoversFullAmount && useWalletCredit) }]">
                                            <button :disabled="!enablePaymentButton" @click="handlePayment"
                                                class="btn btn-custom complete-payment-btn text-nowrap">
                                                <span v-if="walletCoversFullAmount && useWalletCredit">
                                                    COMPLETA L'ORDINE CON WALLET
                                                </span>
                                                <span v-else-if="isFreeOrder">COMPLETA L'ORDINE</span>
                                                <span v-else-if="selectedPayment === 'CARD' || selectedPayment === 'CARD_KIOSK'">Paga con carta</span>
                                                <span v-else-if="selectedPayment === 'CASH'">Paga in reception</span>
                                                <span v-else-if="selectedPayment === 'CASH_KIOSK'">Paga in contanti</span>
                                                <span v-else>Scegli come pagare</span>
                                            </button>
                                            <span v-if="!hasAcceptedTerms" class="terms-warning">Per proseguire, devi
                                                <a href="#" @click="scrollToCheckboxes">accettare i termini e le condizioni</a>.</span>
                                        </div>
                                    </div> <!-- ✅ CHIUSURA del div hasAcceptedTerms -->
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>

                <!-- Mobile-only terms + CTA for Free Trial -->
                <div class="d-xl-none mt-4" v-if="freeTrial && selectedProduct?.type !== 'REGISTRATION'">
                    <button type="button" class="terms-select-all" @click="toggleAllTerms">
                        <span class="terms-select-all-box" :class="{ 'is-on': hasAcceptedTerms }">
                            <svg viewBox="0 0 24 24" aria-hidden="true"><use href="#co-check" /></svg>
                        </span>
                        {{ hasAcceptedTerms ? 'Deseleziona tutti' : 'Seleziona tutti' }}
                    </button>

                    <div class="terms-section mt-3" id="terms-section-free-trial-mobile">
                        <!-- 1. Termini e condizioni -->
                        <div class="terms-checkbox">
                            <input type="checkbox" id="terms-ft-mobile" class="custom-checkbox terms-cb" v-model="acceptTerms" />
                            <div class="text-container">
                                <label for="terms-ft-mobile" class="terms-label">
                                    Confermo di aver preso visione ed accetto i
                                    <a href="https://elitefitness.it/terms/" target="_blank">Termini e condizioni</a>
                                </label>
                            </div>
                        </div>

                        <!-- 2. Informativa privacy -->
                        <div class="terms-checkbox">
                            <input type="checkbox" id="privacy-ft-mobile" class="custom-checkbox terms-cb" v-model="acceptPrivacyPolicy" />
                            <div class="text-container">
                                <label for="privacy-ft-mobile" class="terms-label">
                                    Confermo di aver preso visione dell'
                                    <a href="https://elitefitness.it/privacy/" target="_blank">Informativa Privacy</a>
                                    ai sensi del Regolamento (UE) 2016/679 (GDPR)
                                </label>
                            </div>
                        </div>

                        <!-- 3. Regolamento -->
                        <div class="terms-checkbox">
                            <input type="checkbox" id="regulation-ft-mobile" class="custom-checkbox terms-cb" v-model="acceptRegulation" />
                            <div class="text-container">
                                <label for="regulation-ft-mobile" class="terms-label">
                                    Confermo di aver preso visione ed accetto il
                                    <a href="https://elitefitness.it/regulation/" target="_blank">Regolamento Interno di Elite Fitness SSD</a>
                                </label>
                            </div>
                        </div>

                        <!-- 4. Codice etico -->
                        <div class="terms-checkbox">
                            <input type="checkbox" id="medicalCert-ft-mobile" class="custom-checkbox terms-cb" v-model="acceptMedicalCertDeclaration" />
                            <div class="text-container">
                                <label for="medicalCert-ft-mobile" class="terms-label">
                                    Confermo di aver preso visione del
                                    <a href="https://elitefitness.it/ethical-code/" target="_blank">Codice Etico</a>
                                </label>
                            </div>
                        </div>

                        <!-- 5. Documenti di identità -->
                        <div class="terms-checkbox">
                            <input type="checkbox" id="identityDocs-ft-mobile" class="custom-checkbox terms-cb" v-model="acceptIdentityDocsDeclaration" />
                            <div class="text-container">
                                <label for="identityDocs-ft-mobile" class="terms-label">
                                    Confermo di aver preso visione della
                                    <a href="https://elitefitness.it/dichiarazione-documenti-di-identita/" target="_blank">Dichiarazione Relativa ai Documenti di Identità</a>
                                </label>
                            </div>
                        </div>

                    </div>
                    <div class="text-center mt-3">
                        <button @click="onStartFreeTrialMobile"
                                class="btn btn-custom complete-payment-btn text-nowrap"
                                :disabled="freeTrialCta.step !== 'auth' && (!hasAcceptedTerms || (remainingCount != null && remainingCount == 0))">
                            {{ freeTrialCta.label }}
                        </button>
                        <span v-if="freeTrialCta.step === 'consents'" class="terms-warning">Per proseguire, devi
                            <a href="#" @click.prevent="scrollToTerms">accettare i termini e le condizioni</a>.
                        </span>
                        <div v-if="freeTrialCta.help" class="terms-warning mt-2">{{ freeTrialCta.help }}</div>
                    </div>
                </div>

                <!-- Right column with overview (hidden on mobile) -->
                <div class="co-col-side">
                    <div class="overview">
                        <h2 class="fw-bold">PANORAMICA</h2>

                        <p style="font-size: 1.1rem">
                            Stai acquistando
                            <strong @click="openDescription(this.selectedProduct.description)" style="cursor: pointer"
                                class="highlight">
                                {{ selectedProduct.name }} ⓘ
                            </strong>
                            <span> presso </span>
                            <span>
                                <strong class="highlight">
                                    {{ centerDescription }}
                                </strong>
                            </span>
                            <span>.</span>
                        </p>

                        <div v-if="freeTrial && selectedProduct.type != 'GYM'" class="alert alert-primary d-flex align-items-center" role="alert">
                            <i class="fa-solid fa-circle-info"></i>
                            <span style="margin-left: 10px;">
                                <div style="margin:10px">
                                    <span>L'ingresso per la prova gratuita del corso </span>
                                    <span>{{ generateFreeTierCourse(selectedService) }}</span>
                                </div>
                            </span>
                        </div>

                        <div v-if="remainingCount != null" class="row">
                            <div v-if="remainingCount > 0" class="col">
                                <div class="alert alert-primary d-flex align-items-center" role="alert">
                                    <i class="fa-solid fa-circle-info"></i>
                                    <span style="margin-left: 10px;">Rimangono {{ remainingCount }} posti
                                        disponibili.</span>
                                </div>
                            </div>
                            <div v-if="remainingCount == 0" class="col">
                                <div class="alert alert-danger d-flex align-items-center" role="alert">
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                    <span style="margin-left: 10px;">Non ci sono posti disponibili.</span>
                                </div>
                            </div>
                        </div>

                        <!-- Variation Overview -->
                        <div v-if="selectedVariationName">

                            <!-- Una riga = un elemento flex. Prima erano due <ul> parallele
                                 allineate per posizione: bastava un'etichetta piu' lunga che
                                 andava a capo, o un valore senza etichetta corrispondente,
                                 perche' tutte le righe sotto slittassero di una posizione. -->
                            <div class="co-sum" v-if="!hideDetails && !isGiftCard">
                                <div class="co-sum-row" v-if="!(selectedProduct?.metadata?.packEntry || selectedProduct?.type == 'ENTRY_PACK')">
                                    <span class="co-sum-label">Durata</span>
                                    <span class="co-sum-value highlight">{{ selectedVariationName || 'N/A' }}</span>
                                </div>
                                <div class="co-sum-row">
                                    <span class="co-sum-label">Quota</span>
                                    <span class="co-sum-value highlight">{{ (selectedVariation?.price)?.toFixed(2) || 'N/A' }}€</span>
                                </div>
                                <div class="co-sum-row" v-if="selectedProduct?.metadata?.packEntry || selectedProduct?.type == 'ENTRY_PACK'">
                                    <span class="co-sum-label">Ingressi</span>
                                    <span class="co-sum-value highlight">{{ entryPeriod || 'N/A' }}</span>
                                </div>
                                <div class="co-sum-row" v-else-if="checkoutOverviewShowsRenewalInDays">
                                    <span class="co-sum-label">Rinnovo</span>
                                    <span class="co-sum-value highlight">fra {{ renewalPeriod || 'N/A' }}</span>
                                </div>
                            </div>
                            <div class="co-sum" v-if="!hideDetails">
                                <div class="co-sum-row" v-if="requiresRegistration && !skipInsuranceActive">
                                    <span class="co-sum-label">Assicurazione</span>
                                    <!-- Quota non dovuta: si dichiara, non si barra. -->
                                    <span class="co-sum-value" v-if="registrationFeeIncluded"><span class="badge-included">Inclusa</span></span>
                                    <span class="co-sum-value highlight" v-else>{{ registrationDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div class="co-sum-row" v-if="requiresMembership && selectedProduct?.type !== 'ENTRY_PACK'">
                                    <span class="co-sum-label">Tesseramento</span>
                                    <span class="co-sum-value highlight">{{ membershipDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div class="co-sum-row" v-if="requiresStopAndGo">
                                    <span class="co-sum-label">Stop &amp; Go</span>
                                    <span class="co-sum-value highlight">{{ selectedStopAndGoVariation?.price.toFixed(2) }}€</span>
                                </div>
                            </div>

                            <!-- Upsell Overview: righe flex (evita disallineamento prezzi quando il nome / (obbligatorio) vanno a capo) -->
                            <div class="checkout-upsell-lines" v-if="!hideDetails && (requiresMandatoryUpsell || requiresBIA || requiresTarget || requiresPersonal || requiresPrecision)">
                                <div v-if="requiresMandatoryUpsell && mandatoryProduct" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">
                                        {{ activeMandatoryProduct?.name }}
                                        <small class="text-warning checkout-upsell-mandatory-tag">(obbligatorio)</small>
                                    </span>
                                    <span class="highlight checkout-upsell-amount">{{ mandatoryDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div v-if="requiresBIA" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">{{ biaSummaryLabelValue }}</span>
                                    <span class="highlight checkout-upsell-amount">{{ biaDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div v-if="requiresTarget" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">{{ targetSummaryLabel }}</span>
                                    <span class="highlight checkout-upsell-amount">{{ targetDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div v-if="requiresPersonal" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">Elite Personal:</span>
                                    <span class="highlight checkout-upsell-amount">{{ personalDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div v-if="requiresPrecision" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">Precision Training:</span>
                                    <span class="highlight checkout-upsell-amount">{{ precisionDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                            </div>


                            <div class="row" v-if="selectedVariationPrice.discount > 0">
                                <div class="col">
                                    <h5 class="mt-5 fw-bold">Sconto applicato</h5>
                                </div>
                                <div class="col">
                                    <h4 class="mt-5 fw-bold text-end">-{{ (selectedVariationPrice.discount).toFixed(2)
                                        || 'N/A' }}€</h4>
                                </div>
                            </div>
                            <div class="row co-promo-discount-breakdown" v-if="promoCode && (selectedVariationPrice.discount > 0 || promoHasGift)">
                                <div class="col-4 ms-auto">
                                    <ul class="co-promo-discount-list" style="list-style-type: none; padding: 0;">
                                        <li class="discount-item-description" v-if="selectedVariationPrice.discount > 0">
                                            <span>{{ promoCode.discountAmount }}{{ promoCode.percentage ? '%' : '€' }}
                                                sul
                                                prodotto</span>
                                        </li>
                                        <li class="discount-item-description"
                                            v-if="upsellsDiscountEff && upsellsDiscountEff.applyToMembership && requiresMembership">
                                            <span>{{ upsellsDiscountEff.membershipDiscount }}{{ (upsellsDiscountEff.membershipPercentage || upsellsDiscountEff.membershipIsPercentage) ? '%' : '€' }} sul
                                                Tesseramento</span>
                                        </li>
                                        <li class="discount-item-description"
                                            v-if="upsellsDiscountEff && upsellsDiscountEff.applyToRegistration && requiresRegistration">
                                            <span>{{ upsellsDiscountEff.registrationDiscount }}{{ (upsellsDiscountEff.registrationPercentage || upsellsDiscountEff.registrationIsPercentage) ? '%' : '€' }}
                                                sull'Assicurazione</span>
                                        </li>
                                        <li class="discount-item-description"
                                            v-if="upsellsDiscountEff && upsellsDiscountEff.applyToBIA && requiresBIA">
                                            <span>{{ upsellsDiscountEff.biaDiscount }}{{ (upsellsDiscountEff.biaPercentage || upsellsDiscountEff.biaIsPercentage) ? '%' : '€' }} sulla BIA</span>
                                        </li>
                                        <li class="discount-item-description"
                                            v-if="upsellsDiscountEff && (upsellsDiscountEff.applyToTarget || upsellsDiscountEff.applyToTargetTraining) && requiresTarget">
                                            <span>{{ (upsellsDiscountEff.targetDiscount ?? upsellsDiscountEff.targetTrainingDiscount) }}{{ (upsellsDiscountEff.targetPercentage || upsellsDiscountEff.targetTrainingPercentage) ? '%' : '€' }} sul Target Training</span>
                                        </li>
                                        <li class="discount-item-description"
                                            v-if="upsellsDiscountEff && upsellsDiscountEff.applyToPersonalTraining && requiresPersonal">
                                            <span>{{ upsellsDiscountEff.personalTrainingDiscount }}{{ upsellsDiscountEff.personalTrainingPercentage ? '%' : '€' }} su Elite Personal</span>
                                        </li>
                                        <li class="discount-item-description"
                                            v-if="upsellsDiscountEff && upsellsDiscountEff.applyToStopAndGo && requiresStopAndGo">
                                            <span>{{ upsellsDiscountEff.stopAndGoDiscount }}{{ (upsellsDiscountEff.stopAndGoPercentage || upsellsDiscountEff.stopngoPercentage) ? '%' : '€' }} su Stop & Go</span>
                                        </li>
                                        <li class="discount-item-description co-promo-free-benefit" v-if="promoFreeMonthsApplied"><span>+{{ promoFreeMonths }} {{ promoFreeMonths === 1 ? 'mese' : 'mesi' }} in omaggio</span></li>
                                        <li class="discount-item-description co-promo-free-benefit" v-if="promoFreeDaysApplied"><span>+{{ promoFreeDays }} giorni gratuiti</span></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <h4 class="mt-1 fw-bold">TOTALE</h4>
                                </div>
                                <div class="col">
                                    <h4 class="mt-1 fw-bold text-end">{{ (selectedVariationPrice.total).toFixed(2) ||
                                        'N/A' }}€</h4>
                                </div>
                            </div>

                        </div>

                        <!-- Product Overview -->
                        <div v-if="!showVariationStep">
                            <div class="row">
                                <div class="col">
                                    <h4 class="mt-5 fw-bold">TOTALE</h4>
                                </div>
                                <div class="col">
                                    <h4 class="mt-5 fw-bold text-end">{{ (selectedVariationPrice.total).toFixed(2) ||
                                        'N/A' }}€</h4>
                                </div>
                            </div>

                        </div>

                        <button type="button" class="terms-select-all"
                                v-if="freeTrial==true && selectedProduct?.type !== 'REGISTRATION'"
                                @click="toggleAllTerms">
                            <span class="terms-select-all-box" :class="{ 'is-on': hasAcceptedTerms }">
                                <svg viewBox="0 0 24 24" aria-hidden="true"><use href="#co-check" /></svg>
                            </span>
                            {{ hasAcceptedTerms ? 'Deseleziona tutti' : 'Seleziona tutti' }}
                        </button>

                        <div v-if="freeTrial==true && selectedProduct?.type !== 'REGISTRATION'" class="terms-section mt-3" id="terms-section-free-trial">
                            <!-- 1. Termini e condizioni -->
                            <div class="terms-checkbox">
                                <input type="checkbox" id="terms" class="custom-checkbox terms-cb"
                                    v-model="acceptTerms" />
                                <div class="text-container">
                                    <label for="terms" class="terms-label">
                                        Confermo di aver preso visione ed accetto i
                                        <a href="https://elitefitness.it/terms/" target="_blank">Termini e condizioni</a>
                                    </label>
                                </div>
                            </div>

                            <!-- 2. Informativa privacy -->
                            <div class="terms-checkbox">
                                <input type="checkbox" id="privacy" class="custom-checkbox terms-cb"
                                    v-model="acceptPrivacyPolicy" />
                                <div class="text-container">
                                    <label for="privacy" class="terms-label">
                                        Confermo di aver preso visione dell'
                                        <a href="https://elitefitness.it/privacy/" target="_blank">Informativa
                                            Privacy</a>
                                        ai sensi del Regolamento (UE) 2016/679 (GDPR)
                                    </label>
                                </div>
                            </div>

                            <!-- 3. Regolamento -->
                            <div class="terms-checkbox">
                                <input type="checkbox" id="regulationFreeTrial" class="custom-checkbox terms-cb"
                                    v-model="acceptRegulation" />
                                <div class="text-container">
                                    <label for="regulationFreeTrial" class="terms-label">
                                        Confermo di aver preso visione ed accetto il
                                        <a href="https://elitefitness.it/regulation/" target="_blank">Regolamento
                                            Interno di Elite Fitness SSD</a>
                                    </label>
                                </div>
                            </div>

                            <!-- 4. Codice etico -->
                            <div class="terms-checkbox">
                                <input type="checkbox" id="medicalCert" class="custom-checkbox terms-cb"
                                    v-model="acceptMedicalCertDeclaration" />
                                <div class="text-container">
                                    <label for="medicalCert" class="terms-label">
                                        Confermo di aver preso visione del
                                        <a href="https://elitefitness.it/ethical-code/"
                                            target="_blank">Codice Etico</a>
                                    </label>
                                </div>
                            </div>

                            <!-- 5. Documenti di identità -->
                            <div class="terms-checkbox">
                                <input type="checkbox" id="identityDocs" class="custom-checkbox terms-cb"
                                    v-model="acceptIdentityDocsDeclaration" />
                                <div class="text-container">
                                    <label for="identityDocs" class="terms-label">
                                        Confermo di aver preso visione della
                                        <a href="https://elitefitness.it/dichiarazione-documenti-di-identita/"
                                            target="_blank">Dichiarazione Relativa ai Documenti di Identità</a>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div v-if="(selectedVariationName || !showVariationStep) && userLogged && !isGiftCard" class="mt-3">
                            <div class="input-group co-discount-bar mb-3">
                                <input type="text" v-model="discountCode"
                                    class="form-control discount custom-placeholder"
                                    placeholder="INSERISCI IL CODICE SCONTO" aria-label="Codice Sconto"
                                    aria-describedby="button-addon2" :disabled="!!promoCode || smartExcludesPromo">
                                <button v-if="!promoCode" class="btn btn-danger rounded-0" type="button"
                                    :disabled="smartExcludesPromo"
                                    @click="applyDiscount">APPLICA</button>
                                <button v-else class="btn btn-outline-danger rounded-0" type="button"
                                    @click="removeDiscount">RIMUOVI</button>
                            </div>
                            <!-- L'esito negativo resta scritto accanto al campo: prima l'unico segnale era un
                                 toast da tre secondi, dopo il quale il checkout proseguiva a prezzo pieno senza
                                 che nulla dicesse perché il codice non era stato applicato. -->
                            <div v-if="discountError && !promoCode" class="discount-error-message" role="alert">
                                <i class="fa-solid fa-circle-exclamation"></i>
                                <span>{{ discountError }}</span>
                            </div>
                            <!-- Le offerte di recupero nascono esclusive: il socio deve sapere che applicandole
                                 rinuncia agli altri sconti, prima di pagare e non dopo. -->
                            <div v-if="smartExcludesPromo" class="discount-exclusive-note" role="status">
                                <i class="fa-solid fa-circle-info"></i>
                                <span>{{ smartPromoNote }}</span>
                            </div>
                            <div v-if="promoCode && promoCode.exclusive" class="discount-exclusive-note">
                                <i class="fa-solid fa-circle-info"></i>
                                <span>Questa offerta non è cumulabile con altre promozioni o codici sconto.</span>
                            </div>
                        </div>
                        <div v-else-if="!userLogged && discountCode?.length > 0 && !promoCode && !discountCodeFromUrl && !isGiftCard">
                            <div class="alert alert-danger d-flex align-items-center" role="alert">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                <span style="margin-left: 10px;">Per applicare un codice sconto, devi
                                    <router-link :to="getLoginLink()">
                                        <a style="color:white" href="#">effettuare l'accesso</a>
                                    </router-link>
                                </span>
                            </div>
                        </div>
                        <!-- ✅ Nel pannello di destra rimane solo il bottone per la Prova Gratuita -->
                        <div class="text-center mt-4" v-if="freeTrial && selectedProduct?.type !== 'REGISTRATION'">
                            <button :disabled="freeTrialCta.step !== 'auth' && !enablePaymentButton" @click="handleFreeTrial"
                                class="btn btn-custom complete-payment-btn text-nowrap">
                                {{ freeTrialCta.label }}
                            </button>
                            <span v-if="freeTrialCta.step === 'consents'" class="terms-warning">Per proseguire, devi
                                <a href="#" @click="scrollToTerms">accettare i termini e le condizioni</a>.</span>
                            <div v-if="freeTrialCta.help" class="terms-warning mt-2">{{ freeTrialCta.help }}</div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
        
        <!-- Mobile Order Summary (fixed bottom, expandable) -->
        <div class="mobile-summary co-sticky-summary" :class="{ open: isMobileSummaryOpen }"
            v-if="selectedProduct && !productNotFound && !isServiceDisabled">
            <div class="mobile-summary-bar" @click="toggleMobileSummary">
                <div class="msb-left">
                    <span class="msb-label">Dettagli ordine</span>
                </div>
                <div class="msb-right">
                    <span class="msb-total">{{ (selectedVariationPrice.total).toFixed(2) }}€</span>
                    <i class="fa-solid" :class="isMobileSummaryOpen ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </div>
            </div>
            <transition name="slide-up">
                <div v-if="isMobileSummaryOpen" class="mobile-summary-panel">
                    <div class="panel-content">
                        <h3 class="fw-bold">Riepilogo</h3>
                        <p class="mb-2" v-if="selectedProduct">
                            <span>Stai acquistando </span>
                            <strong class="highlight">{{ selectedProduct.name }}</strong>
                        </p>

                        <!-- Mobile-only discount code inside the summary as well -->
                        <div class="d-xl-none mb-3" v-if="userLogged && (selectedVariationName || !showVariationStep)">
                            <div class="input-group co-discount-bar">
                                <input type="text" v-model="discountCode" class="form-control discount custom-placeholder"
                                       placeholder="INSERISCI IL CODICE SCONTO" aria-label="Codice Sconto"
                                       :disabled="!!promoCode || smartExcludesPromo">
                                <button v-if="!promoCode" class="btn btn-danger rounded-0" type="button" :disabled="smartExcludesPromo" @click="applyDiscount">APPLICA</button>
                                <button v-else class="btn btn-outline-danger rounded-0" type="button" @click="removeDiscount">RIMUOVI</button>
                            </div>
                        </div>

                        <div v-if="selectedVariationName">
                            <div class="row" v-if="!hideDetails && !isGiftCard">
                                <div class="col">
                                    <ul class="list-unstyled">
                                        <li>Durata:</li>
                                        <li>Quota di abbonamento:</li>
                                        <li v-if="selectedProduct?.metadata?.packEntry || selectedProduct?.type == 'ENTRY_PACK'">Ingressi:</li>
                                    </ul>
                                </div>
                                <div class="col">
                                    <ul class="list-unstyled text-end">
                                        <li><span class="highlight">{{ selectedVariationName || 'N/A' }}</span></li>
                                        <li><span class="highlight">{{ (selectedVariation?.price).toFixed(2) || 'N/A' }}€</span></li>
                                        <li v-if="selectedProduct?.metadata?.packEntry || selectedProduct?.type == 'ENTRY_PACK'"><span class="highlight">{{ entryPeriod || 'N/A' }}</span></li>
                                        <li v-else-if="checkoutOverviewShowsRenewalInDays"><span class="highlight">fra {{ renewalPeriod || 'N/A' }}</span></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row" v-if="!hideDetails">
                                <div class="col">
                                    <ul class="list-unstyled">
                                        <li v-if="requiresRegistration && !skipInsuranceActive">Assicurazione:</li>
                                        <li v-if="requiresMembership && selectedProduct?.type !== 'ENTRY_PACK'">Tesseramento:</li>
                                        <li v-if="requiresStopAndGo">Stop & Go:</li>
                                    </ul>
                                </div>
                                <div class="col">
                                    <ul class="list-unstyled text-end">
                                        <li v-if="requiresRegistration && !skipInsuranceActive">
                                            <span v-if="registrationFeeIncluded" class="badge-included">Inclusa</span>
                                            <span v-else class="highlight">{{ registrationDisplayPrice?.toFixed(2) }}€</span>
                                        </li>
                                        <li v-if="requiresMembership && selectedProduct?.type !== 'ENTRY_PACK'"><span class="highlight">{{ membershipDisplayPrice?.toFixed(2) }}€</span></li>
                                        <li v-if="requiresStopAndGo"><span class="highlight">{{ selectedStopAndGoVariation?.price.toFixed(2) }}€</span></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="checkout-upsell-lines" v-if="!hideDetails && (requiresMandatoryUpsell || requiresBIA || requiresTarget || requiresPersonal || requiresPrecision)">
                                <div v-if="requiresMandatoryUpsell && mandatoryProduct" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">
                                        {{ activeMandatoryProduct?.name }}
                                        <small class="text-warning checkout-upsell-mandatory-tag">(obbligatorio)</small>
                                    </span>
                                    <span class="highlight checkout-upsell-amount">{{ mandatoryDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div v-if="requiresBIA" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">{{ biaSummaryLabelValue }}</span>
                                    <span class="highlight checkout-upsell-amount">{{ biaDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div v-if="requiresTarget" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">{{ targetSummaryLabel }}</span>
                                    <span class="highlight checkout-upsell-amount">{{ targetDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div v-if="requiresPersonal" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">Elite Personal:</span>
                                    <span class="highlight checkout-upsell-amount">{{ personalDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                                <div v-if="requiresPrecision" class="checkout-upsell-row">
                                    <span class="checkout-upsell-label">Precision Training:</span>
                                    <span class="highlight checkout-upsell-amount">{{ precisionDisplayPrice?.toFixed(2) }}€</span>
                                </div>
                            </div>

                            <div class="row" v-if="selectedVariationPrice.discount > 0">
                                <div class="col"><h5 class="mt-3 fw-bold">Sconto</h5></div>
                                <div class="col"><h5 class="mt-3 fw-bold text-end">-{{ (selectedVariationPrice.discount).toFixed(2) || 'N/A' }}€</h5></div>
                            </div>
                            <div class="row co-promo-discount-breakdown" v-if="promoCode && (selectedVariationPrice.discount > 0 || promoHasGift)">
                                <div class="col-6 ms-auto">
                                    <ul class="co-promo-discount-list" style="list-style-type: none; padding: 0;">
                                        <li class="discount-item-description" v-if="selectedVariationPrice.discount > 0"><span>{{ promoCode.discountAmount }}{{ promoCode.percentage ? '%' : '€' }} sul prodotto</span></li>
                                        <li class="discount-item-description" v-if="upsellsDiscountEff && upsellsDiscountEff.applyToMembership && requiresMembership"><span>{{ upsellsDiscountEff.membershipDiscount }}{{ (upsellsDiscountEff.membershipPercentage || upsellsDiscountEff.membershipIsPercentage) ? '%' : '€' }} sul Tesseramento</span></li>
                                        <li class="discount-item-description" v-if="upsellsDiscountEff && upsellsDiscountEff.applyToRegistration && requiresRegistration"><span>{{ upsellsDiscountEff.registrationDiscount }}{{ (upsellsDiscountEff.registrationPercentage || upsellsDiscountEff.registrationIsPercentage) ? '%' : '€' }} sull'Assicurazione</span></li>
                                        <li class="discount-item-description" v-if="upsellsDiscountEff && upsellsDiscountEff.applyToBIA && requiresBIA"><span>{{ upsellsDiscountEff.biaDiscount }}{{ (upsellsDiscountEff.biaPercentage || upsellsDiscountEff.biaIsPercentage) ? '%' : '€' }} sulla BIA</span></li>
                                        <li class="discount-item-description" v-if="upsellsDiscountEff && (upsellsDiscountEff.applyToTarget || upsellsDiscountEff.applyToTargetTraining) && requiresTarget"><span>{{ (upsellsDiscountEff.targetDiscount ?? upsellsDiscountEff.targetTrainingDiscount) }}{{ (upsellsDiscountEff.targetPercentage || upsellsDiscountEff.targetTrainingPercentage) ? '%' : '€' }} sul Target Training</span></li>
                                        <li class="discount-item-description" v-if="upsellsDiscountEff && upsellsDiscountEff.applyToPersonalTraining && requiresPersonal"><span>{{ upsellsDiscountEff.personalTrainingDiscount }}{{ upsellsDiscountEff.personalTrainingPercentage ? '%' : '€' }} su Elite Personal</span></li>
                                        <li class="discount-item-description" v-if="upsellsDiscountEff && upsellsDiscountEff.applyToStopAndGo && requiresStopAndGo"><span>{{ upsellsDiscountEff.stopAndGoDiscount }}{{ (upsellsDiscountEff.stopAndGoPercentage || upsellsDiscountEff.stopngoPercentage) ? '%' : '€' }} su Stop & Go</span></li>
                                        <li class="discount-item-description co-promo-free-benefit" v-if="promoFreeMonthsApplied"><span>+{{ promoFreeMonths }} {{ promoFreeMonths === 1 ? 'mese' : 'mesi' }} in omaggio</span></li>
                                        <li class="discount-item-description co-promo-free-benefit" v-if="promoFreeDaysApplied"><span>+{{ promoFreeDays }} giorni gratuiti</span></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col"><h4 class="mt-2 fw-bold">TOTALE</h4></div>
                                <div class="col"><h4 class="mt-2 fw-bold text-end">{{ (selectedVariationPrice.total).toFixed(2) || 'N/A' }}€</h4></div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { IS_KIOSK } from '@/config/kiosk';
import { QUICK_CHECKOUT } from '@/config/quickCheckout';
import QuickSignupForm from './QuickSignupForm.vue';
import { biaPacksFromProduct, findBiaPack, biaBasePrice, biaSummaryLabel, biaAdditionals } from '@/utils/biaPack.js';
import BiaPackPicker from './BiaPackPicker.vue';
import { kioskSession } from '@/config/kioskSession';
import GenderSelect from '@/components/GenderSelect.vue';
import Datepicker from '@vuepic/vue-datepicker'
import { useRoute } from 'vue-router';
import { onMounted } from 'vue';
import Swal from 'sweetalert2'
import { validateItalianTaxCode } from '@/utils/taxCodeValidator.js'
import { resolveVariationFromCatalog, normalizeVariationName } from '@/utils/variationNames.js'
import { buildRegistrationSigningAttachments, dateOfBirthToApiIso, submitLegalAttestation } from '@/utils/registrationSigningFlow.js'
import { prezzoUpsellScontato, prezzoAssicurazioneAcquistata, upsellsDiscountEffettivo } from '@/utils/upsellPrices.js'
import {
    pagaConCarta, avviaPayPal, esitoCreazioneCarta, giudicaRicontrolloCodice,
    firmaCarrello, haCarrelloRicordato, carrelloGiaCompletato, registraCarrelloCompletato, dimenticaCarrelloCompletato,
} from '@/utils/paymentFlow.js'
import {
    packsFromResponse, orderablePacks, findPack as findTargetPack, keepSelection as keepTargetPack,
    targetBasePrice, summaryLabel as targetPackSummaryLabel, targetAdditionals,
} from '@/utils/targetPack.js'
import TargetPackPicker from './TargetPackPicker.vue'
import { fetchGuestPromoPreview } from '@/utils/guestPromoPreview.js'
import { freeTrialCtaState } from '@/utils/freeTrialCta.js'
import { normalizePromoCode } from '@/utils/promoCode.js'
import { INITIATIVE_LABELS, listPriceFor, previewPriceFor, previewQuery, shouldShowUpgrade, smartExcludesPromo } from '@/utils/commercialInitiatives.js'

export default {
    components: {
        GenderSelect,
        Datepicker,
        TargetPackPicker,
        BiaPackPicker,
        QuickSignupForm
    },
    setup() {
        const route = useRoute();

        onMounted(() => {
            console.log("Route object after mount:", route);
            console.log("Product ID from URL after mount:", route.query?.productId);
        });

        return {};
    },
    data() {
        return {
            isLoading: false,
            menuVisible: false,
            userLogged: false,
            userEmail: null,
            userToken: null,
            userFullName: null,
            userId: null,

            step: 1,  // Step iniziale
            selectedVariationName: null,  // Variazione selezionata
            selectedProductId: null,  // Imposta l'id del prodotto specifico qui
            selectedProduct: null,
            selectedVariation: null,
            annualVariation: false,

            productNotFound: false,

            hasVariations: false,  // Indica se il prodotto ha variazioni
            showVariationStep: false,  // Controlla se lo step delle variazioni deve essere mostrato

            user: {
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                dateOfBirth: null,
                placeOfBirth: '',
                taxCode: '',
                gender: '',
                address: '',
                city: '',
                postalCode: '',
                province: '',
                country: '',
                phoneNumber: '',
                mobileNumber: '',
                // Dati tutore legale (inviati solo se minorenne)
                legalGuardian: {
                    firstName: '',
                    lastName: '',
                    taxCode: '',
                    relationship: '',
                    email: '',
                    phoneNumber: '',
                    address: '',
                    city: '',
                    postalCode: '',
                    province: '',
                    country: ''
                }
            },
            stripe: null,
            elements: null,
            cardElement: null,
            paymentElement: null,
            paymentRequestButton: null,
            paymentRequest: null,
            isPaymentReady: false,
            checkoutIdempotencyKey: null, // Per idempotenza su retry (stripe/create, paypal/create)

            promoCode: null,
            discountCode: '',  // Codice sconto inserito dall'utente
            /** True when discountCode was present in the landing URL (marketing comeback links). */
            discountCodeFromUrl: false,
            /** Guest preview from GET /api/promo/* — prices only; payment still requires login + validate. */
            guestPromoPreviewActive: false,
            guestPromoVariationPrices: null,
            discountAmount: 0,  // Importo dello sconto
            discountError: null,  // Messaggio di errore per il codice sconto
            finalPrice: 0,  // Prezzo finale dopo lo sconto

            emailError: null,
            taxCodeError: null, // Errore validazione codice fiscale
            taxCodeValidationTimeout: null, // Timeout per debounce validazione CF

            requiresRegistration: true,
            requiresMembership: true,
            requiresStopAndGo: false,
            registrationProduct: null, // Prodotto di iscrizione e assicurazione
            membershipProduct: null, // Prodotto di tesseramento
            stopngoProduct: null, // Prodotto di Stop & Go
            biaProduct: null,
            selectedBiaPackName: null, // pacchetto BIA scelto (#213); null = BIA singola, checkout invariato
            targetProduct: null,
            personalProduct: null,
            precisionProduct: null,

            selectedStopAndGoVariation: null,
            
            // Data di inizio personalizzata (formato YYYY-MM-DD per il backend)
            customStartDate: null,
            // Oggetto Date per il Datepicker (computed)
            customStartDateObject: null,

            // Gift Card fields
            giftCardRecipientEmail: '',
            giftCardMessage: '',

            // Checkout Gift fields (per acquisti in modalità gift)
            isGiftMode: false,
            sendEmailToGiftRecipient: false,
            giftRecipientEmail: '',
            giftMessage: '',

            // Esposto al template: al totem alcuni percorsi (registrazione) sono
            // diversi da quelli web.
            isKiosk: IS_KIOSK,

            // Al kiosk si paga in loco: Contanti (Cashmatic) o POS. Sul web
            // restano i metodi online (Carta/PayPal/Reception).
            paymentMethods: IS_KIOSK
                ? [
                    { label: "Contanti", value: "CASH_KIOSK", icon: "fa-money-bill-wave", iconType: "solid" },
                    { label: "Carta (POS)", value: "CARD_KIOSK", icon: "fa-credit-card", iconType: "solid" },
                ]
                : [
                    { label: "Carta", value: "CARD", icon: "fa-credit-card", iconType: "solid" },
                    { label: "PayPal", value: "PAYPAL", icon: "fa-paypal", iconType: "brands" },
                    { label: "In Reception (Contanti o  POS)", value: "CASH", icon: "fa-store", iconType: "solid" },
                ],
            selectedPayment: IS_KIOSK ? "CASH_KIOSK" : "", // #113: sul web nessuna preselezione, la scelta è dell'utente

            // Wallet credit
            walletBalance: 0,
            useWalletCredit: false,
            walletLoading: false,
            format: 'dd/MM/yyyy',
            previewFormat: (date) => {
                if (!date) return ''
                const day = date.getDate().toString().padStart(2, '0')
                const month = (date.getMonth() + 1).toString().padStart(2, '0')
                const year = date.getFullYear()
                return `${day}/${month}/${year}`
            },
            showPassword: false,
            passwordError: null,

            // Registration Steps
            collapsedSections: {
                personalInfo: false,
                contactInfo: true,
                guardianInfo: true,
                accountInfo: true,
            },

            centers: [],
            centersLoadedAtLeastOnce: false,
            selectedService: null,
            selectedCenterId: '', // Centro scelto al checkout (solo Fitness Lover). '' = Tutti (legacy).
            // Iniziative commerciali (#210/#211/#230): anteprima prezzo e proposta di upgrade, decise dal server.
            initiativePreview: null,
            // Checkout aperto dal banner Rinnovo/Upgrade Smart della Member App (devops#466): si mostra solo la durata
            // dell'offerta. Il prezzo resta deciso dal server; il parametro restringe soltanto la scelta.
            smartOffer: null,
            smartOfferVariationName: null,
            upgradeProposal: null,
            upgradeProposalDismissed: false,
            initiativeSeq: 0,
            pricingCenterId: '', // Centro listino; con FOLLOW_PAID_LIST non limita gli accessi.
            isFreeTargetUpsell: false, // Target gratuito per centro con freeTargetEnabled (trainer scelto in app)
            toasts: [],
            
            // Temporary state for calendar navigation
            tempServiceCenters: null,
            tempCalendarDate: null,

            // Autocompletamento ISTAT per utente principale
            placeOfBirthSuggestions: [],
            showPlaceOfBirthSuggestions: false,
            isLoadingPlaceOfBirth: false,
            placeOfBirthSearchTimeout: null,
            
            citySuggestions: [],
            showCitySuggestions: false,
            isLoadingCities: false,
            citySearchTimeout: null,
            
            postalCodeSuggestions: [],
            showPostalCodeSuggestions: false,
            isLoadingPostalCodes: false,
            postalCodeSearchTimeout: null,
            
            provinceSuggestions: [],
            showProvinceSuggestions: false,
            isLoadingProvinces: false,
            provinceSearchTimeout: null,
            
            // Dropdown nazione con ricerca
            allCountries: [],
            countrySearchQuery: '',
            showCountryDropdown: false,
            isLoadingCountries: false,
            
            // Autocompletamento ISTAT per tutore legale
            legalGuardianCitySuggestions: [],
            showLegalGuardianCitySuggestions: false,
            isLoadingLegalGuardianCities: false,
            legalGuardianCitySearchTimeout: null,
            
            legalGuardianPostalCodeSuggestions: [],
            showLegalGuardianPostalCodeSuggestions: false,
            isLoadingLegalGuardianPostalCodes: false,
            legalGuardianPostalCodeSearchTimeout: null,
            
            legalGuardianProvinceSuggestions: [],
            showLegalGuardianProvinceSuggestions: false,
            isLoadingLegalGuardianProvinces: false,
            legalGuardianProvinceSearchTimeout: null,

            remainingCount: null,

            freeTrial: false, // Se true, il checkout deve effettuare un free trial. Non verifica se il prodotto ha un free trial
            requiresBIA: false,
            requiresTarget: false,
            requiresPersonal: false,
            requiresPrecision: false,
            selectedBIATrainerId: null,
            trainers: [],
            trainerCustomPrices: [], // Trainer con prezzi custom (API open, per utenti non loggati)
            showBIATrainerSelection: false,

            // Mandatory Product Upsell
            requiresMandatoryUpsell: null,
            mandatoryProduct: null,
            mandatoryService: null,
            selectedMandatoryVariation: null,
            /** Alternativa "Dipendenza ingressi": prodotto ENTRY_PACK offerto in
             * alternativa all'abbonamento del servizio padre (null se non disponibile) */
            mandatoryEntryPackProduct: null,
            /** Scelta dell'utente per l'upsell obbligatorio: 'subscription' | 'entries' */
            mandatoryChoice: 'subscription',

            // Selezione del personal trainer per il prodotto PERSONAL_TRAINING
            selectedPersonalTrainerId: null,
            selectedPersonalUpsellTrainerId: null,
            selectedPrecisionUpsellTrainerId: null,
            /** Nome variazione prodotto Elite Personal come upsell (stringa per il select) */
            selectedPersonalUpsellVariationName: null,
            selectedTargetTrainerId: null,

            bypassMandatory: false, // Se true, bypassa il mandatory upsell

            referralCode: null,
            referralCodeFromUrl: false, // Traccia se il referralCode proviene dalla URL iniziale
            // Source of checkout entry: 'web' (default) or 'app'
            checkoutSource: 'web',

            acceptTerms: false,
            acceptPrivacyPolicy: false,
            acceptRegulation: false,
            acceptMedicalCertDeclaration: false,
            acceptIdentityDocsDeclaration: false,

            acceptTermsSignup: false,
            acceptPrivacyPolicySignup: false,
            acceptRegulationSignup: false,
            acceptMedicalCertDeclarationSignup: false,
            acceptIdentityDocsDeclarationSignup: false,

            // Default prices
            targetDefaultPrice: 0,
            targetPacksRaw: [], // risposta del listino pacchetti Target Training (#212); vuoto = iniziativa spenta, checkout invariato
            selectedTargetPackCode: null,
            biaDefaultPrice: 0,
            personalDefaultPrice: 0,

            productDefaultPrice: 0, // Prezzo di default del prodotto selezionato
            /** Prezzo catalogo variazione Precision al load (immutable); il picker non usa variation.price mutato. */
            precisionCatalogFlatPrice: null,

            // Mobile Summary
            isMobileSummaryOpen: false,

            // UI: toggle for registration form in Step 2
            showRegistrationForm: false,
            quickCheckoutUnavailable: false, // il server ha risposto 404: flusso spento, si ricade sulla registrazione completa

            // Promo: giorni gratuiti extra dal codice promozionale
            promoFreeDays: 0,
            // Promo: mesi omaggio di calendario, si sommano ai giorni
            promoFreeMonths: 0,
            // Centri ammessi dal codice promo (solo servizi GYM con restrizione)
            promoAllowedCenters: null,
            // Sede in cui il pagamento concede lo sconto (discountCenterId di validate), se una sola
            promoDiscountCenterId: null,
            // Sede con cui il codice applicato e' stato validato l'ultima volta
            promoValidatedCenterId: null,
            // Codice tolto dal riepilogo perche' non vale nella sede scelta: si riprova al cambio sede
            promoSuspendedForCenter: false,
            // Scarta le rivalidazioni superate da un cambio sede successivo
            promoCenterCheckSeq: 0,
        };
    },
    async created() {
        try {
            // Inizializza Stripe
            this.stripe = await loadStripe('pk_live_51QP1pFKXs4KZv5huj0vF3RTtJSglnwXuYgauIG0tpIlD7zHxkGxL7Xh5gPHjrfLXjtLV13WjSPzAScy2BrVppoSc00zBtu1kK1');
            if (!this.stripe) {
                throw new Error('Stripe failed to initialize');
            }

            // Verifica se l'utente è loggato
            var email = localStorage.getItem('userEmail');
            var token = localStorage.getItem('userToken');

            // Consegna di sessione: al posto del JWT l'indirizzo porta un identificativo opaco, che scambiamo
            // qui una volta sola. `userToken` resta accettato perché le versioni della Member App già negli
            // store continueranno a mandarlo finché non saranno aggiornate tutte.
            const handoffFromUrl = this.$route.query?.handoff;
            let tokenFromHandoff = null;
            if (handoffFromUrl) {
                try {
                    const res = await fetch(
                        `https://api.elitefitness.it/api/auth/checkout-handoff/${encodeURIComponent(handoffFromUrl)}/consume`,
                        { method: 'POST' });
                    if (res.ok) {
                        const data = await res.json();
                        tokenFromHandoff = data?.accessToken || null;
                    }
                } catch (e) {
                    console.warn('handoff non consumabile', e);
                }
            }

            // Verifica se c'è il token da URL
            const userTokenFromUrl = tokenFromHandoff || this.$route.query?.userToken;
            if (userTokenFromUrl) {
                const response = await fetch('https://api.elitefitness.it/api/users/profile', {
                    headers: {
                        Authorization: `Bearer ${userTokenFromUrl}`,
                    },
                });
                if (response.ok) {
                    const userData = await response.json();
                    this.userLogged = true;
                    this.userEmail = userData.email;
                    this.userToken = userTokenFromUrl;
                    this.userFullName = this.nomeConIniziali(userData.personalInfo);
                    this.publishKioskUserName();
                    this.userId = userData.id;
                    email = this.userEmail;
                    token = this.userToken;
                }
            }

            // Recupera il profilo utente se l'utente è loggato
            if (email && token) {
                this.userLogged = true;
                this.userEmail = email;
                this.userToken = token;

                try {
                    // Recupera il profilo utente
                    const response = await fetch('https://api.elitefitness.it/api/users/profile', {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    if (!response.ok) {
                        this.userLogged = false;
                        this.userEmail = null;
                        this.userToken = null;
                        localStorage.removeItem('userEmail');
                        localStorage.removeItem('userToken');
                        localStorage.removeItem('tokenExpiration');
                        console.error('Errore nel recupero del profilo utente');
                        this.$router.go();
                        return;
                    }

                    const userData = await response.json();
                    this.userFullName = this.nomeConIniziali(userData.personalInfo);
                    this.publishKioskUserName();
                    this.userId = userData.id;
                    
                    // Load wallet balance
                    this.loadWalletBalance();
                } catch (error) {
                    console.error('Errore durante la richiesta al server:', error);
                }
            }

            // Supporta sia "ref" che "referralCode" come parametro URL
            const referralCode = this.$route.query?.referralCode || this.$route.query?.ref;
            if (referralCode) {
                this.referralCode = referralCode;
                this.referralCodeFromUrl = true; // Marca che il referral proviene dalla URL
            } else {
                this.referralCode = null;
                this.referralCodeFromUrl = false;
            }

            const bypassMandatory = this.$route.query?.bypm;
            this.bypassMandatory = bypassMandatory === 'true';

            const freeTrial = this.$route.query?.freeTrial;
            this.freeTrial = (freeTrial === 'true');

            // Check if checkout is in gift mode
            const gift = this.$route.query?.gift;
            this.isGiftMode = (gift === 'true');

            // Capture source param (web/app), default to web
            try {
                const src = (this.$route.query?.source || 'web').toString().toLowerCase();
                this.checkoutSource = (src === 'app') ? 'app' : 'web';
            } catch (e) {
                this.checkoutSource = 'web';
            }

            // Restore trainer selections and upsell toggles from URL (if present)
            const biaTrainerIdFromUrl = this.$route.query?.biaTrainerId;
            const targetTrainerIdFromUrl = this.$route.query?.targetTrainerId;
            const personalTrainerIdFromUrl = this.$route.query?.personalTrainerId;
            if (biaTrainerIdFromUrl) this.selectedBIATrainerId = biaTrainerIdFromUrl;
            if (targetTrainerIdFromUrl) this.selectedTargetTrainerId = targetTrainerIdFromUrl;
            if (personalTrainerIdFromUrl) this.selectedPersonalTrainerId = personalTrainerIdFromUrl;

            const centerIdFromUrl = this.$route.query?.centerId;
            if (centerIdFromUrl) this.selectedCenterId = centerIdFromUrl;

            const requiresBIAFromUrl = this.$route.query?.requiresBIA;
            const requiresTargetFromUrl = this.$route.query?.requiresTarget;
            const requiresPersonalFromUrl = this.$route.query?.requiresPersonal;
            const requiresStopAndGoFromUrl = this.$route.query?.requiresStopAndGo;
            if (typeof requiresBIAFromUrl !== 'undefined') this.requiresBIA = (requiresBIAFromUrl === 'true');
            if (typeof requiresTargetFromUrl !== 'undefined') this.requiresTarget = (requiresTargetFromUrl === 'true');
            if (typeof requiresPersonalFromUrl !== 'undefined') this.requiresPersonal = (requiresPersonalFromUrl === 'true');
            const requiresPrecisionFromUrl = this.$route.query?.requiresPrecision;
            if (typeof requiresPrecisionFromUrl !== 'undefined') this.requiresPrecision = (requiresPrecisionFromUrl === 'true');
            const precisionTrainerIdFromUrl = this.$route.query?.precisionTrainerId;
            if (precisionTrainerIdFromUrl) this.selectedPrecisionUpsellTrainerId = precisionTrainerIdFromUrl;
            if (typeof requiresStopAndGoFromUrl !== 'undefined') this.requiresStopAndGo = (requiresStopAndGoFromUrl === 'true');

            const personalUpsellTrainerIdFromUrl = this.$route.query?.personalUpsellTrainerId;
            if (personalUpsellTrainerIdFromUrl) this.selectedPersonalUpsellTrainerId = personalUpsellTrainerIdFromUrl;
            // Qui il prodotto Personal non è ancora caricato, quindi si può controllare solo la
            // forma: nello stato entra una stringa o niente, mai un array o un oggetto arrivato
            // dalla query string. La verifica che il nome esista davvero avviene più avanti,
            // quando le variazioni sono note.
            const personalUpsellVariationFromUrl = this.$route.query?.personalUpsellVariation;
            if (typeof personalUpsellVariationFromUrl === 'string' && personalUpsellVariationFromUrl.trim()) {
                this.selectedPersonalUpsellVariationName = personalUpsellVariationFromUrl;
            }

            const productIdFromUrl = this.$route.query?.productId;
            const variationFromUrl = this.$route.query?.variationName;
            const discountCodeFromUrl = this.$route.query?.discountCode;
            if (discountCodeFromUrl) {
                this.discountCode = this.sanitizePromoCode(discountCodeFromUrl);
                this.discountCodeFromUrl = !!this.discountCode;
            }
            else {
                this.discountCode = '';
                this.discountCodeFromUrl = false;
            }
            let productResponse;

            // Se è presente un ID prodotto nell'URL, recupera quel prodotto specifico
            if (productIdFromUrl) {
                productResponse = await fetch(`https://api.elitefitness.it/api/products/${productIdFromUrl}`);
                if (productResponse.ok) {
                    const product = await productResponse.json();
                    this.selectedProduct = product;

                    this.showBIATrainerSelection = this.selectedProduct.type == 'BIA';

                    // Filtro variazioni attive: per Gift Card mantieni tutte (active undefined considerate true)
                    if (this.selectedProduct.variations) {
                        if (this.selectedProduct.type === 'GIFT_CARD') {
                            this.selectedProduct.variations = this.selectedProduct.variations.filter(v => v.active !== false);
                        } else {
                            this.selectedProduct.variations = this.selectedProduct.variations.filter(v => v.active === true);
                        }
                    }

                    // Il parametro URL vale solo se corrisponde davvero a una variazione di questo
                    // prodotto. Se non corrisponde -- nome inesistente, spazi o maiuscole diverse,
                    // valore non stringa -- viene scartato in silenzio e si prosegue come se non
                    // fosse stato passato: chi sta pagando non deve vedere un errore per un
                    // parametro che non ha scritto lui.
                    const variationFromCatalog = resolveVariationFromCatalog(
                        this.selectedProduct.variations, variationFromUrl);
                    if (variationFromCatalog) {
                        this.selectedVariation = variationFromCatalog;
                        this.selectedVariationName = variationFromCatalog.variationName;
                        // Anche la variante arrivata dal link decide se l'iscrizione è inclusa (devops #292).
                        this.aggiornaVarianteAnnuale();
                        this.applySmartOfferFromUrl(variationFromCatalog);
                    }
                    // La condizione guarda l'esito della risoluzione e non la presenza del parametro:
                    // altrimenti un parametro sbagliato lascerebbe il checkout senza variazione
                    // selezionata proprio quando ce n'e' una sola possibile.
                    if (!variationFromCatalog && this.selectedProduct.variations && this.selectedProduct.variations.length === 1) {
                        this.selectVariation(this.selectedProduct.variations[0]);
                    }
                    // Seleziono la variazione usando selectVariation(..)

                    // Verifico se il discountCode è presente e se è una promo attiva
                    if (this.discountCode) {
                        this.applyDiscount();
                    }

                    this.selectedProductId = product.id;

                    if (this.selectedProduct.type === 'COURSE') {
                        await this.fetchRemainingCount(this.selectedProduct.serviceId);
                    }

                } else {
                    this.productNotFound = true;
                }
            } else {
                // Nessun prodotto nell'indirizzo: si ripiega sul prodotto di riferimento del catalogo. Va bene
                // per chi arriva al checkout da solo, NON per chi arriva da un link con un'offerta: quel
                // prodotto può non essere fra quelli in offerta, e allora il socio vedrebbe il listino pieno con
                // un codice applicato che non sconta nulla — cioè un'offerta che sembra una presa in giro.
                // Meglio non applicare il codice e dirlo: chi legge un errore chiama la reception.
                if (discountCodeFromUrl) {
                    this.discountCode = '';
                    this.discountError = 'Non riusciamo ad aprire la tua offerta su questo abbonamento. '
                        + 'Contatta la reception: il codice è ancora valido.';
                }
                productResponse = await fetch('https://api.elitefitness.it/api/products');
                if (productResponse.ok) {
                    const products = await productResponse.json();
                    this.selectedProduct = products.find((p) => p.name.includes("Fitness Lover"));

                    // Filtro per verificare se this.selectedProduct.variations[].active è true
                    if (this.selectedProduct.variations) {
                        this.selectedProduct.variations = this.selectedProduct.variations.filter(v => v.active === true);
                    }

                    if (this.selectedProduct)
                        this.selectedProductId = this.selectedProduct.id;
                    else this.productNotFound = true;

                    // Il parametro URL vale solo se corrisponde davvero a una variazione di questo
                    // prodotto. Se non corrisponde -- nome inesistente, spazi o maiuscole diverse,
                    // valore non stringa -- viene scartato in silenzio e si prosegue come se non
                    // fosse stato passato: chi sta pagando non deve vedere un errore per un
                    // parametro che non ha scritto lui.
                    const variationFromCatalog = resolveVariationFromCatalog(
                        this.selectedProduct.variations, variationFromUrl);
                    if (variationFromCatalog) {
                        this.selectedVariation = variationFromCatalog;
                        this.selectedVariationName = variationFromCatalog.variationName;
                        // Anche la variante arrivata dal link decide se l'iscrizione è inclusa (devops #292).
                        this.aggiornaVarianteAnnuale();
                        this.applySmartOfferFromUrl(variationFromCatalog);
                    }

                    // La condizione guarda l'esito della risoluzione e non la presenza del parametro:
                    // altrimenti un parametro sbagliato lascerebbe il checkout senza variazione
                    // selezionata proprio quando ce n'e' una sola possibile.
                    if (!variationFromCatalog && this.selectedProduct.variations && this.selectedProduct.variations.length === 1) {
                        this.selectVariation(this.selectedProduct.variations[0]);
                    }

                    if (this.discountCode) {
                        this.applyDiscount();
                    }
                }
            }

            this.productDefaultPrice = this.selectedProduct?.price || 0; // Imposta il prezzo di default del prodotto

            if (this.selectedProduct && this.selectedProduct.serviceId)
                this.fetchServiceById(this.selectedProduct.serviceId);

            console.log("Variazioni prodotto:", this.selectedProduct?.variations);

            // Controlla se il prodotto ha variazioni
            if ((this.selectedProduct.type === 'GYM' ||
                this.selectedProduct.type === 'COURSE' ||
                this.selectedProduct.type === 'ENTRY_PACK' ||
                this.selectedProduct.type === 'NUTRITION' ||
                this.selectedProduct.type === 'MEDICAL_CERTIFICATE' ||
                this.selectedProduct.type === 'GIFT_CARD')
                && this.selectedProduct.variations && this.selectedProduct.variations.length > 0) {
                this.hasVariations = true;
                this.showVariationStep = true;


            } else {
                // Non ci sono variazioni o il prodotto non è di tipo GYM o COURSE
                this.hasVariations = false;
                this.showVariationStep = false;
                this.finalPrice = this.selectedProduct.price;  // Usa il prezzo del prodotto
                // Vai allo step di accesso se non loggato, al pagamento se loggato
                this.step = this.userLogged ? 3 : 2;
                this.$nextTick(() => this.scrollToStep(this.step));
            }

            // Verifica se l'utente è loggato per mostrare iscrizione e tesseramento in upsell
            if (this.userLogged) {
                // Fetch stato dei constraints utente solo se loggato
                const constraintsResponse = await fetch('https://api.elitefitness.it/api/users/constraints', {
                    headers: {
                        Authorization: `Bearer ${this.userToken}`,
                    },
                });
                if (constraintsResponse.ok) {
                    const constraints = await constraintsResponse.json();
                    // Do not require registration/insurance upsell if product/service requests to skip it
                    this.requiresRegistration = (!constraints.registrationInsurance) && !this.skipInsuranceActive;
                    this.requiresMembership = !constraints.membershipCard;

                    if (this.requiresRegistration) {
                        const registrationProductResponse = await fetch('https://api.elitefitness.it/api/products/672cdc7b078175c5932ae517');
                        if (registrationProductResponse.ok) {
                            this.registrationProduct = await registrationProductResponse.json();
                        }
                    }

                    if (this.requiresMembership) {
                        const membershipProductResponse = await fetch('https://api.elitefitness.it/api/products/672cdc7b078175c5932ae518');
                        if (membershipProductResponse.ok) {
                            this.membershipProduct = await membershipProductResponse.json();
                        }
                    }

                    const stopngoProductResponse = await fetch('https://api.elitefitness.it/api/products/67404798180f654c79a1286b');
                    if (stopngoProductResponse.ok) {
                        this.stopngoProduct = await stopngoProductResponse.json();
                        this.updateStopAndGoVariation();
                    }

                } else {
                    console.error('Failed to fetch user constraints');
                }
            } else {
                // Utente non loggato: imposta di default registrazione solo se non è attivo skipInsurance
                this.requiresRegistration = !this.skipInsuranceActive;
                this.requiresMembership = true;

                // Recupera i prodotti di registrazione e tesseramento
                const registrationProductResponse = await fetch('https://api.elitefitness.it/api/products/672cdc7b078175c5932ae517');
                if (registrationProductResponse.ok) {
                    this.registrationProduct = await registrationProductResponse.json();
                }

                const membershipProductResponse = await fetch('https://api.elitefitness.it/api/products/672cdc7b078175c5932ae518');
                if (membershipProductResponse.ok) {
                    this.membershipProduct = await membershipProductResponse.json();
                }

                const stopngoProductResponse = await fetch('https://api.elitefitness.it/api/products/67404798180f654c79a1286b');
                if (stopngoProductResponse.ok) {
                    this.stopngoProduct = await stopngoProductResponse.json();
                    this.updateStopAndGoVariation();
                }
            }

            const biaProductResponse = await fetch('https://api.elitefitness.it/api/products/0e296747-8d6d-4197-9cff-0cd1f683df29');
            if (biaProductResponse.ok) {
                this.biaProduct = await biaProductResponse.json();
                this.biaDefaultPrice = this.biaProduct?.price || 0; // Imposta il prezzo di default
                console.log(this.biaProduct?.price);
            }

            const targetProductResponse = await fetch('https://api.elitefitness.it/api/products/676fea0ddc015ecc671bfd31');
            if (targetProductResponse.ok) {
                this.targetProduct = await targetProductResponse.json();
                this.targetDefaultPrice = this.targetProduct?.price || 0; // Imposta il prezzo di default
                console.log(this.targetProduct?.price);
            }

            // Precision Training: id del prodotto in produzione, come gli altri upsell qui sopra
            const precisionProductResponse = await fetch('https://api.elitefitness.it/api/products/6a033e50902a8e3d7d40b296');
            if (precisionProductResponse.ok) {
                this.precisionProduct = await precisionProductResponse.json();
            }

            const personalProductResponse = await fetch('https://api.elitefitness.it/api/products/676fea0ddc015ecc671bfd32');
            if (personalProductResponse.ok) {
                this.personalProduct = await personalProductResponse.json();
                this.personalDefaultPrice = this.personalProduct?.price || 0; // Imposta il prezzo di default
                console.log(this.personalProduct?.price);
                this.ensurePersonalUpsellVariationName();
                // Come per variationName: se il parametro non risolve su una variazione reale si
                // tiene quella già scelta da ensurePersonalUpsellVariationName(), in silenzio.
                const puv = resolveVariationFromCatalog(
                    this.personalProduct?.variations, this.$route.query?.personalUpsellVariation);
                if (puv) this.selectedPersonalUpsellVariationName = puv.variationName;
                if (this.selectedPersonalUpsellTrainerId) {
                    this.updatePricesByTrainerInfo(this.selectedPersonalUpsellTrainerId);
                }
            }

            // Recupera i centri
            const centersResponse = await fetch('https://api.elitefitness.it/api/open/centers');
            if (centersResponse.ok) {
                this.centers = [...(await centersResponse.json())];
                console.log("Centri recuperati:", this.centers);
                this.applyCenterPriceOverrides();
            } else {
                console.error("Errore durante il recupero dei centri:", centersResponse.status);
            }

            // Rinnovo/Upgrade Smart dal banner della Member App (devops#466): la durata arriva dall'URL senza passare
            // da selectVariation, che è l'unico punto che chiedeva l'anteprima. Qui socio, prodotto, durata e sedi sono
            // pronti: si chiede subito al server il prezzo dell'iniziativa, o il checkout mostrerebbe il listino.
            this.refreshInitiatives();

            // Recupera i trainer (con prezzi custom da API open, funziona anche senza login)
            const trainersResponse = await fetch('https://api.elitefitness.it/api/open/trainer');
            const customPricesResponse = await fetch('https://api.elitefitness.it/api/open/trainerInfo/custom-prices');
            if (trainersResponse.ok) {
                this.trainers = await trainersResponse.json();
                console.log("Trainer recuperati:", this.trainers);
            }
            if (customPricesResponse.ok) {
                this.trainerCustomPrices = await customPricesResponse.json();
                console.log("Prezzi custom trainer:", this.trainerCustomPrices);
            }
            if (trainersResponse.ok || customPricesResponse.ok) {
                // Usa trainerCustomPrices per i dropdown se disponibili, altrimenti trainers
                const trainersForCheckout = this.trainerCustomPrices.length > 0 ? this.trainerCustomPrices : this.trainers;
                if (trainersForCheckout.length > 0) {
                    try {
                        if (this.selectedBIATrainerId) {
                            this.updatePricesByTrainerInfo(this.selectedBIATrainerId);
                        }
                        if (this.selectedTargetTrainerId) {
                            this.updatePricesByTrainerInfo(this.selectedTargetTrainerId);
                        }
                        if (this.selectedPersonalTrainerId) {
                            this.updatePricesByTrainerInfo(this.selectedPersonalTrainerId);
                        }
                    } catch (e) {
                        console.warn('Impossibile applicare i prezzi custom dai trainer selezionati via URL:', e);
                    }
                }
            }
            if (!trainersResponse.ok && !customPricesResponse.ok) {
                console.error("Errore durante il recupero dei trainer:", trainersResponse.status);
            }

            // Verifica se il prodotto è di tipo SERVICE e ha un parentServiceId
            console.log('Selected Product: ', this.selectedProduct);
            if ((this.selectedProduct.type === 'GYM' ||
                this.selectedProduct.type === 'COURSE') && this.selectedProduct.serviceId) {
                const parentServiceId = this.selectedService.parentServiceId;

                if (parentServiceId && parentServiceId.length > 0) {

                    // Dipendenza ingressi: se attiva sul servizio, la dipendenza è
                    // soddisfatta anche con almeno un ingresso residuo utilizzabile
                    const entriesCheckEnabled = this.selectedService.parentServiceEntriesCheck === true;

                    // Verifica se l'utente ha già il servizio obbligatorio.
                    // Default conservativo: su qualunque errore (rete, body non-JSON,
                    // risposta non-ok) la dipendenza resta NON soddisfatta e l'upsell
                    // obbligatorio viene mostrato.
                    let dependencySatisfied = false;
                    try {
                        const hasSubscription = await fetch(`https://api.elitefitness.it/api/subscriptions/has/${parentServiceId}${entriesCheckEnabled ? '?includeEntries=true' : ''}`, {
                            headers: {
                                Authorization: `Bearer ${this.userToken}`,
                            },
                        });

                        if (hasSubscription.ok) {
                            const hasSubscriptionResponse = await hasSubscription.json();
                            console.log(hasSubscriptionResponse);
                            dependencySatisfied = hasSubscriptionResponse.hasSubscription === true ||
                                (entriesCheckEnabled && hasSubscriptionResponse.hasUsableEntries === true);
                        }
                    } catch (error) {
                        console.error('Errore verifica dipendenza servizio padre:', error);
                    }
                    this.requiresMandatoryUpsell = !dependencySatisfied;
                    this.requiresMandatoryUpsell = this.bypassMandatory ? false : this.requiresMandatoryUpsell;

                    // Recupera il servizio obbligatorio
                    const serviceResponse = await fetch(`https://api.elitefitness.it/api/open/services/${parentServiceId}`);
                    this.mandatoryService = serviceResponse.ok ? await serviceResponse.json() : null;

                    // Recupera il prodotto obbligatorio
                    productResponse = await fetch('https://api.elitefitness.it/api/products');
                    const products = await productResponse.json();

                    this.mandatoryProduct = products.find((p) => p.serviceId == parentServiceId);

                    // Dipendenza ingressi: il Pacchetto Ingressi è offerto come alternativa
                    // all'abbonamento solo se il flag è attivo e il padre è la Sala Pesi
                    // (gli EntriesPack globali soddisfano solo dipendenze FITNESS_LOVER)
                    if (entriesCheckEnabled && this.mandatoryService?.gymServiceType === 'FITNESS_LOVER') {
                        this.mandatoryEntryPackProduct = products.find((p) => p.type === 'ENTRY_PACK' && p.enable !== false
                            && Array.isArray(p.variations) && p.variations.some(v => v.active === true)) || null;
                    }

                    // If URL specified a mandatoryProductId/mandatoryVariation, restore
                    // choice and variation now that products are available
                    const mandatoryProductIdParam = this.$route.query?.mandatoryProductId;
                    if (mandatoryProductIdParam && this.mandatoryEntryPackProduct &&
                        mandatoryProductIdParam === this.mandatoryEntryPackProduct.id) {
                        this.mandatoryChoice = 'entries';
                    }
                    // Solo fra le variazioni attive: una variazione disattivata non è acquistabile,
                    // quindi un parametro che la nomina va scartato come un nome inesistente.
                    const mandatoryVar = resolveVariationFromCatalog(
                        (this.activeMandatoryProduct?.variations || []).filter(v => v.active === true),
                        this.$route.query?.mandatoryVariation);
                    if (mandatoryVar) this.selectedMandatoryVariation = mandatoryVar;

                }
            }

        } catch (error) {
            console.error('Error initializing PaymentComponent:', error);
        }
    },


    computed: {
        // Trainer con prezzi custom per dropdown (Nome • prezzo €)
        trainersForCheckout() {
            return this.trainerCustomPrices?.length > 0 ? this.trainerCustomPrices : this.trainers;
        },
        // Wallet computed properties
        walletAmountToUse() {
            if (!this.useWalletCredit || this.walletBalance <= 0) return 0;
            const total = this.selectedVariationPrice?.total || 0;
            return Math.min(this.walletBalance, total);
        },
        remainingAfterWallet() {
            if (!this.useWalletCredit || this.walletBalance <= 0) return this.selectedVariationPrice?.total || 0;
            const total = this.selectedVariationPrice?.total || 0;
            return Math.max(0, total - this.walletBalance);
        },
        walletCoversFullAmount() {
            if (!this.useWalletCredit || this.walletBalance <= 0) return false;
            const total = this.selectedVariationPrice?.total || 0;
            return this.walletBalance >= total;
        },
        // True se un codice promo valido fornisce giorni gratuiti extra (>0)
        promoFreeDaysApplied() {
            return !!this.promoCode && typeof this.promoFreeDays === 'number' && this.promoFreeDays > 0;
        },
        // True se un codice promo valido fornisce mesi omaggio (>0)
        promoFreeMonthsApplied() {
            return !!this.promoCode && typeof this.promoFreeMonths === 'number' && this.promoFreeMonths > 0;
        },
        // Il codice concede un omaggio sulla durata, con o senza sconto sul prezzo: un codice a soli
        // giorni/mesi omaggio ha sconto 0 e non deve per questo restare invisibile nel riepilogo.
        promoHasGift() {
            return this.promoFreeDaysApplied || this.promoFreeMonthsApplied;
        },
        // Treat service.enable=false as disabled checkout
        isServiceDisabled() {
            try {
                // If service info is loaded and has enable flag set to false, consider disabled
                if (this.selectedService && typeof this.selectedService.enable === 'boolean') {
                    return this.selectedService.enable === false;
                }
                return false;
            } catch (e) { return false; }
        },
        isMinor() {
            const dob = this.user?.dateOfBirth;
            if (!dob) return false;
            try {
                const birth = new Date(dob);
                if (isNaN(birth.getTime())) return false;
                const today = new Date();
                let age = today.getFullYear() - birth.getFullYear();
                const m = today.getMonth() - birth.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
                    age--;
                }
                return age < 18;
            } catch (e) {
                return false;
            }
        },
        
        // Verifica se la nazione selezionata è Italia
        isItaly() {
            return this.user.country === 'Italy' || this.user.country === 'Italia';
        },
        
        // Nome del paese selezionato per il display
        selectedCountryName() {
            if (this.user.country) {
                return this.user.country;
            }
            return '';
        },
        
        // Data minima per la selezione (domani) - formato stringa per input HTML5
        minStartDate() {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return tomorrow.toISOString().split('T')[0];
        },
        // Data minima come oggetto Date per Datepicker
        minStartDateObject() {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0);
            return tomorrow;
        },
        // Filtra i paesi in base alla ricerca
        filteredCountries() {
            if (!this.countrySearchQuery || this.countrySearchQuery.trim() === '') {
                return this.allCountries;
            }
            const query = this.countrySearchQuery.toLowerCase().trim();
            return this.allCountries.filter(country => 
                country.name.toLowerCase().includes(query)
            );
        },
        hideDetails() {
            return this.selectedProduct?.type == 'BIA' || this.selectedProduct?.type == 'NUTRITION' || this.selectedProduct?.type == 'MEDICAL_CERTIFICATE';
        },
        isGiftCard() {
            return this.selectedProduct?.type === 'GIFT_CARD';
        },
        allowStartDate() {
            return this.selectedProduct?.type === 'GYM'
                || this.selectedProduct?.type === 'COURSE'
                || this.productIsPersonal;
        },
        /** Elite Personal o Precision Training (stesso checkout, prezzo trainer da campo diverso). */
        productIsPersonal() {
            const t = this.selectedProduct?.metadata?.type;
            return t === 'PERSONAL_TRAINING' || t === 'PRECISION_TRAINING';
        },
        productIsPrecisionMain() {
            return this.selectedProduct?.metadata?.type === 'PRECISION_TRAINING';
        },
        /** Scheda standalone: in panoramica non mostrare "fra X giorni" sulla durata rinnovo. */
        checkoutOverviewShowsRenewalInDays() {
            const t = this.selectedProduct?.metadata?.type;
            if (t === 'TARGET_TRAINING' || t === 'PRECISION_TRAINING') {
                return false;
            }
            return true;
        },
        productIsTarget() {
            return this.selectedProduct?.metadata?.type == 'TARGET_TRAINING';
        },
        productIsFitnessLover() {
            return this.selectedProduct?.type === 'GYM' && this.selectedProduct?.metadata?.type === 'FITNESS_LOVER';
        },
        isFollowPaidListPromo() {
            return this.promoCode?.accessPolicy === 'FOLLOW_PAID_LIST';
        },
        biaUpsellEnabled() {
            return this.selectedService?.bia || this.selectedProduct?.metadata?.bia;
        },
        // Checkout veloce (#374): acceso a build-time; kiosk e prodotto Assicurazione restano sul flusso di sempre.
        quickCheckoutActive() {
            return QUICK_CHECKOUT && !this.quickCheckoutUnavailable && !this.isKiosk
                && this.selectedProduct?.type !== 'REGISTRATION';
        },
        targetUpsellEnabled() {
            return this.selectedService?.targetTraining;
        },
        personalUpsellEnabled() {
            if (this.productIsPersonal || !this.personalProduct) return false;
            return !!(this.selectedService?.personalTraining || this.selectedProduct?.metadata?.personalTraining);
        },
        precisionUpsellEnabled() {
            if (this.productIsPrecisionMain || !this.precisionProduct) return false;
            return !!(this.selectedService?.precisionTraining || this.selectedProduct?.metadata?.precisionTraining);
        },
        // If either product or service has skipInsurance=true, we must not add the registration/insurance upsell
        skipInsuranceActive() {
            try {
                const productFlag = this.selectedProduct?.skipInsurance === true;
                const serviceFlag = this.selectedService?.skipInsurance === true;
                return !!(productFlag || serviceFlag);
            } catch (e) { return false; }
        },
        /**
         * Prezzi mostrati nel riepilogo. Passano tutti da `prezzoUpsellScontato`, che è
         * la stessa funzione usata dal calcolo del totale: se divergessero, il socio
         * leggerebbe una cifra e ne pagherebbe un'altra (devops #147).
         */
        biaPacks() {
            return biaPacksFromProduct(this.biaProduct);
        },
        selectedBiaPack() {
            return findBiaPack(this.biaPacks, this.selectedBiaPackName);
        },
        biaBasePriceValue() {
            return biaBasePrice(this.selectedBiaPack, this.biaProduct?.price);
        },
        biaSummaryLabelValue() {
            return biaSummaryLabel(this.selectedBiaPack);
        },
        biaDisplayPrice() {
            if (!this.requiresBIA) return 0;
            return prezzoUpsellScontato(this.biaBasePriceValue, this.upsellsDiscountEff, 'bia');
        },
        /**
         * Iscrizione e assicurazione. Il totale azzera questa quota per le variazioni
         * annuali e per i Pacchetti Ingressi, dove è compresa: qui si replicano le
         * stesse condizioni, così la riga non annuncia un importo che nessuno addebita.
         * In quei casi il riepilogo mostra il badge «Inclusa» al posto del prezzo.
         */
        upsellsDiscountEff() {
            return upsellsDiscountEffettivo(this.promoCode);
        },
        registrationDisplayPrice() {
            if (!this.requiresRegistration || this.skipInsuranceActive) return 0;
            if (this.selectedProduct?.type === 'REGISTRATION' || this.annualVariation
                || this.selectedProduct?.type === 'ENTRY_PACK') return 0;
            if (this.selectedProduct?.type === 'MEDICAL_CERTIFICATE' || this.selectedProduct?.type === 'NUTRITION') return 0;
            return prezzoUpsellScontato(this.registrationProduct?.price, this.upsellsDiscountEff, 'registration');
        },
        membershipDisplayPrice() {
            if (!this.requiresMembership) return 0;
            if (this.selectedProduct?.type === 'REGISTRATION' || this.selectedProduct?.type === 'ENTRY_PACK') return 0;
            if (this.selectedProduct?.type === 'MEDICAL_CERTIFICATE' || this.selectedProduct?.type === 'NUTRITION') return 0;
            return prezzoUpsellScontato(this.membershipProduct?.price, this.upsellsDiscountEff, 'membership');
        },
        targetPacks() {
            return orderablePacks(this.targetPacksRaw, this.targetProduct);
        },
        selectedTargetPack() {
            return findTargetPack(this.targetPacks, this.selectedTargetPackCode);
        },
        targetBasePriceValue() {
            return targetBasePrice(this.selectedTargetPack, this.targetProduct?.price);
        },
        targetSummaryLabel() {
            return targetPackSummaryLabel(this.selectedTargetPack);
        },
        targetDisplayPrice() {
            if (!this.requiresTarget) return 0;
            if (this.isFreeTargetUpsell) return 0;
            return prezzoUpsellScontato(this.targetBasePriceValue, this.upsellsDiscountEff, 'targetTraining');
        },
        /**
         * Prezzo pieno: `upsellsDiscount` non ha un campo per il Precision Training e il
         * ramo PRECISION_TRAINING di OrderService non ne applica nessuno, quindi scontarlo
         * qui mostrerebbe meno di quanto il server addebita. La regola sta in
         * `UPSELL_SENZA_SCONTO` dentro upsellPrices.js, non qui: se un giorno il server
         * inizierà a scontarlo, va tolta da quella lista e questo prezzo seguirà.
         */
        precisionDisplayPrice() {
            if (!this.requiresPrecision) return 0;
            return prezzoUpsellScontato(this.precisionProduct?.price, this.upsellsDiscountEff, 'precisionTraining');
        },
        personalDisplayPrice() {
            if (!this.requiresPersonal) return 0;
            const vars = this.personalProduct?.variations || [];
            const v = vars.find(x => x.variationName === this.selectedPersonalUpsellVariationName);
            const price = v?.price ?? this.personalProduct?.price ?? 0;
            return prezzoUpsellScontato(price, this.upsellsDiscountEff, 'personalTraining');
        },
        /** Prodotto dell'opzione scelta per l'upsell obbligatorio:
         * abbonamento al servizio padre oppure Pacchetto Ingressi. */
        activeMandatoryProduct() {
            return (this.mandatoryChoice === 'entries' && this.mandatoryEntryPackProduct)
                ? this.mandatoryEntryPackProduct
                : this.mandatoryProduct;
        },
        mandatoryDisplayPrice() {
            if (!this.requiresMandatoryUpsell) return 0;
            if (this.selectedMandatoryVariation?.price) return this.selectedMandatoryVariation.price;
            // Con variazioni attive il prezzo dipende dalla scelta: niente fallback al
            // prezzo base del prodotto, che mostrerebbe un importo fuorviante
            const hasActiveVariations = this.activeMandatoryProduct?.variations?.some(v => v.active === true);
            return hasActiveVariations ? 0 : (this.activeMandatoryProduct?.price || 0);
        },
        /**
         * Etichetta e testo di aiuto del pulsante della prova gratuita, in base al passo che
         * manca davvero (devops #316). La decisione sta in un modulo a parte perché è l'unica
         * parte nuova che si possa verificare senza montare il componente.
         */
        freeTrialCta() {
            return freeTrialCtaState({
                userLogged: this.userLogged,
                hasAcceptedTerms: this.hasAcceptedTerms,
                soldOut: this.remainingCount != null && this.remainingCount == 0,
            });
        },
        enablePaymentButton() {
            console.log("userLogged:", this.userLogged);
            console.log("freeTrial:", this.freeTrial);
            console.log("requiresBIA:", this.requiresBIA);
            console.log("requiresTarget:", this.requiresTarget);
            console.log("selectedBIATrainerId:", this.selectedBIATrainerId);
            console.log("requiresMandatoryUpsell:", this.requiresMandatoryUpsell);
            console.log("selectedMandatoryVariation:", this.selectedMandatoryVariation);
            console.log("remainingCount:", this.remainingCount);
            console.log("isPaymentReady:", this.isPaymentReady);

            if (!this.hasAcceptedTerms) {
                return false;
            }

            // #113: nessun metodo preselezionato — finché il socio non sceglie come pagare la
            // conferma resta disabilitata. Gli ordini gratuiti (free trial, wallet che copre tutto,
            // importo zero) non richiedono un metodo e restano abilitati.
            const freeCheckout = this.freeTrial
                || this.isFreeOrder
                || (this.walletCoversFullAmount && this.useWalletCredit);
            if (!freeCheckout && !this.selectedPayment) {
                return false;
            }

            if (this.userLogged) {
                if (this.freeTrial) {
                    return true;
                }
                if (this.requiresBIA && !this.selectedBIATrainerId) {
                    return false;
                }
                if (this.requiresTarget && !this.isFreeTargetUpsell && !this.selectedTargetTrainerId) {
                    return false;
                }
                if (this.requiresPrecision && !this.selectedPrecisionUpsellTrainerId) {
                    return false;
                }
                if (this.requiresPersonal && !this.selectedPersonalUpsellTrainerId) {
                    return false;
                }
                // If the main product is Target Training, force trainer selection as mandatory
                if (this.productIsTarget && !this.selectedTargetTrainerId) {
                    return false;
                }
                if (this.productIsPersonal && !this.selectedPersonalTrainerId) {
                    return false;
                }
                if (this.requiresMandatoryUpsell && this.requiresMandatoryUpsell && !this.selectedMandatoryVariation) {
                    return false;
                }
                if (this.remainingCount != null && this.remainingCount == 0) {
                    return false;
                }
                return this.isPaymentReady;
            }
            return false;
        },
        centerDescription() {
            // Se i dati non sono ancora caricati
            if (!this.selectedService || !this.centers.length) {
                return "tutti i centri";
            }

            // FOLLOW_PAID_LIST separa il listino dal perimetro di accesso:
            // l'ordine concede tutti i centri del servizio anche quando il
            // prezzo è stato calcolato sul listino di una sola sede.
            if (this.isFollowPaidListPromo) {
                return "tutti i centri";
            }

            // Una sede scelta esplicitamente vince su qualsiasi elenco: e' il
            // centro in cui l'utente ha appena accettato di allenarsi.
            if (this.selectedCenterId && String(this.selectedCenterId).trim()) {
                const chosen = this.centers.find(
                    c => String(c.id ?? '') === String(this.selectedCenterId).trim()
                );
                if (chosen) return chosen.name;
            }

            // Se il promo limita i centri, mostra solo quelli
            if (this.promoAllowedCenters && this.promoAllowedCenters.length) {
                const map = new Map(this.centers.map(c => [c.id?.toString(), c.name]));
                const names = this.promoAllowedCenters.map(id => map.get(id.toString())).filter(n => !!n);
                return names.length ? names.join(", ") : "";
            }

            // Assicurati di avere sempre un array di centri associati
            const serviceCenters = Array.isArray(this.selectedService.centersId)
                ? this.selectedService.centersId.map(id => id.toString())
                : [];

            // Crea un array con gli ID di tutti i centri fetchati (normalizzati a stringhe)
            const allCenterIds = this.centers.map(center => center.id.toString());

            console.log(allCenterIds);
            console.log(serviceCenters);

            // Se il numero di centri associati è uguale al numero totale di centri, restituisci "tutti i centri"
            if (serviceCenters.length === allCenterIds.length) {
                return "tutti i centri";
            } else {
                // Altrimenti, filtra i centri fetchati e prendi quelli associati
                const associatedCenters = this.centers
                    .filter(center => serviceCenters.includes(center.id.toString()))
                    .map(center => center.name);
                return associatedCenters.join(", ");
            }
        },
        /**
         * Vero quando la quota d'iscrizione NON viene addebitata, quindi va
         * dichiarata "Inclusa" invece che barrata.
         *
         * Rispecchia esattamente le condizioni con cui `selectedVariationPrice`
         * azzera `regFee` (vedi il calcolo di regFee piu' sotto): il template
         * ne considerava solo due su quattro, quindi per un prodotto REGISTRATION
         * o per i tipi MEDICAL_CERTIFICATE / NUTRITION mostrava un importo che
         * il totale non conteggiava.
         */
        showUpgradeProposal() {
            // Dal banner si compra esattamente la durata della card: nessuna proposta di cambiarla.
            if (this.smartOffer) return false;
            return shouldShowUpgrade(this.upgradeProposal, this.upgradeProposalDismissed, this.selectedProduct?.variations);
        },
        smartPromoNote() {
            const label = INITIATIVE_LABELS[this.initiativePreview?.initiative] || 'questa promozione';
            return `Hai già il prezzo ${label}: i codici sconto non sono cumulabili con questa promozione.`;
        },
        /** Rinnovo/Upgrade Smart sulla scelta corrente: niente codici sconto (devops#466). */
        smartExcludesPromo() {
            return smartExcludesPromo(this.initiativePreview, this.selectedVariationName, this.selectedCenterId);
        },
        initiativeNote() {
            const price = previewPriceFor(this.initiativePreview, this.selectedVariationName, this.selectedCenterId, !!this.promoCode);
            if (price === null) return null;
            return {
                label: INITIATIVE_LABELS[this.initiativePreview.initiative] || 'Offerta',
                price,
                list: Number(this.initiativePreview.listPrice),
            };
        },
        registrationFeeIncluded() {
            const t = this.selectedProduct?.type;
            if (t === 'REGISTRATION' || t === 'MEDICAL_CERTIFICATE' || t === 'NUTRITION') return true;
            if (t === 'ENTRY_PACK') return true;
            return !!this.annualVariation;
        },
        selectedVariationPrice() {
            if (!this.selectedProduct) return { total: 0, discount: 0 };

            let mandatoryUpsell = 0;
            if (this.requiresMandatoryUpsell) {
                // Stessa logica di mandatoryDisplayPrice: con variazioni attive il prezzo
                // entra nel totale solo dopo la scelta della variazione
                mandatoryUpsell = this.mandatoryDisplayPrice;
            }

            if (this.selectedProduct?.variations) {
                // Trova la variazione selezionata del prodotto principale
                const variation = this.selectedProduct.variations.find(
                    variation => variation.variationName === this.selectedVariationName
                );

                // Calcola il prezzo totale con le variazioni
                // For REGISTRATION products, do not add any extra fees or upsells
                const isRegistration = this.selectedProduct?.type === 'REGISTRATION';
                let regFee = (!isRegistration && !this.annualVariation && this.selectedProduct.type !== 'ENTRY_PACK' && this.requiresRegistration && !this.skipInsuranceActive && this.registrationProduct?.price) ? this.registrationProduct.price : 0;
                let membFee = (!isRegistration && this.selectedProduct.type !== 'ENTRY_PACK' && this.requiresMembership && this.membershipProduct?.price) ? this.membershipProduct.price : 0;

                if (this.selectedProduct?.type == 'MEDICAL_CERTIFICATE' || this.selectedProduct?.type == 'NUTRITION') {
                    regFee = 0;
                    membFee = 0;
                }

                let stopAndGoPrice = (!isRegistration && this.requiresStopAndGo) ? (this.selectedStopAndGoVariation?.price || 0) : 0;

                let biaPrice = (!isRegistration && this.requiresBIA) ? this.biaBasePriceValue : 0;
                let targetPrice = (!isRegistration && this.requiresTarget) 
                    ? (this.isFreeTargetUpsell ? 0 : this.targetBasePriceValue) 
                    : 0;
                // Precision Training: prezzo flat, nessuno sconto upsell (il server non ne applica)
                let precisionPrice = (!isRegistration && this.requiresPrecision && this.precisionProduct)
                    ? (this.precisionProduct.price || 0)
                    : 0;
                let personalPrice = 0;
                if (!isRegistration && this.requiresPersonal && this.personalProduct) {
                    const vars = this.personalProduct.variations || [];
                    const pv = vars.find(x => x.variationName === this.selectedPersonalUpsellVariationName);
                    personalPrice = pv?.price ?? this.personalProduct.price ?? 0;
                }

                let productPrice = variation?.price || 0;
                // Iniziativa commerciale (Rinnovo/Upgrade Smart): prezzo deciso dal server per QUESTA durata e sede.
                // Con un codice promozionale vince il codice (non cumulabilità per ordine).
                const initiativePrice = previewPriceFor(this.initiativePreview, this.selectedVariationName,
                    this.selectedCenterId, !!this.promoCode);
                if (initiativePrice !== null) productPrice = initiativePrice;

                let discountAmount = 0;

                // Applica sconti upsell se presenti
                if (!isRegistration && this.promoCode && this.upsellsDiscountEff) {
                    const u = this.upsellsDiscountEff;
                    if (u.applyToRegistration) {
                        const res = this.computeDiscounted(regFee, Number(u.registrationDiscount || 0), (u.registrationPercentage === true));
                        regFee = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToMembership) {
                        const res = this.computeDiscounted(membFee, Number(u.membershipDiscount || 0), (u.membershipPercentage === true));
                        membFee = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToBIA) {
                        const res = this.computeDiscounted(biaPrice, Number(u.biaDiscount || 0), (u.biaPercentage === true));
                        biaPrice = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToStopAndGo) {
                        const res = this.computeDiscounted(stopAndGoPrice, Number(u.stopAndGoDiscount || 0), (u.stopAndGoPercentage === true || u.stopngoPercentage === true));
                        stopAndGoPrice = res.after; discountAmount += res.discount;
                    }
                    // Target training upsell
                    if (u.applyToTarget || u.applyToTargetTraining) {
                        const disc = (u.targetDiscount ?? u.targetTrainingDiscount) || 0;
                        const pct = (u.targetPercentage === true) || (u.targetTrainingPercentage === true);
                        const res = this.computeDiscounted(targetPrice, Number(disc), pct);
                        targetPrice = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToPersonalTraining) {
                        const res = this.computeDiscounted(personalPrice, Number(u.personalTrainingDiscount || 0), u.personalTrainingPercentage === true);
                        personalPrice = res.after; discountAmount += res.discount;
                    }
                }

                // Sconto sul prodotto principale: stessa formula usata dalle card delle durate, così il
                // riepilogo e la card non possono raccontare due prezzi diversi per la stessa variazione.
                if (this.promoCode) {
                    const offerta = this.variationOffer(variation);
                    productPrice = offerta.scontato;
                    discountAmount += offerta.sconto;
                }

                // Calcola il prezzo totale includendo sempre gli upsell obbligatori
                // Anche se il prodotto principale è gratuito (sconto 100%), gli upsell devono essere inclusi
                const total = productPrice + regFee + membFee + stopAndGoPrice + biaPrice + mandatoryUpsell + targetPrice + personalPrice + precisionPrice;

                // Ritorna il prezzo totale
                return {
                    total: total,
                    discount: discountAmount,
                };

            } else {
                // Nessuna variazione
                let productPrice = this.selectedProduct?.price || 0;
                let discountAmount = 0;

                // Calcola gli upsell obbligatori anche per prodotti senza variazioni
                const isRegistration = this.selectedProduct?.type === 'REGISTRATION';
                let regFee = (!isRegistration && this.requiresRegistration && !this.skipInsuranceActive && this.registrationProduct?.price) ? this.registrationProduct.price : 0;
                let membFee = (!isRegistration && this.requiresMembership && this.membershipProduct?.price) ? this.membershipProduct.price : 0;

                if (this.selectedProduct?.type == 'MEDICAL_CERTIFICATE' || this.selectedProduct?.type == 'NUTRITION') {
                    regFee = 0;
                    membFee = 0;
                }

                let stopAndGoPrice = (!isRegistration && this.requiresStopAndGo) ? (this.selectedStopAndGoVariation?.price || 0) : 0;
                let biaPrice = (!isRegistration && this.requiresBIA) ? this.biaBasePriceValue : 0;
                let targetPrice = (!isRegistration && this.requiresTarget) 
                    ? (this.isFreeTargetUpsell ? 0 : this.targetBasePriceValue) 
                    : 0;
                // Precision Training: prezzo flat, nessuno sconto upsell (il server non ne applica)
                let precisionPrice = (!isRegistration && this.requiresPrecision && this.precisionProduct)
                    ? (this.precisionProduct.price || 0)
                    : 0;
                let personalPrice = 0;
                if (!isRegistration && this.requiresPersonal && this.personalProduct) {
                    const vars = this.personalProduct.variations || [];
                    const pv = vars.find(x => x.variationName === this.selectedPersonalUpsellVariationName);
                    personalPrice = pv?.price ?? this.personalProduct.price ?? 0;
                }

                // Applica sconti upsell se presenti
                if (this.promoCode && this.upsellsDiscountEff) {
                    const u = this.upsellsDiscountEff;
                    if (u.applyToRegistration) {
                        const res = this.computeDiscounted(regFee, Number(u.registrationDiscount || 0), (u.registrationPercentage === true));
                        regFee = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToMembership) {
                        const res = this.computeDiscounted(membFee, Number(u.membershipDiscount || 0), (u.membershipPercentage === true));
                        membFee = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToBIA) {
                        const res = this.computeDiscounted(biaPrice, Number(u.biaDiscount || 0), (u.biaPercentage === true));
                        biaPrice = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToStopAndGo) {
                        const res = this.computeDiscounted(stopAndGoPrice, Number(u.stopAndGoDiscount || 0), (u.stopAndGoPercentage === true || u.stopngoPercentage === true));
                        stopAndGoPrice = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToTarget || u.applyToTargetTraining) {
                        const disc = (u.targetDiscount ?? u.targetTrainingDiscount) || 0;
                        const pct = (u.targetPercentage === true) || (u.targetTrainingPercentage === true);
                        const res = this.computeDiscounted(targetPrice, Number(disc), pct);
                        targetPrice = res.after; discountAmount += res.discount;
                    }
                    if (u.applyToPersonalTraining) {
                        const res = this.computeDiscounted(personalPrice, Number(u.personalTrainingDiscount || 0), u.personalTrainingPercentage === true);
                        personalPrice = res.after; discountAmount += res.discount;
                    }
                }

                // Applica sconto sul prodotto principale (anche se upsellsDiscount è null)
                if (this.promoCode && this.promoCode.discountAmount) {
                    if (this.promoCode.percentage) {
                        const productDiscount = (this.promoCode.discountAmount / 100) * (productPrice || 0);
                        productPrice = Math.max(0, productPrice - productDiscount);
                        discountAmount += productDiscount;
                    } else {
                        productPrice = Math.max(0, (productPrice || 0) - this.promoCode.discountAmount);
                        discountAmount += this.promoCode.discountAmount;
                    }
                }

                // Calcola il totale includendo sempre gli upsell obbligatori
                const total = productPrice + regFee + membFee + stopAndGoPrice + biaPrice + mandatoryUpsell + targetPrice + personalPrice + precisionPrice;

                return {
                    total: total,
                    discount: discountAmount
                }
            }
        },
        isFreeOrder() {
            // Verifica se l'ordine è gratuito (totale = 0)
            return this.selectedVariationPrice.total === 0;
        },
        paypalInstallmentMessage() {
            const total = this.selectedVariationPrice?.total || 0;
            if (total < 60) {
                return "Puoi scegliere di pagare subito o in 3 rate";
            } else {
                return "Puoi scegliere di pagare subito o in 3, 6, 12 e 24 rate";
            }
        },
        entryPeriod() {
            const variations = this.selectedProduct?.variations || [];
            const variation = variations.find(v => v.variationName === this.selectedVariationName);
            const duration = variation?.attributes?.duration;
            return (duration != null) ? `${duration} ingressi` : null;
        },
        renewalPeriod() {
            const variations = this.selectedProduct?.variations || [];
            const variation = variations.find(v => v.variationName === this.selectedVariationName);
            const duration = variation?.attributes?.duration;
            return (duration != null) ? `${duration} giorni` : null;
        },

        getDuration() {
            const variations = this.selectedProduct?.variations || [];
            const variation = variations.find(v => v.variationName === this.selectedVariationName);
            return variation?.attributes?.duration ?? null;
        },

        hasAcceptedTerms() {
            return this.acceptTerms && this.acceptPrivacyPolicy && this.acceptRegulation && this.acceptMedicalCertDeclaration && this.acceptIdentityDocsDeclaration;
        },

        hasAcceptedTermsSignup() {
            return this.acceptTermsSignup && this.acceptPrivacyPolicySignup && this.acceptRegulationSignup && this.acceptMedicalCertDeclarationSignup && this.acceptIdentityDocsDeclarationSignup;
        },
        // Names of variations allowed by promo for current product, per rules:
        // - If promo.variations missing key for productId => all variations allowed
        // - If key exists and list empty => all allowed
        // - Else only listed variation names are allowed
        /** Le durate su cui vale il codice applicato. Senza codice sono tutte. */
        durateInOfferta() {
            const tutte = this.selectedProduct?.variations || [];
            if (this.smartOffer && this.smartOfferVariationName) {
                const sola = tutte.filter(v => v.variationName === this.smartOfferVariationName);
                if (sola.length) return sola;
            }
            if (!this.promoCode) return tutte;
            return tutte.filter(v => this.isVariationAllowed(v.variationName));
        },
        /** Le durate acquistabili ma fuori dall'offerta: restano comprabili, a prezzo di listino. */
        durateFuoriOfferta() {
            const tutte = this.selectedProduct?.variations || [];
            if (this.smartOffer && this.smartOfferVariationName) return [];
            if (!this.promoCode) return [];
            return tutte.filter(v => !this.isVariationAllowed(v.variationName));
        },
        hasDurateFuoriOfferta() {
            return this.durateFuoriOfferta.length > 0;
        },
        allowedVariationNames() {
            try {
                const allNames = (this.selectedProduct?.variations || []).map(v => v.variationName);
                if (!this.promoCode || !this.promoCode.variations) return allNames;
                const productId = this.selectedProductId || this.selectedProduct?.id;
                if (!productId) return allNames;
                const map = this.promoCode.variations || {};
                const entry = map[productId] || map[String(productId)] || map[productId?.toString?.()] || null;
                if (!entry || entry.length === 0) return allNames;
                // Intersezione con confronto normalizzato: nei dati reali convivono "Annuale" e "Annuale "
                // con lo spazio finale, e un includes() letterale nasconderebbe una durata che il server
                // considera ammessa — il socio vedrebbe sparire proprio l'abbonamento in offerta.
                const normalized = entry.map(n => String(n).trim().toLowerCase());
                return allNames.filter(name => normalized.includes(String(name).trim().toLowerCase()));
            } catch (e) {
                return (this.selectedProduct?.variations || []).map(v => v.variationName);
            }
        }
    },
    watch: {
        // Rinnovo/Upgrade Smart non si sommano a un codice (devops#466): se il prezzo Smart arriva quando un codice è
        // già applicato (per esempio dall'URL), il codice si toglie. Il server non lo applicherebbe comunque.
        smartExcludesPromo(excluded) {
            if (excluded && (this.promoCode || this.discountCode)) {
                this.removeDiscount();
                this.discountError = null;
            }
        },
        // Enforce variation restrictions when a promo is set/changed
        promoCode(newVal) {
            if (newVal) {
                this.enforceVariationRulesAfterPromo();
            }
            this.applyCenterPriceOverrides();
            // If we are on payment step, refresh Stripe totals (Payment Request)
            this.updateStripeTotalsIfReady();
        },
        // Mentre si scrive il campo non cancella più nulla di visibile: toglie solo spazi e
        // caratteri invisibili (tipici di un incolla da WhatsApp) e porta in minuscolo, che è la
        // forma in cui i codici sono salvati. Punto, virgola e trattino restano sotto gli occhi
        // di chi li ha digitati (devops #333).
        discountCode(newVal) {
            const norm = normalizePromoCode(newVal);
            if (newVal !== norm) this.discountCode = norm;
        },
        // Refresh Stripe totals whenever the computed total changes
        'selectedVariationPrice.total': function () {
            this.updateStripeTotalsIfReady();
        },
        useWalletCredit() {
            this.updateStripeTotalsIfReady();
        },
        walletBalance() {
            this.updateStripeTotalsIfReady();
        },
        centers: {
            handler(newVal) {
                console.log("centers aggiornato:", newVal);
                if (newVal?.length && this.selectedCenterId) {
                    this.applyFreeTargetUpsellForCenter(this.selectedCenterId);
                }
            },
            deep: true
        },
        selectedService: {
            handler(newVal) {
                console.log("selectedService aggiornato:", newVal);
                try {
                    if (this.skipInsuranceActive && this.requiresRegistration) {
                        this.requiresRegistration = false;
                        // optional: clear loaded registration product to avoid adding it elsewhere
                        // this.registrationProduct = null;
                    }
                } catch (e) { /* no-op */ }
            },
            deep: true
        },
        // Sincronizza customStartDateObject quando customStartDate viene impostato come stringa
        customStartDate(newVal) {
            if (newVal && typeof newVal === 'string') {
                // Converti stringa YYYY-MM-DD in Date per il Datepicker
                const date = new Date(newVal + 'T00:00:00');
                if (!isNaN(date.getTime())) {
                    this.customStartDateObject = date;
                }
            } else if (!newVal) {
                this.customStartDateObject = null;
            }
        },
        // Enforce REGISTRATION constraints whenever product changes
        selectedProduct(newVal) {
            if (newVal && newVal.type === 'REGISTRATION') {
                // Force-off free trial and any upsell flags
                if (this.freeTrial) this.freeTrial = false;
                this.requiresBIA = false;
                this.requiresTarget = false;
                this.requiresPersonal = false;
                this.requiresPrecision = false;
                this.requiresStopAndGo = false;
                this.requiresMandatoryUpsell = false;
                this.selectedMandatoryVariation = null;
                this.mandatoryChoice = 'subscription';
                this.mandatoryEntryPackProduct = null;
                // Hide registration form UI on step 2 for REGISTRATION products
                this.showRegistrationForm = false;
            }
            // Reset centro se il prodotto non è Fitness Lover
            if (newVal && !(newVal.type === 'GYM' && newVal.metadata?.type === 'FITNESS_LOVER')) {
                this.selectedCenterId = '';
                this.pricingCenterId = '';
                this.isFreeTargetUpsell = false;
            }
            // Prodotto e centri arrivano da chiamate distinte: chi vince la corsa
            // non deve cambiare il prezzo mostrato.
            this.applyCenterPriceOverrides();
        },
        mandatoryProduct() {
            this.applyCenterPriceOverrides();
        },
        mandatoryEntryPackProduct() {
            this.applyCenterPriceOverrides();
        },
        selectedCenterId(newVal) {
            this.loadTargetPacks();
            this.syncUrl?.();
            this.applyCenterPriceOverrides();
            this.applyFreeTargetUpsellForCenter(newVal);
            this.recheckPromoForCenter(newVal);
        },
        pricingCenterId() {
            this.applyCenterPriceOverrides();
        },
        
        // ✅ AGGIUNTO: Watcher per i termini (step 2 - registrazione)
        hasAcceptedTermsSignup(newValue) {
            if (newValue && this.step === 2 && this.showRegistrationForm) {
                // Prima di abilitare definitivamente la registrazione, mostra riepilogo conferma
                const riepilogo = `<ul style='text-align:left;line-height:1.5;padding-left:18px;'>`
                  + `<li>Accetto Termini e Condizioni</li>`
                  + `<li>Ho letto e accetto l'Informativa Privacy</li>`
                  + `<li>Accetto il Regolamento Interno</li>`
                  + `<li>Ho letto e accetto il Codice Etico</li>`
                  + `<li>Confermo di aver preso visione della dichiarazione relativa ai documenti di identità</li>`
                  + `</ul>`;
                Swal.fire({
                    title: 'Confermi tutte le dichiarazioni?',
                    html: `<div style='text-align:left;font-size:15px;'>Stai per procedere alla registrazione avendo dichiarato e accettato quanto segue:${riepilogo}<p style='margin-top:8px;'>Confermi?</p></div>`,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Conferma',
                    cancelButtonText: 'Annulla',
                    reverseButtons: true,
                    focusCancel: true,
                    customClass: {
                        confirmButton: 'swal-stopgo-confirm',
                        cancelButton: 'swal-stopgo-cancel',
                        actions: 'swal-stopgo-actions'
                    },
                    buttonsStyling: false
                }).then(res => {
                    if (res.isConfirmed) {
                        // Conferma: le checkbox rimangono spuntate
                    } else {
                        // Reset di tutte le checkbox termini (signup section)
                        this.acceptTermsSignup = false;
                        this.acceptPrivacyPolicySignup = false;
                        this.acceptRegulationSignup = false;
                        this.acceptMedicalCertDeclarationSignup = false;
                        this.acceptIdentityDocsDeclarationSignup = false;
                    }
                });
            }
        },
        // ✅ AGGIUNTO: Watcher per i termini (step 3 - pagamento)
        hasAcceptedTerms(newValue) {
            if (newValue && this.step === 3) {
                // Prima di abilitare definitivamente il pagamento, mostra riepilogo conferma
                const riepilogo = `<ul style='text-align:left;line-height:1.5;padding-left:18px;'>`
                  + `<li>Accetto Termini e Condizioni</li>`
                  + `<li>Ho letto e accetto l'Informativa Privacy</li>`
                  + `<li>Accetto il Regolamento Interno</li>`
                  + `<li>Ho letto e accetto il Codice Etico</li>`
                  + `<li>Confermo di aver preso visione della dichiarazione relativa ai documenti di identità</li>`
                  + `</ul>`;
                Swal.fire({
                    title: 'Confermi tutte le dichiarazioni?',
                    html: `<div style='text-align:left;font-size:15px;'>Stai per procedere al pagamento avendo dichiarato e accettato quanto segue:${riepilogo}<p style='margin-top:8px;'>Confermi?</p></div>`,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Conferma',
                    cancelButtonText: 'Annulla',
                    reverseButtons: true,
                    focusCancel: true,
                    customClass: {
                        confirmButton: 'swal-stopgo-confirm',
                        cancelButton: 'swal-stopgo-cancel',
                        actions: 'swal-stopgo-actions'
                    },
                    buttonsStyling: false
                }).then(res => {
                    if (res.isConfirmed) {
                        this.$nextTick(() => {
                            if (this.selectedPayment === 'CARD') {
                                this.initializeStripeElements();
                            }
                            this.isPaymentReady = true;
                        });
                    } else {
                        // Reset di tutte le checkbox termini (payment section)
                        this.acceptTerms = false;
                        this.acceptPrivacyPolicy = false;
                        this.acceptRegulation = false;
                        this.acceptMedicalCertDeclaration = false;
                        this.acceptIdentityDocsDeclaration = false;
                        this.isPaymentReady = false;
                    }
                });
            } else {
                this.isPaymentReady = false;
            }
    },
        // Keep URL in sync when trainer selections or mandatory variation change via v-model
        selectedBIATrainerId(newVal) {
            this.syncUrl?.();
            if (newVal) this.updatePricesByTrainerInfo(newVal);
        },
        selectedTargetTrainerId(newVal) {
            this.syncUrl?.();
            if (newVal) this.updatePricesByTrainerInfo(newVal);
            this.loadTargetPacks();
        },
        targetPacks(list) {
            this.selectedTargetPackCode = keepTargetPack(list, this.selectedTargetPackCode);
        },
        selectedPersonalTrainerId(newVal) {
            this.syncUrl?.();
            if (newVal) this.updatePricesByTrainerInfo(newVal);
        },
        selectedPersonalUpsellTrainerId(newVal) {
            this.syncUrl?.();
            if (newVal) this.updatePricesByTrainerInfo(newVal);
        },
        selectedPersonalUpsellVariationName() {
            this.syncUrl?.();
        },
        personalUpsellEnabled(val) {
            if (!val) this.requiresPersonal = false;
        },
        selectedPrecisionUpsellTrainerId(newVal) {
            this.syncUrl?.();
            if (newVal) this.updatePricesByTrainerInfo(newVal);
        },
        /* Se l'upsell smette di essere applicabile — cambio sede o servizio — la spunta va tolta,
           o resterebbe selezionato un prodotto che non compare più. */
        precisionUpsellEnabled(val) {
            if (!val) this.requiresPrecision = false;
        },
        selectedMandatoryVariation() {
            // Variazione diversa = payload diverso: la Idempotency-Key va rigenerata
            // per non riusare un PaymentIntent creato con l'importo precedente
            this.checkoutIdempotencyKey = null;
            this.syncUrl?.();
        },
        // Keep Stop & Go variation aligned with the main selection in all cases
        selectedVariationName() {
            this.updateStopAndGoVariation();
        },
        requiresStopAndGo() {
            this.updateStopAndGoVariation();
        },
        stopngoProduct() {
            this.updateStopAndGoVariation();
        }
    },
    methods: {
        /** Cambia l'opzione dell'upsell obbligatorio (abbonamento | pacchetto ingressi).
         * La scelta attiva non è deselezionabile: l'obbligo resta sempre soddisfatto
         * da una delle due opzioni. Al cambio si azzera la variazione selezionata. */
        setMandatoryChoice(choice, event) {
            if (this.mandatoryChoice === choice) {
                // Click sull'opzione già attiva: ripristina lo stato visivo del checkbox
                // (il binding :checked non cambia, quindi Vue non lo ri-renderizza)
                if (event?.target) event.target.checked = true;
                return;
            }
            this.mandatoryChoice = choice;
            this.selectedMandatoryVariation = null;
            // Il payload di pagamento cambia: nuova Idempotency-Key, altrimenti un retry
            // dopo un tentativo fallito riuserebbe il PaymentIntent della scelta precedente
            this.checkoutIdempotencyKey = null;
            // Persisti la scelta nell'URL (il watcher sulla variazione non scatta su null→null)
            this.syncUrl?.();
        },
        // Load wallet balance for the logged in user
        async loadWalletBalance() {
            if (!this.userToken) return;
            
            this.walletLoading = true;
            try {
                const response = await fetch('https://api.elitefitness.it/api/invite-friend/wallet', {
                    headers: {
                        Authorization: `Bearer ${this.userToken}`,
                    },
                });
                
                if (response.ok) {
                    const data = await response.json();
                    this.walletBalance = data.balance || 0;
                    console.log('Wallet balance loaded:', this.walletBalance);
                } else {
                    console.warn('Failed to load wallet balance');
                    this.walletBalance = 0;
                }
            } catch (error) {
                console.error('Error loading wallet balance:', error);
                this.walletBalance = 0;
            } finally {
                this.walletLoading = false;
            }
        },
        // La regola sta in un posto solo: vedi utils/promoCode.js per quali caratteri il campo
        // toglie (solo gli invisibili) e perché il resto — trattino, punto, virgola — deve passare.
        sanitizePromoCode(value) {
            return normalizePromoCode(value);
        },
        // Sync Stop & Go variation with the selected product variation (by name, then by duration)
        updateStopAndGoVariation() {
            try {
                if (!this.requiresStopAndGo) {
                    this.selectedStopAndGoVariation = null;
                    return;
                }
                const vars = this.stopngoProduct?.variations || [];
                if (!vars.length) return;

                const name = this.selectedVariationName;
                const selectedVar = this.selectedVariation;

                // Prefer exact name match
                let match = vars.find(v => v?.variationName === name);
                // Fallback by equal duration
                if (!match && selectedVar?.attributes?.duration != null) {
                    const dur = selectedVar.attributes.duration;
                    match = vars.find(v => v?.attributes?.duration === dur);
                }
                this.selectedStopAndGoVariation = match || null;
            } catch (e) {
                console.warn('Errore sync variazione Stop & Go:', e);
            }
        },
        // Build a canonical checkout query with all current selections
        buildCheckoutQuery() {
            try {
                // Build upsells summary as comma-separated product IDs for resiliency
                const upsells = [];
                if (!this.skipInsuranceActive && this.requiresRegistration && this.registrationProduct && this.annualVariation == false && this.selectedProduct?.type !== 'ENTRY_PACK') upsells.push(this.registrationProduct.id);
                if (this.requiresMembership && this.membershipProduct && this.selectedProduct?.type !== 'ENTRY_PACK') upsells.push(this.membershipProduct.id);
                if (this.requiresStopAndGo && this.stopngoProduct) upsells.push(this.stopngoProduct.id);
                if (this.requiresBIA && this.biaProduct) upsells.push(this.biaProduct.id);
                if (this.requiresMandatoryUpsell && this.activeMandatoryProduct) upsells.push(this.activeMandatoryProduct.id);
                if (this.requiresTarget && this.targetProduct) upsells.push(this.targetProduct.id);
                if (this.requiresPersonal && this.personalProduct) upsells.push(this.personalProduct.id);
                if (this.requiresPrecision && this.precisionProduct) upsells.push(this.precisionProduct.id);

                const q = {
                    action: 'checkout',
                    productId: this.selectedProductId || this.selectedProduct?.id || undefined,
                    variationName: this.selectedVariationName || undefined,
                    discountCode: this.sanitizePromoCode(this.discountCode) || undefined,
                    ref: this.referralCode || undefined, // Usa "ref" per coerenza con il link generato dal backend
                    bypm: this.bypassMandatory ? 'true' : undefined,
                    freeTrial: this.freeTrial ? 'true' : undefined,
                    gift: this.isGiftMode ? 'true' : undefined,
                    // Trainer selections
                    biaTrainerId: this.selectedBIATrainerId || undefined,
                    targetTrainerId: this.selectedTargetTrainerId || undefined,
                    personalTrainerId: this.selectedPersonalTrainerId || undefined,
                    centerId: this.isFollowPaidListPromo ? undefined : (this.selectedCenterId || undefined),
                    // Il checkout del banner Rinnovo/Upgrade Smart resta tale anche dopo un ricarico (devops#466).
                    smartOffer: this.smartOffer || undefined,
                    // Upsell toggles and mandatory selection
                    requiresBIA: this.requiresBIA ? 'true' : undefined,
                    requiresTarget: this.requiresTarget ? 'true' : undefined,
                    requiresPersonal: this.requiresPersonal ? 'true' : undefined,
                    requiresPrecision: this.requiresPrecision ? 'true' : undefined,
                    precisionTrainerId: this.selectedPrecisionUpsellTrainerId || undefined,
                    personalUpsellTrainerId: this.selectedPersonalUpsellTrainerId || undefined,
                    personalUpsellVariation: this.selectedPersonalUpsellVariationName || undefined,
                    requiresStopAndGo: this.requiresStopAndGo ? 'true' : undefined,
                    requiresMembership: this.requiresMembership ? 'true' : undefined,
                    requiresRegistration: (!this.skipInsuranceActive && this.requiresRegistration) ? 'true' : undefined,
                    mandatoryProductId: (this.activeMandatoryProduct && this.requiresMandatoryUpsell) ? this.activeMandatoryProduct.id : undefined,
                    mandatoryVariation: this.selectedMandatoryVariation?.variationName || undefined,
                    // Summarized upsells list
                    upsells: upsells.length ? upsells.join(',') : undefined,
                };
                // Remove null/undefined/empty
                Object.keys(q).forEach(k => {
                    const v = q[k];
                    if (v === undefined || v === null || v === '') delete q[k];
                });
                return q;
            } catch (e) {
                console.error('Errore nella build dei parametri URL:', e);
                return {};
            }
        },
        // Build full encoded return URL for login/registration forward
        buildReturnUrl() {
            const basePath = '/checkout';
            const params = new URLSearchParams(this.buildCheckoutQuery()).toString();
            return `${basePath}${params ? '?' + params : ''}`;
        },
        // Sync current state into the URL while staying on /checkout
        syncUrl() {
            const query = this.buildCheckoutQuery();
            this.$router.replace({ path: '/checkout', query });
        },
        // Router-link helper for login
        getLoginLink() {
            return { name: 'login', query: { returnUrl: encodeURIComponent(this.buildReturnUrl()) } };
        },
        /**
         * Al totem: manda alla schermata di attesa che mostra il QR di
         * registrazione. Il carrello viaggia in returnUrl, così al rientro (con
         * il socio autenticato) il checkout riparte esattamente da dov'era.
         */
        startKioskRegistration() {
            this.$router.push({
                path: '/kiosk-wait',
                query: {
                    returnUrl: encodeURIComponent(this.buildReturnUrl()),
                    productId: this.selectedProductId || this.selectedProduct?.id || undefined,
                    variationName: this.selectedVariationName || undefined,
                    promoCode: this.sanitizePromoCode(this.discountCode) || undefined,
                },
            });
        },
        // Update Stripe Payment Request total if initialized and on payment step
        updateStripeTotalsIfReady() {
            try {
                const onPaymentStep = this.step === 3 || (this.isGiftMode && this.step === 4);
                if (onPaymentStep && this.paymentRequest) {
                    // Allineato a remainingAfterWallet: Apple/Google Pay deve mostrare l'importo
                    // effettivamente addebitato (dopo credito Wallet), come il backend con useWalletCredit.
                    const amountCents = Math.round(this.remainingAfterWallet * 100);
                    this.paymentRequest.update({
                        total: { label: 'Pagamento', amount: amountCents }
                    });
                }
            } catch (e) {
                console.warn('Impossibile aggiornare il totale Stripe:', e);
            }
        },
        scrollToStep(stepNumber) {
            this.$nextTick(() => {
                // Scegli il contenitore step e preferisci l'header per allineare meglio la vista
                let el = document.getElementById(`step-${stepNumber}`);
                if (!el && stepNumber === 1) {
                    // Caso selezione BIA che ha id diverso
                    el = document.getElementById('step-1-bia');
                }
                if (!el) return;

                const header = el.querySelector('.step-header') || el;
                const rect = header.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const offset = 80; // margine per fissare il titolo sotto eventuale navbar
                const top = rect.top + scrollTop - offset;
                window.scrollTo({ top, behavior: 'smooth' });
            });
        },
        toggleMobileSummary() {
            this.isMobileSummaryOpen = !this.isMobileSummaryOpen;
        },
        openDescription(description) {
            Swal.fire({
                title: 'Descrizione del servizio',
                text: description,
                icon: 'info',
                confirmButtonText: 'Chiudi',
                showCancelButton: false,
                customClass: {
                    popup: 'swal2-popup',
                    title: 'swal2-title',
                    content: 'swal2-content',
                    confirmButton: 'swal2-confirm'
                }
            })
        },
        async fetchRemainingCount(serviceId) {
            try {
                const response = await fetch(`https://api.elitefitness.it/api/open/subscriptions/course/${serviceId}/count/remaining`);
                const data = await response.json();
                this.remainingCount = data.count;
            } catch (error) {
                console.error('Error fetching remaining count:', error);
            }
        },
        goToStep1() {
            this.step = 1;
            this.scrollToStep(1);
        },
        // Metodi per gestire la selezione della data di inizio.
        // La rimozione della data usa la X nativa del Datepicker (clearable), che emette
        // update:model-value(null) e passa di qui: non serve un pulsante di reset esterno (#118).
        onStartDateChange(date) {
            if (date) {
                // Verifica che la data sia nel futuro
                const selectedDate = date instanceof Date ? date : new Date(date);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                selectedDate.setHours(0, 0, 0, 0);
                
                // Verifica che sia almeno domani
                const tomorrow = new Date(today);
                tomorrow.setDate(tomorrow.getDate() + 1);
                
                if (selectedDate < tomorrow) {
                    alert('La data di inizio deve essere almeno domani');
                    this.customStartDate = null;
                    this.customStartDateObject = null;
                } else {
                    // Converti Date in formato YYYY-MM-DD per il backend
                    const year = selectedDate.getFullYear();
                    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
                    const day = selectedDate.getDate().toString().padStart(2, '0');
                    this.customStartDate = `${year}-${month}-${day}`;
                    // Mantieni anche l'oggetto Date per il Datepicker
                    this.customStartDateObject = selectedDate;
                }
            } else {
                this.customStartDate = null;
                this.customStartDateObject = null;
            }
        },
        formatStartDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        onStopAndGoChange(newValue) {
            // Conferma attivazione/disattivazione Stop & Go
            // Se si sta tentando di attivare il servizio (newValue = true), mostra una conferma
            if (newValue) {
                Swal.fire({
                    title: 'Sei sicuro di voler attivare il servizio Stop&Go?',
              html: `<div style="text-align:left;font-size:15px;line-height:1.45;">` +
                  `<p style="margin:0 0 14px 0;">Il servizio <strong>Stop&Go</strong> ti permette di bloccare temporaneamente l'abbonamento. Può essere utilizzato solo una volta durante tutta la durata dell'abbonamento. Dopo il blocco, deve passare almeno una settimana per riattivarlo.</p>` +
                  `<p style="margin:0;"><strong>Nota:</strong> il servizio è <strong>a pagamento</strong> e il costo viene mostrato nel riepilogo dell'ordine.</p>` +
                  `</div>`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Conferma',
                    cancelButtonText: 'Annulla',
                    reverseButtons: true,
                    focusCancel: true,
                    customClass: {
                        confirmButton: 'swal-stopgo-confirm',
                        cancelButton: 'swal-stopgo-cancel',
                        actions: 'swal-stopgo-actions',
                        popup: 'swal-stopgo-popup'
                    },
                    buttonsStyling: false
                }).then(result => {
                    if (result.isConfirmed) {
                        this.requiresStopAndGo = true;
                        this.resetDiscountCode();
                        this.syncUrl();
                    } else {
                        // Annullato: assicurati che la checkbox rimanga non selezionata
                        this.requiresStopAndGo = false;
                        // Forza l'aggiornamento UI (se necessario)
                        this.$forceUpdate?.();
                    }
                });
            } else {
                // Disattivazione senza conferma
                this.requiresStopAndGo = false;
                this.resetDiscountCode();
                this.syncUrl();
            }
        },
        onBIAUpsell(newValue) {
            if (this.selectedVariation?.attributes?.mandatoryBia) {
                this.requiresBIA = true;
            }
            else {
                this.requiresBIA = newValue; // Aggiorna lo stato di Stop and Go
                this.resetDiscountCode(); // Resetta il codice sconto
            }
            this.syncUrl();
        },
        // Listino pacchetti Target Training per il trainer scelto (#212). Qualunque esito diverso da un elenco
        // valido lascia il checkout com'era: nessun pacchetto, prezzo singolo.
        async loadTargetPacks() {
            const trainerId = this.selectedTargetTrainerId;
            if (!trainerId) { this.targetPacksRaw = []; return; }
            try {
                const qs = new URLSearchParams({ trainerId });
                if (this.selectedCenterId) qs.set('centerId', this.selectedCenterId);
                const res = await fetch(`https://api.elitefitness.it/api/open/target-training-packs?${qs}`);
                const body = res.ok ? await res.json() : null;
                if (trainerId !== this.selectedTargetTrainerId) return; // risposta superata da un cambio trainer
                this.targetPacksRaw = packsFromResponse(body);
            } catch (e) {
                if (trainerId === this.selectedTargetTrainerId) this.targetPacksRaw = [];
            }
        },
        onTargetUpsell(newValue) {
            if (this.isFreeTargetUpsell) return; // Non permettere di deselezionare se è free target
            this.requiresTarget = newValue;
            this.resetDiscountCode();
            this.syncUrl();
        },
        onPersonalUpsell(newValue) {
            this.requiresPersonal = newValue;
            if (newValue) {
                this.ensurePersonalUpsellVariationName();
                if (this.selectedPersonalUpsellTrainerId) {
                    this.updatePricesByTrainerInfo(this.selectedPersonalUpsellTrainerId);
                }
            }
            this.resetDiscountCode();
            this.syncUrl();
        },
        onPrecisionUpsell(newValue) {
            this.requiresPrecision = newValue;
            if (newValue && this.selectedPrecisionUpsellTrainerId) {
                this.updatePricesByTrainerInfo(this.selectedPrecisionUpsellTrainerId);
            }
            this.resetDiscountCode();
            this.syncUrl();
        },
        onPersonalUpsellVariationChange() {
            this.resetDiscountCode();
            this.syncUrl();
            if (this.selectedPersonalUpsellTrainerId) {
                this.updatePricesByTrainerInfo(this.selectedPersonalUpsellTrainerId);
            }
        },
        ensurePersonalUpsellVariationName() {
            if (!this.personalProduct?.variations?.length) return;
            const active = this.personalProduct.variations.filter(v => v.active !== false);
            const list = active.length ? active : this.personalProduct.variations;
            // Il valore corrente può venire dalla query string: si risolve sul catalogo e si tiene
            // il nome canonico. Con un confronto letterale una variazione scritta con uno spazio
            // in coda risulterebbe assente e verrebbe sostituita dalla prima della lista, cioè si
            // cambierebbe in silenzio la scelta di chi ha aperto il link.
            const corrente = resolveVariationFromCatalog(list, this.selectedPersonalUpsellVariationName);
            this.selectedPersonalUpsellVariationName = corrente
                ? corrente.variationName
                : list[0].variationName;
        },
        /**
         * Il backend, alla creazione dell'ordine, sostituisce il prezzo della
         * variazione con l'override del centro (OrderService.handleOrder, chiave
         * = variationName). Il checkout leggeva solo il listino di prodotto, quindi
         * mostrava una cifra e ne addebitava un'altra. Qui riallineiamo cio' che si
         * vede a cio' che si paga, applicando la stessa identica regola.
         *
         * Il prezzo di listino resta salvato in `basePrice`: cambiando centro si
         * torna al valore originale invece di trascinarsi dietro l'override
         * del centro precedente.
         */
        /**
         * Il centro non e' una preferenza: vincola dove ci si potra' allenare.
         * La conferma arriva prima dell'assegnazione, e su "Annulla" il select
         * torna al valore precedente invece di restare su una scelta mai voluta.
         */
        async onCenterSelectChange(event) {
            const chosenId = event?.target?.value ?? '';
            if (chosenId === this.selectedCenterId) return;

            // Tornare a "Tutti" non toglie accesso a nulla: nessun avviso.
            if (!chosenId) {
                this.selectedCenterId = '';
                this.refreshInitiatives();
                return;
            }

            const center = (this.centers || []).find(c => String(c.id ?? '') === String(chosenId));
            const centerName = center
                ? center.name
                : 'questo centro';

            const result = await Swal.fire({
                icon: 'warning',
                title: 'Attenzione',
                html: `Scegliendo <b>${centerName}</b> potrai allenarti <b>soltanto in questa sede</b>.`
                    + `<br><br>Il tuo abbonamento non dar\u00e0 accesso agli altri centri Elite Fitness.`,
                showCancelButton: true,
                confirmButtonText: 'Conferma',
                cancelButtonText: 'Annulla',
                reverseButtons: true,
                buttonsStyling: false,
                allowOutsideClick: false,
                customClass: {
                    confirmButton: 'swal2-confirm',
                    cancelButton: 'swal2-cancel'
                }
            });

            if (result.isConfirmed) {
                this.selectedCenterId = chosenId;
                this.refreshInitiatives();
            } else {
                // Il DOM ha gia' il nuovo valore ma il dato no: Vue non
                // rigenererebbe il select, quindi lo riallineiamo a mano.
                event.target.value = this.selectedCenterId;
            }
        },
        /**
         * Iniziative commerciali (#210/#211/#230). Chiede al server (1) il prezzo che l'ordine applicherà per la
         * durata e la sede scelte e (2) se proporre una durata superiore. Mai bloccante: qualunque errore lascia il
         * listino e nessuna proposta. Solo per chi è loggato, su abbonamenti di sala e senza codice promozionale.
         */
        /** `smartOffer=RINNOVO_SMART|UPGRADE_SMART` dal banner della Member App: la durata dell'URL è l'unica in vista. */
        applySmartOfferFromUrl(variation) {
            const so = String(this.$route.query?.smartOffer || '').trim().toUpperCase();
            if ((so === 'RINNOVO_SMART' || so === 'UPGRADE_SMART') && variation) {
                this.smartOffer = so;
                this.smartOfferVariationName = variation.variationName;
            }
        },
        async refreshInitiatives() {
            const seq = ++this.initiativeSeq;
            this.initiativePreview = null;
            this.upgradeProposal = null;
            try {
                // Anche con un codice: Rinnovo e Upgrade Smart vincono sul codice (devops#466), e solo il server sa se
                // il socio ne ha diritto. Per le altre iniziative l'anteprima arriva già decisa «col codice vince il codice».
                if (!this.userLogged || !this.userToken || this.freeTrial) return;
                if (this.selectedProduct?.type !== 'GYM') return;
                const variation = this.selectedProduct?.variations?.find(v => v.variationName === this.selectedVariationName);
                if (!variation) return;
                const headers = { Authorization: `Bearer ${this.userToken}` };
                const centerId = this.selectedCenterId || '';
                const listPrice = listPriceFor(variation, this.centerPriceOverridesFor(centerId));
                const query = previewQuery({
                    productId: this.selectedProduct.id,
                    variationName: variation.variationName,
                    centerId,
                    listPrice,
                    promoCodeApplied: !!this.promoCode,
                });
                if (query) {
                    const res = await fetch(`https://api.elitefitness.it/api/commercial-initiatives/price-preview?${query}`, { headers });
                    if (res.ok && seq === this.initiativeSeq) {
                        const body = await res.json();
                        if (body && body.applied) {
                            this.initiativePreview = { ...body, variationName: variation.variationName, centerId };
                        }
                    }
                }
                // La proposta di upgrade ha senso solo con una sede (l'abbonamento e i prezzi sono per sede).
                if (centerId && !this.upgradeProposalDismissed) {
                    const url = `https://api.elitefitness.it/api/upgrade-smart/proposal?centerId=${encodeURIComponent(centerId)}&variation=${encodeURIComponent(variation.variationName)}`;
                    const res = await fetch(url, { headers });
                    if (res.ok && seq === this.initiativeSeq) {
                        this.upgradeProposal = await res.json();
                    }
                }
            } catch (e) {
                console.warn('Iniziative commerciali non disponibili:', e);
            }
        },
        async acceptUpgradeProposal() {
            const target = this.upgradeProposal?.proposedDuration;
            const variation = this.selectedProduct?.variations?.find(v => normalizeVariationName(v.variationName) === normalizeVariationName(target));
            this.markUpgradeSeen(false);
            if (variation) this.selectVariation(variation);
        },
        dismissUpgradeProposal() {
            this.upgradeProposalDismissed = true;
            this.upgradeProposal = null;
            this.markUpgradeSeen(true);
        },
        markUpgradeSeen(dismissed) {
            if (!this.userToken) return;
            fetch('https://api.elitefitness.it/api/upgrade-smart/popup-seen', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${this.userToken}` },
                body: JSON.stringify({ dismissed }),
            }).catch(() => {});
        },
        centerPriceOverridesFor(centerId) {
            if (!centerId || !String(centerId).trim()) return null;
            const target = String(centerId).trim();
            const center = (this.centers || []).find(c => String(c.id ?? '') === target);
            const overrides = center?.variationPriceOverrides;
            return overrides && Object.keys(overrides).length > 0 ? overrides : null;
        },
        promoApplicableCenterIds() {
            if (!this.isFollowPaidListPromo) return [];
            const serviceCenters = Array.isArray(this.selectedService?.centersId)
                ? this.selectedService.centersId.map(id => String(id).trim()).filter(Boolean)
                : [];
            const promoCenters = Array.isArray(this.promoCode?.filters?.centerIds)
                ? this.promoCode.filters.centerIds.map(id => String(id).trim()).filter(Boolean)
                : [];
            if (serviceCenters.length === 0) {
                return promoCenters.length === 1 ? promoCenters : [];
            }
            if (promoCenters.length === 0) return serviceCenters;
            return serviceCenters.filter(serviceId => promoCenters.some(promoId =>
                promoId.toLowerCase() === serviceId.toLowerCase()
            ));
        },
        /**
         * Listino già scelto (selettore o URL) vs listino della promo ad accesso esteso.
         * Senza scelta esplicita la promo può fissare il proprio listino; con una sede già
         * selezionata un listino diverso è un rifiuto, non uno switch di prezzo.
         */
        explicitListinoConflictsWithPromo(promo) {
            if (promo?.accessPolicy !== 'FOLLOW_PAID_LIST') return false;
            const selected = String(this.selectedCenterId || '').trim();
            if (!selected) return false;
            const promoCenters = Array.isArray(promo?.filters?.centerIds)
                ? promo.filters.centerIds.map(id => String(id).trim()).filter(Boolean)
                : [];
            const unique = [...new Set(promoCenters.map(id => id.toLowerCase()))];
            if (unique.length !== 1) return false;
            return unique[0] !== selected.toLowerCase();
        },
        toggleAllTermsSignup() {
            const next = !this.hasAcceptedTermsSignup;
            this.acceptTermsSignup = next;
            this.acceptPrivacyPolicySignup = next;
            this.acceptRegulationSignup = next;
            this.acceptMedicalCertDeclarationSignup = next;
            this.acceptIdentityDocsDeclarationSignup = next;
        },
        toggleAllTerms() {
            const next = !this.hasAcceptedTerms;
            this.acceptTerms = next;
            this.acceptPrivacyPolicy = next;
            this.acceptRegulation = next;
            this.acceptMedicalCertDeclaration = next;
            this.acceptIdentityDocsDeclaration = next;
        },
        /**
         * Gli override del centro valgono per i PIANI di accesso, non per i
         * servizi accessori: sono indicizzati per durata ("Mensile", ...) e piu'
         * prodotti usano le stesse durate. Stesso criterio di
         * OrderService.isCenterPriceOverridable, altrimenti si mostra un prezzo
         * e se ne addebita un altro.
         */
        isCenterPriceOverridable(product) {
            const t = product?.type;
            return t === 'GYM' || t === 'COURSE' || t === 'ENTRY_PACK';
        },
        applyCenterPriceOverrides() {
            const pricingCenterId = this.isFollowPaidListPromo
                ? this.pricingCenterId
                : this.selectedCenterId;
            const overrides = this.centerPriceOverridesFor(pricingCenterId);
            const products = [
                this.selectedProduct,
                this.mandatoryProduct,
                this.mandatoryEntryPackProduct,
            ];
            for (const product of products) {
                if (!product?.variations?.length) continue;
                if (!this.isCenterPriceOverridable(product)) continue;
                for (const variation of product.variations) {
                    // Il prezzo puo' essere cambiato da qualcun altro dopo l'ultimo
                    // passaggio di qui: updatePricesByTrainerInfo ci scrive il prezzo
                    // personalizzato del trainer. Se non e' il valore che avevamo
                    // lasciato noi, e' il nuovo riferimento su cui applicare
                    // l'override: rimetterci il listino cancellerebbe quel prezzo
                    // mentre il backend continua ad addebitarlo.
                    if (variation.basePrice === undefined || variation.priceSetByCenter !== variation.price) {
                        variation.basePrice = variation.price;
                    }
                    const override = overrides?.[variation.variationName];
                    variation.price = (override !== undefined && override !== null)
                        ? Number(override)
                        : variation.basePrice;
                    variation.priceSetByCenter = variation.price;
                }
            }
            // selectedVariation punta allo stesso oggetto dell'array, ma finalPrice
            // e' una copia del valore: senza questo riallineamento il totale
            // resterebbe fermo al prezzo precedente.
            if (this.selectedVariation && !this.discountCode) {
                this.finalPrice = this.selectedVariation.price;
            }
        },
        applyFreeTargetUpsellForCenter(centerId) {
            if (!this.productIsFitnessLover || !this.targetUpsellEnabled) return;
            if (!centerId || !centerId.trim()) {
                this.isFreeTargetUpsell = false;
                if (this.requiresTarget && !this.selectedTargetTrainerId) this.requiresTarget = false;
                this.resetDiscountCode();
                this.syncUrl();
                return;
            }
            const center = this.centers.find(c => (c.id?.toString() || c.id) === centerId);
            const hasFreeTarget = center && center.freeTargetEnabled === true;
            if (hasFreeTarget) {
                this.requiresTarget = true;
                this.isFreeTargetUpsell = true;
                this.selectedTargetTrainerId = null; // Trainer scelto in app
            } else {
                this.isFreeTargetUpsell = false;
                if (this.requiresTarget && !this.selectedTargetTrainerId) {
                    this.requiresTarget = false; // Era auto-selezionato, deseleziona
                }
            }
            this.resetDiscountCode();
            this.syncUrl();
        },
        resetDiscountCode() {
            // Resetta eventuali valori legati allo sconto
            this.discountAmount = 0;
            this.discountError = null;

            // Ripristina il prezzo originale della variazione selezionata
            this.finalPrice = this.selectedVariationPrice.total;

            console.log('Codice sconto resettato e finalPrice aggiornato:', this.finalPrice);
            this.syncUrl();
        },
        showToast(message, type = 'info') {
            const toast = { message, type };
            this.toasts.push(toast);
            console.log("add toast", toast);
            setTimeout(() => {
                this.toasts.splice(this.toasts.indexOf(toast), 1);
            }, 3000);
        },
        areAllCentersIncluded(serviceCenters, allCenters) {
            // Controlla se tutti i centri del servizio sono inclusi nei centri fetchati
            for (const centerId of serviceCenters) {
                if (!allCenters.has(centerId)) {
                    return false;
                }
            }
            return true;
        },
        fetchServiceById(serviceId) {
            return fetch(`https://api.elitefitness.it/api/open/services/${serviceId}`)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error(`Errore durante il recupero del servizio ${serviceId}: ${response.status}`);
                    }
                })
                .then(service => {
                    this.selectedService = service;
                    console.log("Servizio recuperato:", this.selectedService);
                })
                .catch(error => {
                    console.error(`Errore nella fetch del servizio ${serviceId}:`, error);
                });
        },

        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        checkPassword() {
            if (!this.validatePassword(this.user.password)) {
                this.passwordError = "La password deve essere lunga tra 8 e 100 caratteri e contenere almeno un numero, una lettera maiuscola, una lettera minuscola, un carattere speciale e nessuno spazio.";
            } else {
                this.passwordError = null;
            }
        },
        validatePassword(password) {
            const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
            return passwordPattern.test(password);
        },
        toggleMenu() {
            this.menuVisible = !this.menuVisible;
        },
        clearUserData() {
            localStorage.removeItem('user');
        },
        saveUserData() {
            localStorage.setItem('user', JSON.stringify(this.user));
        },
        async checkEmailExists() {
            try {
                if (!this.user.email) {
                    this.emailError = 'Inserisci un\'email valida.';
                    return;
                }

                const response = await fetch(`https://api.elitefitness.it/api/users/exists?email=${encodeURIComponent(this.user.email)}`);

                if (!response.ok) {
                    throw new Error('Errore nella verifica dell\'email');
                }

                const result = await response.json();

                // Verifica il risultato: se l'email esiste, mostra un errore
                if (result.exists) {
                    this.emailError = 'Questa email è già registrata.';
                } else {
                    this.emailError = null; // Nessun errore, email non esistente
                }
            } catch (error) {
                console.error('Errore nella verifica dell\'email:', error);
                this.emailError = 'Impossibile verificare l\'email. Riprova più tardi.';
            }
        },
        shouldApplyGuestPromoPreview() {
            return !this.userLogged
                && this.discountCodeFromUrl
                && !!this.sanitizePromoCode(this.discountCode)
                && !!this.selectedProduct?.id;
        },
        lookupGuestPromoVariationPrice(variationName) {
            if (!this.guestPromoPreviewActive || !this.guestPromoVariationPrices) return null;
            const key = normalizeVariationName(variationName);
            return key ? this.guestPromoVariationPrices[key] : null;
        },
        /**
         * Anteprima prezzi per ospiti con discountCode in URL (link comeback cb-*).
         * Usa GET /api/promo/{code} e /variations — la redenzione resta su validate dopo il login.
         */
        async applyGuestPromoPreview() {
            const sanitized = this.sanitizePromoCode(this.discountCode);
            if (!sanitized || !this.selectedProduct?.id) {
                return;
            }
            if (this.discountCode !== sanitized) this.discountCode = sanitized;

            try {
                const preview = await fetchGuestPromoPreview(sanitized, this.selectedProduct.id);
                if (!preview.ok) {
                    this.discountError = 'Codice sconto non valido o non applicabile a questo abbonamento.';
                    this.guestPromoPreviewActive = false;
                    this.guestPromoVariationPrices = null;
                    this.promoCode = null;
                    return;
                }

                const promo = preview.promo;
                if (promo.existingMembersOnly) {
                    this.discountError = 'Questa offerta è riservata ai tesserati. Effettua l\'accesso per continuare.';
                    return;
                }
                if (this.explicitListinoConflictsWithPromo(promo)) {
                    this.discountError = 'Questo codice sconto non può essere applicato su questo centro.';
                    return;
                }

                this.discountError = null;
                this.guestPromoPreviewActive = true;
                this.guestPromoVariationPrices = preview.variationPrices;
                this.promoCode = promo;

                if (promo.accessPolicy === 'FOLLOW_PAID_LIST') {
                    this.promoAllowedCenters = null;
                    await this.ensureCentersLoaded();
                    const applicableCenters = this.promoApplicableCenterIds();
                    this.pricingCenterId = applicableCenters.length === 1 ? applicableCenters[0] : '';
                    this.selectedCenterId = '';
                } else {
                    const centerIds = promo.filters?.centerIds;
                    if (Array.isArray(centerIds) && centerIds.length > 0) {
                        this.pricingCenterId = '';
                        this.promoAllowedCenters = centerIds.map(c => c.toString());
                        await this.ensureCentersLoaded();
                        if (this.promoAllowedCenters.length === 1) {
                            this.selectedCenterId = this.promoAllowedCenters[0];
                        } else if (this.selectedCenterId && !this.promoAllowedCenters.includes(String(this.selectedCenterId))) {
                            this.selectedCenterId = '';
                        }
                    } else {
                        this.promoAllowedCenters = null;
                        this.pricingCenterId = '';
                    }
                }

                this.updatePromoFreeDays();
                this.enforceVariationRulesAfterPromo();
                // Se l'URL chiedeva freeTrial, non lasciare che la promo guest l'abbia spenta
                // (selectVariation azzera freeTrial). Ripristina e togli la variation.
                if (this.$route.query?.freeTrial === 'true' && this.selectedProduct?.type !== 'REGISTRATION') {
                    this.freeTrial = true;
                    this.selectedVariationName = null;
                    this.selectedVariation = null;
                }
                this.applyCenterPriceOverrides();
                this.updateStripeTotalsIfReady();
                this.syncUrl();
            } catch (error) {
                console.error('Guest promo preview failed:', error);
                this.discountError = 'Impossibile verificare il codice sconto. Riprova più tardi.';
                this.guestPromoPreviewActive = false;
                this.guestPromoVariationPrices = null;
            }
        },
        async applyDiscount() {

            if (this.smartExcludesPromo) {
                // Codice digitato mentre vale Rinnovo/Upgrade Smart: si spiega invece di applicarlo (devops#466).
                if (this.sanitizePromoCode(this.discountCode)) {
                    this.discountError = this.smartPromoNote;
                }
                this.discountCode = '';
                return;
            }

            if (!this.userLogged) {
                if (this.shouldApplyGuestPromoPreview()) {
                    return this.applyGuestPromoPreview();
                }
                this.discountError = 'Devi essere loggato per applicare un codice sconto.';
                return;
            }

            this.guestPromoPreviewActive = false;
            this.guestPromoVariationPrices = null;

            // Sanitize and validate the discount code before sending
            const sanitized = this.sanitizePromoCode(this.discountCode);
            if (!sanitized) {
                this.discountError = 'Inserisci un codice sconto valido.';
                return;
            }
            // Normalize UI/state to the sanitized value
            if (this.discountCode !== sanitized) this.discountCode = sanitized;

            try {
                // Effettua la chiamata API per verificare il codice sconto
                const response = await this.fetchPromoValidation(sanitized, this.selectedCenterId);

                const result = await response.json();
                // Se il backend restituisce anche un referralCode associato, memorizzalo
                // MA solo se non c'è già un referralCode dalla URL iniziale (ha priorità)
                if (result && result.referralCode && !this.referralCodeFromUrl) {
                    this.referralCode = result.referralCode;
                    // Aggiorna l'URL per preservare il referral anche ricaricando la pagina
                    this.syncUrl();
                }

                const promo = result?.promoCode;

                // Gestione esito: considera sia HTTP non-OK che status logico 'error' o assenza promo
                if (!response.ok || result?.status === 'error' || !promo) {
                    this.discountError = result?.message || 'Codice sconto non valido.';
                    this.showToast(this.discountError, 'error');
                    return;
                }

                // Il selettore, prima di applicare la promo, è la scelta del listino.
                // Una promo FOLLOW_PAID_LIST apre tutti i centri ma resta sul listino del
                // suo filtro: se il socio ha già scelto un altro listino, non si sostituisce
                // il prezzo in silenzio.
                if (this.explicitListinoConflictsWithPromo(promo)) {
                    this.discountError = 'Questo codice sconto non può essere applicato su questo centro.';
                    this.showToast(this.discountError, 'error');
                    return;
                }

                this.promoCode = promo;
                // FOLLOW_PAID_LIST usa i centri della promo per scegliere il
                // listino, non per restringere gli accessi.
                if (this.isFollowPaidListPromo) {
                    this.promoAllowedCenters = null;
                    await this.ensureCentersLoaded();
                    const applicableCenters = this.promoApplicableCenterIds();
                    this.pricingCenterId = applicableCenters.length === 1 ? applicableCenters[0] : '';
                    // La promo concede tutti i centri del servizio: non lasciare
                    // nel payload il vecchio centro scelto da URL o da una sessione precedente.
                    this.selectedCenterId = '';
                // Salva eventuale restrizione centri (solo se servizio GYM)
                } else if (Array.isArray(result.allowedCenters) && result.allowedCenters.length > 0) {
                    this.pricingCenterId = '';
                    this.promoAllowedCenters = result.allowedCenters.map(c => c.toString());
                    await this.ensureCentersLoaded();
                    // Un promo con un solo centro non lascia una scelta da fare: la sede
                    // e' parte dell'offerta e va preselezionata prima di calcolare i prezzi.
                    // Se arriviamo da un link con un centro diverso, prevale il vincolo del promo.
                    if (this.promoAllowedCenters.length === 1) {
                        this.selectedCenterId = this.promoAllowedCenters[0];
                    } else if (this.selectedCenterId && !this.promoAllowedCenters.includes(String(this.selectedCenterId))) {
                        this.selectedCenterId = '';
                    }
                    const centerMap = new Map(this.centers.map(c => [c.id?.toString(), c.name]));
                    const names = this.promoAllowedCenters.map(id => centerMap.get(id)).filter(Boolean);
                    const centersString = names.join(', ');
                    console.debug('[PROMO] allowedCenters raw:', result.allowedCenters, 'names after load:', names, 'centers loaded:', this.centers.length);
                    try {
                        Swal.fire({
                            icon: 'info',
                            title: names.length > 1 ? 'Centri limitati' : 'Centro limitato',
                            html: names.length ? `Il codice promozionale è valido solo per ${names.length > 1 ? 'i centri' : 'il centro'} <b>${centersString}</b><br/>L'abbonamento sarà attivato solo lì` : 'Il codice promozionale è valido solo per alcuni centri associati al tuo abbonamento.',
                            confirmButtonText: 'OK'
                        });
                    } catch (e) { console.warn('Swal not available', e); }
                } else {
                    this.promoAllowedCenters = null;
                    this.pricingCenterId = '';
                }
                // validate() senza sede risponde valido anche quando il pagamento lo sconto
                // lo concede in una sola sede: senza questo controllo il riepilogo mostrerebbe
                // uno sconto che l'ordine poi non applica.
                this.promoDiscountCenterId = result.discountCenterId ? String(result.discountCenterId) : null;
                // Senza una sede scelta vale la stessa regola dei codici a sede unica qui sopra:
                // la sede e' parte dell'offerta e si preseleziona, dicendolo.
                if (this.promoDiscountCenterId && !String(this.selectedCenterId || '').trim()) {
                    this.selectedCenterId = this.promoDiscountCenterId;
                    await this.ensureCentersLoaded();
                    const center = this.centers.find(c => String(c.id ?? '') === this.promoDiscountCenterId);
                    try {
                        Swal.fire({
                            icon: 'info',
                            title: 'Centro limitato',
                            html: center
                                ? `Il codice promozionale è valido solo per il centro <b>${center.name}</b><br/>L'abbonamento sarà attivato solo lì`
                                : 'Il codice promozionale è valido solo per una sede, che è stata selezionata.',
                            confirmButtonText: 'OK'
                        });
                    } catch (e) { console.warn('Swal not available', e); }
                }
                const centerMismatch = this.promoCenterMismatchMessage();
                if (centerMismatch) {
                    this.suspendPromoForCenter(centerMismatch);
                    this.showToast(centerMismatch, 'error');
                    return;
                }
                this.promoSuspendedForCenter = false;
                this.discountError = null;
                this.promoValidatedCenterId = String(this.selectedCenterId || '');
                // Calcola giorni gratuiti basandosi sulle mappe per prodotto / variazione.
                this.updatePromoFreeDays();
                console.log('Promo code applicato', this.promoCode, 'freeDays=', this.promoFreeDays);

                this.showToast(result.message, 'success');

                // Enforce allowed variations after applying promo
                this.enforceVariationRulesAfterPromo();

                // Update Stripe totals if already on payment step
                this.updateStripeTotalsIfReady();
                // Update URL with discount code
                this.syncUrl();

            } catch (error) {
                this.discountError = error.message;
                this.discountAmount = 0;  // Reset dello sconto in caso di errore
                this.finalPrice = this.selectedVariationPrice.total;  // Reset del prezzo finale
                this.showToast('Errore nella verifica del codice', 'error');

            }
        },
        async ensureCentersLoaded() {
            if (this.centersLoadedAtLeastOnce && this.centers.length) return;
            if (this.centers.length) {
                this.centersLoadedAtLeastOnce = true;
                return;
            }
            try {
                const resp = await fetch('https://api.elitefitness.it/api/open/centers');
                if (resp.ok) {
                    this.centers = await resp.json();
                    this.centersLoadedAtLeastOnce = true;
                    this.applyCenterPriceOverrides();
                }
            } catch (e) {
                console.warn('Errore caricamento centri (ensureCentersLoaded):', e);
            }
        },
        fetchPromoValidation(code, centerId) {
            const variationIdParam = this.selectedVariation?.id || this.selectedVariation?.variationId || '';
            // Il codice viaggia come segmento di path: senza encode un punto o un carattere
            // accentato nel codice romperebbe l'URL invece di arrivare al server (devops #333).
            return fetch(`https://api.elitefitness.it/api/promo/validate/${encodeURIComponent(code)}?productId=${this.selectedProduct.id}&userId=${this.userId}${variationIdParam ? `&variationId=${variationIdParam}` : ''}${centerId ? `&centerId=${encodeURIComponent(centerId)}` : ''}` , {
                headers: {
                    Authorization: `Bearer ${this.userToken}`,
                },
            });
        },
        /** Motivo per cui lo sconto non vale nella sede scelta, null se vale. */
        promoCenterMismatchMessage() {
            const required = String(this.promoDiscountCenterId || '').trim();
            if (!required) return null;
            const selected = String(this.selectedCenterId || '').trim();
            if (selected.toLowerCase() === required.toLowerCase()) return null;
            const center = (this.centers || []).find(c => String(c.id ?? '').toLowerCase() === required.toLowerCase());
            const name = center?.name || 'una sola sede';
            return `Questo codice sconto vale solo per ${center ? `la sede di ${name}` : name}: selezionala per applicarlo.`;
        },
        /**
         * Toglie lo sconto dal riepilogo lasciando il codice nel campo: tornando su una sede
         * valida si riapplica da solo (recheckPromoForCenter), senza doverlo reinserire.
         */
        suspendPromoForCenter(message) {
            const code = this.discountCode;
            this.removeDiscount();
            this.discountCode = code;
            this.discountError = message;
            this.promoSuspendedForCenter = true;
            this.enforceVariationRulesAfterPromo();
            this.updateStripeTotalsIfReady();
            this.syncUrl();
        },
        /**
         * Il server concede lo sconto solo nella sede per cui il codice vale (gate di
         * PromoCodeService.isCheckoutCenterEligibleForDiscount): al cambio sede il codice si
         * rivalida, o il riepilogo mostrerebbe uno sconto che il pagamento non applica.
         */
        async recheckPromoForCenter(centerId) {
            if (!this.userLogged || this.isFollowPaidListPromo || !this.selectedProduct?.id) return;
            const code = this.sanitizePromoCode(this.discountCode);
            if (!code) return;
            if (!this.promoCode && !this.promoSuspendedForCenter) return;
            const center = String(centerId || '');
            if (this.promoCode && center === this.promoValidatedCenterId) return;

            const seq = ++this.promoCenterCheckSeq;
            let message = null;
            try {
                const response = await this.fetchPromoValidation(code, center);
                const result = await response.json();
                if (seq !== this.promoCenterCheckSeq) return;
                if (!response.ok || result?.status === 'error' || !result?.promoCode) {
                    message = result?.message || 'Il codice promozionale non è valido per questo centro.';
                } else {
                    this.promoDiscountCenterId = result.discountCenterId ? String(result.discountCenterId) : null;
                    message = this.promoCenterMismatchMessage();
                }
            } catch (e) {
                if (seq !== this.promoCenterCheckSeq) return;
                message = 'Impossibile verificare il codice sconto per questa sede. Riapplicalo.';
            }
            // Nel frattempo il socio puo' aver rimosso il codice.
            if (!this.promoCode && !this.promoSuspendedForCenter) return;

            if (this.promoCode) {
                if (message) {
                    this.suspendPromoForCenter(message);
                    this.showToast(message, 'error');
                } else {
                    this.promoValidatedCenterId = center;
                }
            } else if (message) {
                this.discountError = message;
            } else {
                // Sede di nuovo valida: si riapplica senza reinserire il codice. La verifica
                // qui sopra garantisce che applyDiscount non debba spostare la sede scelta.
                await this.applyDiscount();
            }
        },
        removeDiscount() {
            // Clear promo and code
            this.promoCode = null;
            this.guestPromoPreviewActive = false;
            this.guestPromoVariationPrices = null;
            this.promoFreeDays = 0;
            this.promoFreeMonths = 0;
            this.promoAllowedCenters = null;
            this.pricingCenterId = '';
            this.discountCode = '';
            this.discountAmount = 0;
            this.discountError = null;
            this.promoDiscountCenterId = null;
            this.promoValidatedCenterId = null;
            this.promoSuspendedForCenter = false;

            // Reset dependent computed-driven UI by touching base values
            // Restore default product price based on current selection
            if (this.selectedVariation) {
                this.finalPrice = this.selectedVariation.price;
            } else if (this.selectedProduct) {
                this.finalPrice = this.selectedProduct.price || 0;
            } else {
                this.finalPrice = 0;
            }

            // Re-enable all variations (guard methods already check promoCode)
            // No-op needed: isVariationAllowed() returns true when promoCode is null

            // Also clear discountCode from URL by syncing
            this.syncUrl();

            // Inform user
            this.showToast('Codice sconto rimosso.', 'info');

            // Update Stripe totals if already on payment step
            this.updateStripeTotalsIfReady();
        },
        // Giorni e mesi omaggio della durata selezionata. La risoluzione vive in variationOffer, che è la
        // stessa usata dalle card: qui resta solo il travaso nello stato che alimenta il riepilogo.
        updatePromoFreeDays() {
            const offerta = this.variationOffer(this.selectedVariation);
            this.promoFreeDays = offerta.giorniOmaggio;
            this.promoFreeMonths = offerta.mesiOmaggio;
        },
        // Cerca una chiave in una mappa indicizzata per nome di variazione senza farsi fermare da spazi
        // o maiuscole: nei dati reali convivono "Annuale" e "Annuale " con lo spazio finale.
        lookupByVariationName(map, variationName) {
            if (!map || variationName == null) return null;
            if (map[variationName] != null) return map[variationName];
            const wanted = String(variationName).trim().toLowerCase();
            const key = Object.keys(map).find(k => String(k).trim().toLowerCase() === wanted);
            return key != null ? map[key] : null;
        },
        toggleSection(section) {
            Object.keys(this.collapsedSections).forEach((key) => {
                this.collapsedSections[key] = true;
            });

            this.collapsedSections[section] = !this.collapsedSections[section];
        },
        // Small helper: compute discounted amount supporting percent or fixed
        /**
         * L'offerta per una singola durata: listino, sconto risolto, prezzo finale e omaggi.
         *
         * Serve alle card delle durate, che devono essere confrontabili senza doverle selezionare una a una.
         * Il listino è `variation.price` letto adesso, non un valore cachato: `applyCenterPriceOverrides` lo
         * riscrive in-place quando cambia la sede, e un valore congelato mostrerebbe il prezzo di un'altra
         * palestra.
         */
        variationOffer(variation) {
            const listino = Number(variation?.price || 0);
            const nessunaPromo = { listino, sconto: 0, scontato: listino, giorniOmaggio: 0, mesiOmaggio: 0 };
            if (!this.promoCode || !this.selectedProduct) return nessunaPromo;
            // L'assicurazione comprata da sola non ha le durate del codice: vale la regola degli upsell, la stessa
            // del server (devops#432).
            if (this.selectedProduct?.type === 'REGISTRATION') {
                const assicurazione = prezzoAssicurazioneAcquistata(listino, this.promoCode);
                return { ...nessunaPromo, sconto: assicurazione.sconto, scontato: assicurazione.dopo };
            }

            const nome = variation?.variationName || null;
            // Una durata esclusa dal codice si mostra a prezzo pieno: è il suo prezzo vero se la si acquista.
            if (!this.isVariationAllowed(nome)) return nessunaPromo;

            const guestRow = this.lookupGuestPromoVariationPrice(nome);
            if (guestRow && Number.isFinite(guestRow.discountedPrice)) {
                const apiListino = Number(guestRow.price);
                let scontato = Number(guestRow.discountedPrice);
                if (apiListino > 0 && listino > 0 && Math.abs(listino - apiListino) > 0.02) {
                    const ratio = listino / apiListino;
                    scontato = Math.round(scontato * ratio * 100) / 100;
                }
                const sconto = Math.max(0, Math.min(listino, listino - scontato));
                return {
                    listino,
                    sconto,
                    scontato: Math.max(0, listino - sconto),
                    giorniOmaggio: this.resolveVariationFree('freeDaysPerProductVariation', 'freeDaysPerProduct', nome),
                    mesiOmaggio: this.resolveVariationFree('freeMonthsPerProductVariation', null, nome),
                };
            }

            const risolto = this.resolveVariationDiscount(nome);
            const res = this.computeDiscounted(listino, risolto.amount, risolto.percentage);
            return {
                listino,
                sconto: res.discount,
                scontato: res.after,
                giorniOmaggio: this.resolveVariationFree('freeDaysPerProductVariation', 'freeDaysPerProduct', nome),
                mesiOmaggio: this.resolveVariationFree('freeMonthsPerProductVariation', null, nome),
            };
        },
        /**
         * Precedenza dello sconto, la stessa applicata dal server in PromoCode.resolveDiscount:
         * valore della variazione, poi wildcard "*" del prodotto, poi lo sconto generale del codice.
         */
        resolveVariationDiscount(variationName) {
            const productId = this.selectedProduct?.id;
            const perVariazione = (this.promoCode?.discountPerProductVariation || {})[productId];
            if (perVariazione) {
                const esatto = this.lookupByVariationName(perVariazione, variationName);
                if (esatto != null) return { amount: Number(esatto), percentage: true };
                if (perVariazione['*'] != null) return { amount: Number(perVariazione['*']), percentage: true };
            }
            return {
                amount: Number(this.promoCode?.discountAmount || 0),
                percentage: !!this.promoCode?.percentage,
            };
        },
        /**
         * Giorni o mesi omaggio con la stessa precedenza. `perProductKey` è null per i mesi, che non hanno
         * un livello di prodotto: sono nati con la configurazione per durata e non hanno forma storica.
         */
        resolveVariationFree(perVariationKey, perProductKey, variationName) {
            const productId = this.selectedProduct?.id;
            if (!productId) return 0;
            const perVariazione = (this.promoCode?.[perVariationKey] || {})[productId];
            if (perVariazione) {
                const esatto = this.lookupByVariationName(perVariazione, variationName);
                if (esatto != null) return Math.max(0, Number(esatto) || 0);
                if (perVariazione['*'] != null) return Math.max(0, Number(perVariazione['*']) || 0);
            }
            if (perProductKey) {
                const perProdotto = this.promoCode?.[perProductKey] || {};
                if (perProdotto[productId] != null) return Math.max(0, Number(perProdotto[productId]) || 0);
            }
            return 0;
        },
        /** Riga degli omaggi sulla card, es. «+2 mesi in omaggio» o «+30 giorni gratuiti». Vuota se non ce ne sono. */
        variationGiftLabel(variation) {
            const offerta = this.variationOffer(variation);
            const parti = [];
            if (offerta.mesiOmaggio > 0) {
                parti.push(`+${offerta.mesiOmaggio} ${offerta.mesiOmaggio === 1 ? 'mese' : 'mesi'} in omaggio`);
            }
            if (offerta.giorniOmaggio > 0) {
                parti.push(`+${offerta.giorniOmaggio} giorni gratuiti`);
            }
            return parti.join(' · ');
        },
        computeDiscounted(base, discountValue, isPercentage) {
            const amount = Number(base || 0);
            const val = Number(discountValue || 0);
            if (amount <= 0 || val <= 0) return { after: amount, discount: 0 };
            const disc = isPercentage ? (amount * val / 100) : val;
            const after = Math.max(0, amount - disc);
            return { after, discount: Math.min(amount, disc) };
        },
        /**
         * Se la variante scelta è annuale, l'iscrizione e assicurazione è inclusa: non entra nel
         * carrello e il riepilogo la mostra «Inclusa». Va ricalcolato anche quando la variante
         * arriva già scelta dal link — Comeback, promo, app — non solo al click (devops #292).
         *
         * «Annuale» ha una sola definizione, quella del server in util/Annualita.java: un
         * abbonamento Sala Pesi (GYM) o corso (COURSE) di almeno 360 giorni. Il nome della
         * variante non conta: il corso «Annuale» dura 304 giorni e l'iscrizione si paga (decisione
         * del 29/09, devops #311). Prima qui bastava il nome, e il checkout toglieva l'iscrizione a
         * un corso annuale che il server non considerava tale: il socio restava senza copertura.
         * AnnualitaTest, lato API, fallisce se questa regola si allontana da quella del server.
         */
        aggiornaVarianteAnnuale() {
            const GIORNI_ANNUALE = 360;
            const abbonamento = ['GYM', 'COURSE'].includes(this.selectedProduct?.type);
            this.annualVariation = abbonamento && Number(this.getDuration) >= GIORNI_ANNUALE;
        },
        selectVariation(variation) {
            if (this._isPrecisionCheckoutProduct()) {
                const n = Number(variation.price);
                this.precisionCatalogFlatPrice = !Number.isNaN(n) && n > 0 ? n : this.precisionCatalogFlatPrice;
            } else {
                this.precisionCatalogFlatPrice = null;
            }
            this.selectedVariation = variation;
            this.selectedVariationName = variation.variationName;
            this.finalPrice = variation.price;

            this.productDefaultPrice = variation.price; // Aggiorna il prezzo di default del prodotto

            this.aggiornaVarianteAnnuale();


            // Trova e assegna la variazione dello Stop & Go corrispondente
            if (this.stopngoProduct?.variations) {
                console.log("Trova e assegna la variazione dello Stop & Go corrispondente")
                this.selectedStopAndGoVariation = this.stopngoProduct.variations.find(
                    stopGoVariation => stopGoVariation.variationName === this.selectedVariationName
                );
            }

            if (this.biaUpsellEnabled) {
                this.requiresBIA = this.selectedVariation?.attributes?.mandatoryBia;
            }

            this.resetDiscountCode();

            this.applyDiscount();

            // Ricalcola i giorni gratuiti (se c'è già un promo applicato e si cambia variation)
            this.updatePromoFreeDays();

            this.freeTrial = false;

            this.syncUrl();
            this.refreshInitiatives();
        },
        // Click handler that respects promo restrictions
        onVariationClick(variation) {
            // Le durate fuori offerta restano acquistabili: sono sotto «Altri abbonamenti — a prezzo di
            // listino», e rifiutare il click su qualcosa che il socio può comprare sarebbe una vendita persa.
            // Lo sconto semplicemente non si applica, qui come al server, e la card lo mostra già a prezzo pieno.
            if (this.promoCode && !this.isVariationAllowed(variation.variationName)) {
                this.showToast('Questa durata non rientra nella tua offerta: la paghi a prezzo di listino.', 'info');
            }
            this.selectVariation(variation);
        },
        // Validate current selection after a promo is applied and optionally auto-select a valid one
        enforceVariationRulesAfterPromo() {
            try {
                // Prova gratuita non usa una variation: auto-selezionare una durata (es. guest
                // promo Comeback → «14 Giorni») chiamerebbe selectVariation e spegnerebbe freeTrial.
                if (this.freeTrial) return;
                if (!this.promoCode || !this.selectedProduct?.variations?.length) return;

                const allowedSet = new Set(this.allowedVariationNames);

                // Appena applicato il codice, si porta il socio sull'offerta: è quello che si aspetta di vedere.
                // Da lì può comunque tornare su un'altra durata — resta acquistabile a listino — perché lo
                // spostamento avviene solo qui, non a ogni click.
                if (this.selectedVariationName && !allowedSet.has(this.selectedVariationName)) {
                    const firstAllowed = this.selectedProduct.variations.find(v => allowedSet.has(v.variationName));
                    if (firstAllowed) {
                        this.selectVariation(firstAllowed);
                        this.showToast('Abbiamo selezionato la durata inclusa nella tua offerta.', 'info');
                    } else {
                        // No allowed variations (edge case): clear selection
                        this.selectedVariationName = null;
                        this.selectedVariation = null;
                        this.showToast('Il codice sconto non è applicabile a nessuna durata di questo prodotto.', 'error');
                    }
                }
            } catch (e) {
                console.error('Errore durante l\'applicazione delle regole variazioni promo:', e);
            }
        },
        // Returns true if a variation name is allowed under current promo
        isVariationAllowed(variationName) {
            if (!this.promoCode) return true;
            return this.allowedVariationNames.includes(variationName);
        },
        selectTrainerForBIA(trainer) {
            const id = trainer?.id || trainer?.trainerId;
            this.selectedBIATrainerId = id;
            this.updatePricesByTrainerInfo(id);
            this.syncUrl();
        },
        selectBIATrainer(trainer) {
            // Solo seleziona/aggiorna i prezzi e lascia la possibilità di cambiare trainer
            this.selectTrainerForBIA(trainer);
        },
        _personalPackVariationPrice(singlePrice, packagePrice, duration) {
            const pkg = Number(packagePrice || 0);
            if (duration === 1) {
                return singlePrice;
            }
            if (pkg > 0) {
                return pkg;
            }
            return singlePrice * duration * 0.6;
        },
        /** Formato dropdown: "Nome • prezzo €" (target|bia|personal base seduta — non usare per Elite Personal pacchetto) */
        formatTrainerOption(trainer, priceType) {
            const name = trainer?.fullName || trainer?.personalInfo?.fullName || '';
            const priceKeys = {
                target: 'targetTrainingPrice',
                bia: 'biaPrice',
                precision: 'precisionTrainingPrice',
            };
            const price = trainer?.[priceKeys[priceType] || 'personalTrainingPrice'];
            if (price != null && Number(price) > 0) {
                return `${name} • ${Number(price).toFixed(2)} €`;
            }
            return name;
        },
        /** True se il checkout è Precision (metadata o categoria), anche se productIsPrecision non è ancora valorizzato. */
        _isPrecisionCheckoutProduct() {
            const p = this.selectedProduct;
            const t = p?.metadata?.type;
            if (t === 'PRECISION_TRAINING') return true;
            const cats = p?.categories;
            return Array.isArray(cats) && cats.includes('PRECISION_TRAINING');
        },
        /**
         * Prezzo mostrato nel menu trainer per Elite Personal: stessa formula di updatePricesByTrainerInfo
         * (pacchetto in base a duration), non la singola seduta.
         */
        _formatPersonalPackTrainerLabel(trainer, variations, selectedVariationName) {
            const name = trainer?.fullName || trainer?.personalInfo?.fullName || '';
            const isPrecision = this._isPrecisionCheckoutProduct();
            const priceKey = isPrecision ? 'precisionTrainingPrice' : 'personalTrainingPrice';
            const base = Number(trainer?.[priceKey]);
            const vars = variations || [];
            const v = vars.find((x) => x.variationName === selectedVariationName);
            const dur = v?.attributes?.duration != null ? Number(v.attributes.duration) : 1;
            let packPrice = NaN;
            if (!Number.isNaN(base) && base > 0) {
                // Precision: flat. Elite Personal: STESSA formula autorevole di updatePricesByTrainerInfo
                // (_personalPackVariationPrice) — usa personalTrainingPackagePrice indipendente (BUG 64),
                // NON la vecchia base*dur*0.6, così l'etichetta coincide con card/panoramica.
                if (isPrecision) {
                    packPrice = base;
                } else {
                    const packagePrice = Number(trainer?.personalTrainingPackagePrice || 0);
                    packPrice = this._personalPackVariationPrice(base, packagePrice, dur);
                }
            } else if (!isPrecision && v && v.price != null && Number(v.price) > 0) {
                packPrice = Number(v.price);
            } else if (isPrecision) {
                // Non usare variation.price: è condiviso e viene mutato da updatePrices (es. 2700).
                const snap = this.precisionCatalogFlatPrice;
                const prodP = Number(this.selectedProduct?.price);
                if (snap != null && !Number.isNaN(Number(snap)) && Number(snap) > 0) {
                    packPrice = Number(snap);
                } else if (!Number.isNaN(prodP) && prodP > 0) {
                    packPrice = prodP;
                }
            }
            if (!Number.isNaN(packPrice) && packPrice > 0) {
                return `${name} • ${packPrice.toFixed(2)} €`;
            }
            return name;
        },
        /** Elite Personal checkout diretto: usa variazione del prodotto principale (selectedProduct). */
        formatTrainerOptionForPersonalStandalone(trainer) {
            return this._formatPersonalPackTrainerLabel(trainer, this.selectedProduct?.variations, this.selectedVariationName);
        },
        /**
         * Elite Personal come upsell (es. Sala Pesi): il prezzo nel menu riflette il pacchetto selezionato
         * (personalProduct + selectedPersonalUpsellVariationName).
         */
        /**
         * Nome del socio con le iniziali maiuscole, tollerante ai dati mancanti.
         *
         * `fullName` non e' garantito: un tesserato registrato al banco puo' non averlo. Prima si dava
         * per scontato, e `fullName.replace(...)` sollevava un TypeError nelle primissime righe di
         * `created`. Il try/catch di `created` lo logga soltanto, quindi tutto cio' che viene dopo —
         * prodotti, servizio, prezzi, metodi di pagamento — non veniva mai eseguito: al socio restava
         * una schermata blu vuota, senza un messaggio. Segnalato il 16/09 su un checkout reale.
         *
         * Un'intestazione senza nome e' un inconveniente; un checkout che non si apre e' una vendita
         * persa, e nessuno capisce perche'.
         */
        nomeConIniziali(personalInfo) {
            const nome = personalInfo?.fullName;
            if (typeof nome !== 'string' || !nome.trim()) return '';
            return nome.replace(/\b\w/g, (c) => c.toUpperCase());
        },
        // Sul totem il nome del socio loggato va al centro dello schermo (KioskCheckoutBar):
        // vuoto se non c'è nessun socio, così non compare né un segnaposto né «Ospite».
        publishKioskUserName() {
            if (!IS_KIOSK) return;
            kioskSession.userName = this.userLogged ? (this.userFullName || '') : '';
        },
        formatTrainerOptionForPersonalUpsell(trainer) {
            return this._formatPersonalPackTrainerLabel(trainer, this.personalProduct?.variations, this.selectedPersonalUpsellVariationName);
        },
        goNextAfterBIA() {
            // Se ci sono variazioni, vai allo step di selezione piano
            if (this.showVariationStep) {
                this.step = 1;
                this.scrollToStep(1);
                this.syncUrl();
                return;
            }
            // Senza variazioni: se non loggato vai ai dati utente, altrimenti al pagamento
            if (!this.userLogged) {
                this.step = 2;
                this.scrollToStep(2);
                this.syncUrl();
                return;
            }
            // Utente loggato: vai al pagamento
            this.step = 3;
            this.initializeStripeElements();
            this.isPaymentReady = this.hasAcceptedTerms;
            this.scrollToStep(3);
            this.syncUrl();
        },
        goToPayment() {
            this.step = 3;
            this.initializeStripeElements();
            this.isPaymentReady = true; // Abilita il pulsante di pagamento
            this.scrollToStep(3);
            this.syncUrl();
        },
        goToNextStep() {
            // Validazione per lo step gift
            if (this.isGiftMode && this.step === 3) {
                if (this.sendEmailToGiftRecipient) {
                    if (!this.giftRecipientEmail || !this.giftRecipientEmail.trim()) {
                        this.showErrorAlert('Inserisci l\'email del destinatario per continuare.');
                        return;
                    }
                    // Validazione email base
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(this.giftRecipientEmail)) {
                        this.showErrorAlert('Inserisci un indirizzo email valido.');
                        return;
                    }
                }
            }
            this.nextStep();
        },
        nextStep() {
            console.log(this.step);
            // Step 1: Selezione del piano
            if (this.step === 1) {
                console.log("Step 1")
                console.log(this.selectedProduct.type)
                console.log(!this.selectedVariationName, !this.freeTrial, this.selectedProduct.type !== 'BIA')
                if ((!this.selectedVariationName && !this.freeTrial) && this.selectedProduct.type !== 'BIA') {
                    this.showInfoAlert("Seleziona un piano per continuare.");
                    return;
                }
                if (this.productIsPersonal && !this.selectedPersonalTrainerId) {
                    this.showInfoAlert("Seleziona un trainer per continuare.");
                    return;
                }
                // Target Training (main product) requires trainer selection
                if (this.productIsTarget && !this.selectedTargetTrainerId) {
                    this.showInfoAlert("Seleziona un trainer per continuare.");
                    return;
                }
                // Target Training as upsell requires trainer selection when enabled (non per free target)
                if (this.requiresTarget && !this.isFreeTargetUpsell && !this.selectedTargetTrainerId) {
                    this.showInfoAlert("Seleziona un trainer per continuare.");
                    return;
                }
                // BIA upsell selezionato: la scelta del trainer è obbligatoria (come per il Personal Training)
                if (this.requiresBIA && !this.selectedBIATrainerId) {
                    this.showInfoAlert("Seleziona un trainer per continuare.");
                    return;
                }
                // Upsell obbligatorio con variazioni: la scelta della variazione è obbligatoria (come per il trainer del Personal Training)
                if (this.requiresMandatoryUpsell && this.activeMandatoryProduct?.variations?.some(v => v.active === true) && !this.selectedMandatoryVariation) {
                    this.showInfoAlert("Seleziona una variazione per il servizio obbligatorio per continuare.");
                    return;
                }
                // Decidi il prossimo step in base allo stato login, freeTrial e gift mode
                let targetStep = 2;
                if (this.userLogged && !this.freeTrial) {
                    if (this.isGiftMode) {
                        targetStep = 3; // utenti loggati in modalità gift vanno allo step gift
                    } else {
                        targetStep = 3; // utenti loggati saltano ai pagamenti (step 3 se non gift, step 4 se gift)
                    }
                }

                this.step = targetStep;
                // Inizializza Stripe solo quando si arriva allo step di pagamento
                if (targetStep === (this.isGiftMode ? 4 : 3)) {
                    this.initializeStripeElements();
                    this.isPaymentReady = false;
                }
                this.scrollToStep(targetStep);
                console.log(this.step);
                return;
            }

            // Step 2: Inserimento dei dati personali (registrazione diretta senza sezioni collassabili)
            if (this.step === 2) {
                if (!this.userLogged) {
                    if (!this.validateRegistration()) {
                        return;
                    }
                    this.register()
                        .then(() => {
                            this.showEmailVerificationAlert();
                        })
                        .catch(async (error) => {
                            if (error.response) {
                                try {
                                    const errorData = await error.response.json();
                                    this.showErrorAlert(errorData.message || error.message);
                                } catch {
                                    this.showErrorAlert(error.message);
                                }
                            } else {
                                this.showErrorAlert(error.message);
                            }
                        });
                    return;
                }

                // Utente loggato: prosegui al pagamento o allo step gift
                this.step += 1;
                this.scrollToStep(this.step);
                return;
            }

            console.log(this.freeTrial);
            if (!this.freeTrial) {
                // Step 3: Gift (solo se in modalità gift) o Pagamento
                if (this.step === 3 && this.isGiftMode) {
                    // Step 3 è lo step del gift, passa allo step 4 (pagamento)
                    this.step = 4;
                    this.initializeStripeElements();
                    this.isPaymentReady = false;
                    this.scrollToStep(this.step);
                    return;
                }
                
                // Step 3/4: Pagamento
                if (this.step === (this.isGiftMode ? 4 : 3)) {
                    // ✅ MODIFICATO: Inizializza Stripe solo se termini accettati
                    if (this.hasAcceptedTerms) {
                        this.initializeStripeElements();
                        this.isPaymentReady = true;
                    } else {
                        this.isPaymentReady = false;
                    }
                    this.scrollToStep(3);
                }
            }
        },
        // Sessione dell'account provvisorio (24 ore, senza refresh): stessa persistenza del login, poi si
        // ricarica la pagina così `created()` riparte come per un utente che ha appena fatto accesso.
        onQuickSignedUp({ token, expiresIn, email }) {
            try {
                localStorage.setItem('userEmail', email);
                localStorage.setItem('userToken', token);
                localStorage.setItem('tokenExpiration', expiresIn);
            } catch (_) { /* storage bloccato: la sessione vale solo per questa pagina */ }
            this.$router.go();
        },
        validateRegistration() {
            // Basic trim helper
            const trim = (v) => (typeof v === 'string' ? v.trim() : v);
            // Required base fields
            const missing = [];
            if (!trim(this.user.firstName)) missing.push('Nome');
            if (!trim(this.user.lastName)) missing.push('Cognome');
            if (!this.user.dateOfBirth) missing.push('Data di nascita');
            if (!trim(this.user.taxCode)) missing.push('Codice Fiscale');
            if (!trim(this.user.gender)) missing.push('Genere');
            if (!trim(this.user.city)) missing.push('Città');
            if (!trim(this.user.postalCode)) missing.push('CAP');
            if (!trim(this.user.province)) missing.push('Provincia');
            if (!trim(this.user.country)) missing.push('Nazione');
            if (!trim(this.user.phoneNumber)) missing.push('Telefono');
            if (!trim(this.user.email)) missing.push('Email');
            if (!trim(this.user.password)) missing.push('Password');

            // Guardian required if minor
            if (this.isMinor) {
                const g = this.user.legalGuardian || {};
                if (!trim(g.firstName)) missing.push('Nome tutore');
                if (!trim(g.lastName)) missing.push('Cognome tutore');
                if (!trim(g.taxCode)) missing.push('Codice fiscale tutore');
                if (!trim(g.relationship)) missing.push('Relazione con il minore');
                if (!trim(g.email)) missing.push('Email tutore');
                if (!trim(g.phoneNumber)) missing.push('Telefono tutore');
            }

            // Email and password pattern checks
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (trim(this.user.email) && !emailRegex.test(this.user.email)) {
                this.showErrorAlert('Inserisci un\'email valida.');
                return false;
            }
            if (this.user.password && !this.validatePassword(this.user.password)) {
                this.showErrorAlert('La password non soddisfa i requisiti minimi.');
                return false;
            }

            if (missing.length > 0) {
                this.showErrorAlert('Compila i campi obbligatori: ' + missing.join(', '));
                return false;
            }
            return true;
        },
        async initializeStripeElements() {
            console.log("initializeStripeElements")
            this.$nextTick(() => {
                if (!this.stripe) {
                    console.error("Stripe is not initialized yet.");
                    return;
                }

                // ✅ AGGIUNTO: Verifica che l'elemento card-element sia presente nel DOM
                const cardElementContainer = document.getElementById('card-element');
                if (!cardElementContainer) {
                    console.log("Card element container not found in DOM, skipping Stripe initialization");
                    return;
                }

                if (!this.elements) {
                    this.elements = this.stripe.elements();
                }

                /*
                if(!this.paymentElement){
                    // Crea e monta l'elemento di pagamento
                    this.paymentElement = this.elements.create('payment', {
                        layout: 'tabs',
                        paymentRequest: this.paymentRequest,
                    });
                    this.paymentElement.mount('#payment-element');
                }
                */

                if (!this.cardElement) {
                    // Definisci lo stile per l'elemento della carta
                    const style = {
                        base: {
                            color: 'white',            // Testo bianco
                            fontSize: '14px',          // Stessa scala dei titoli e delle label del checkout
                            fontWeight: '600',
                            lineHeight: '48px',           // Centra verticalmente il testo nel campo Stripe
                            '::placeholder': {
                                color: 'rgba(255, 255, 255, 0.7)',  // Placeholder bianco, ma più trasparente
                            },
                            textAlign: 'left',         // Il contenuto parte allineato al bordo del campo
                            fontFamily: 'Montserrat, sans-serif', // Imposta il font
                            iconColor: 'white',        // Colore delle icone
                        },
                        invalid: {
                            color: '#ff4d4f',           // Colore rosso per gli input non validi
                            iconColor: '#ff4d4f',
                        },
                    };

                    // Crea e monta l'elemento della carta con lo stile
                    this.cardElement = this.elements.create('card', { style });
                    this.cardElement.mount('#card-element');
                }

                // Creiamo `paymentRequest` come variabile di istanza
                this.paymentRequest = this.stripe.paymentRequest({
                    country: 'IT',
                    currency: 'eur',
                    total: {
                        label: 'Pagamento',
                        amount: Math.round(this.remainingAfterWallet * 100),
                    },
                    requestPayerName: true,
                    requestPayerEmail: true,

                });

                // **Verifica se il metodo di pagamento è disponibile**
                this.paymentRequest.canMakePayment().then((canMakePayment) => {
                    if (canMakePayment) {
                        this.isPaymentReady = true;

                        // **Crea il bottone per Apple Pay e Google Pay**
                        // ✅ AGGIUNTO: Verifica che il container sia presente nel DOM
                        const paymentRequestContainer = document.getElementById('payment-request-button-container');
                        if (paymentRequestContainer) {
                            this.paymentRequestButton = this.elements.create('paymentRequestButton', {
                                paymentRequest: this.paymentRequest,
                            });

                            this.paymentRequestButton.mount('#payment-request-button-container');

                // **Gestisci il pagamento con Apple Pay / Google Pay**
                this.paymentRequest.on('paymentmethod', async (event) => {
                                try {
                                    // Validazione Gift Card
                                    if (this.isGiftCard && !this.giftCardRecipientEmail) {
                                        event.complete('fail');
                                        this.showErrorAlert('Inserisci l\'email del destinatario per completare l\'acquisto della Gift Card.');
                                        return;
                                    }
                                    // ✅ USA LA STESSA LOGICA DEL CASH PAYMENT
                    const paymentRequest = this.createPaymentRequest('stripe');

                                const response = await fetch('https://api.elitefitness.it/api/payment/stripe/create', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: `Bearer ${this.userToken}`,
                                        'Idempotency-Key': this.getOrCreateCheckoutIdempotencyKey(),
                                    },
                                    body: JSON.stringify(paymentRequest),
                                });

                                // Totale 0: il server completa l'ordine e non manda client_secret (devops#431).
                                const esito = esitoCreazioneCarta(await response.json());
                                if (esito.tipo === 'completato') {
                                    event.complete('success');
                                    this.vaiAlSuccessoCompletato('STRIPE');
                                    return;
                                }
                                if (esito.tipo !== 'conferma') {
                                    throw new Error('Risposta stripe/create senza client_secret');
                                }

                                const { error } = await this.stripe.confirmCardPayment(esito.clientSecret, {
                                    payment_method: event.paymentMethod.id,
                                });

                                if (error) {
                                    event.complete('fail');
                                    this.showErrorAlert(error.message);
                                } else {
                                    event.complete('success');
                                    this.vaiAlSuccessoCompletato('STRIPE');
                                }
                            } catch (error) {
                                event.complete('fail');
                                console.error(error);
                                this.showErrorAlert('Errore durante il pagamento.');
                            }
                        });
                        } // ✅ AGGIUNTO: Chiusura del blocco if per paymentRequestContainer
                    } // ✅ AGGIUNTO: Chiusura del blocco else per isAvailable
                }); // ✅ CHIUSURA: del blocco canMakePayment


                // Abilita il pulsante di pagamento dopo che i dati della carta sono pronti
                this.isPaymentReady = true;
            });
        },
        async handleFreeTrial() {
            // Richiede login: se non loggato, mostra Step 2 (accesso/registrazione)
            if (!this.userLogged) {
                this.step = 2;
                this.scrollToStep(2);
                this.showToast('Effettua l\'accesso per iniziare la prova gratuita.', 'info');
                return;
            }
            // Verifica accettazione termini anche in modalità Free Trial
            if (!this.hasAcceptedTerms) {
                this.scrollToTerms();
                this.showToast('Per iniziare la prova gratuita devi accettare tutti i termini.', 'warning');
                return;
            }
            // Conferma riepilogativa come nello step pagamento
            const riepilogo = `<ul style='text-align:left;line-height:1.5;padding-left:18px;'>`
              + `<li>Accetto Termini e Condizioni</li>`
              + `<li>Ho letto e accetto il Codice Etico</li>`
              + `<li>Confermo di aver preso visione della dichiarazione relativa ai documenti di identità</li>`
              + `<li>Ho letto e accetto l'Informativa Privacy</li>`
              + `<li>Accetto i Termini per allenamento notturno H24</li>`
              + `</ul>`;
            const confirmRes = await Swal.fire({
                title: 'Confermi tutte le dichiarazioni?',
                html: `<div style='text-align:left;font-size:15px;'>Stai per iniziare una prova gratuita avendo dichiarato e accettato quanto segue:${riepilogo}<p style='margin-top:8px;'>Confermi?</p></div>`,
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Conferma',
                cancelButtonText: 'Annulla',
                reverseButtons: true,
                focusCancel: true,
                customClass: {
                    confirmButton: 'swal-stopgo-confirm',
                    cancelButton: 'swal-stopgo-cancel',
                    actions: 'swal-stopgo-actions'
                },
                buttonsStyling: false
            });
            if (!confirmRes.isConfirmed) {
                this.acceptTerms = false;
                this.acceptPrivacyPolicy = false;
                this.acceptRegulation = false;
                this.acceptMedicalCertDeclaration = false;
                this.acceptIdentityDocsDeclaration = false;
                this.isPaymentReady = false;
                return;
            }
            try {
                const response = await fetch('https://api.elitefitness.it/api/freeTrial?serviceId=' + this.selectedProduct.serviceId, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.userToken}`,
                    },
                });

                // Vado alla pagina /success se la richiesta va a buon fine, ossia "status":"ok"
                const data = await response.json();

                console.log(data);

                if (data.status == 'ok') {
                    this.$router.push({ path: '/success', query: { source: this.checkoutSource } });
                } else {
                    this.showErrorAlert('Non è stato possibile prenotare una prova gratuita. Puoi prenotare una sola prova gratuita per ogni servizio.');
                }


            } catch (error) {
                console.error(error);
                this.showErrorAlert('Non è stato possibile prenotare una prova gratuita. Puoi prenotare una sola prova gratuita per ogni servizio.');
            }
        },
        async handleCardPayment() {
            try {
                // Totale 0: nessun passaggio da Stripe, si segue il percorso gratuito (devops#431).
                if (this.isFreeOrder) {
                    return this.handleCashPayment();
                }
                // Validazione Gift Card
                if (this.isGiftCard && !this.giftCardRecipientEmail) {
                    this.showErrorAlert('Inserisci l\'email del destinatario per completare l\'acquisto della Gift Card.');
                    return;
                }
                if (!this.stripe || !this.cardElement) {
                    this.showErrorAlert("Stripe o l'elemento carta non è pronto.");
                    return;
                }

                const selectedVariation = this.selectedProduct.variations.find(variation => variation.variationName === this.selectedVariationName);
                if (!selectedVariation) {
                    console.error("Selected variation not found");
                    return;
                }

                const paymentRequest = this.createPaymentRequest('stripe');

                await pagaConCarta({
                    chiama: () => fetch('https://api.elitefitness.it/api/payment/stripe/create', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${this.userToken}`,
                            'Idempotency-Key': this.getOrCreateCheckoutIdempotencyKey(),
                        },
                        body: JSON.stringify(paymentRequest),
                    }),
                    confermaStripe: (clientSecret) => this.stripe.confirmCardPayment(clientSecret, {
                        payment_method: {
                            card: this.cardElement,
                            billing_details: {
                                name: this.userFullName,
                                email: this.userEmail,
                            },
                        },
                    }),
                    vaiAlSuccesso: (metodo) => this.vaiAlSuccessoCompletato(metodo),
                    mostraErrore: (messaggio) => this.showErrorAlert(messaggio),
                });
            } catch (error) {
                console.error(error);
                this.showErrorAlert('Si è verificato un errore durante il pagamento.');
            }
        },
        async startPayPalPayment() {
            // Apre il popup PayPal e interroga ciclicamente lo stato lato backend
            const POLL_MS = 1200;
            const TIMEOUT_MS = 180000; // 3 minuti
            let pollTimer = null;
            let popup = null;

            const stopPolling = () => { if (pollTimer) clearInterval(pollTimer); pollTimer = null; };

            const pollStatus = (orderId) => {
                const startedAt = Date.now();
                pollTimer = setInterval(async () => {
                    try {
                        const res = await fetch(`https://api.elitefitness.it/api/payment/paypal/status/${orderId}`, {
                            headers: { Authorization: `Bearer ${this.userToken}` }
                        });
                        if (!res.ok) throw new Error(await res.text());
                        const { state } = await res.json();

                        // Salva lo stato corrente (opzionale/UI)
                        this.paypalState = state; // AWAITING_APPROVAL | CAPTURED_PENDING_WEBHOOK | PAID | FAILED | CANCELLED

                        if (state === 'PAID') {
                            stopPolling();
                            if (popup && !popup.closed) popup.close();
                            // Naviga alla pagina di successo, in linea con gli altri flussi
                            this.vaiAlSuccessoCompletato('PAYPAL');
                            return;
                        }

                        if (state === 'FAILED' || state === 'CANCELLED') {
                            stopPolling();
                            if (popup && !popup.closed) popup.close();
                            this.showToast(state === 'FAILED' ? 'Pagamento non riuscito' : 'Pagamento annullato', 'error');
                            return;
                        }

                        if (Date.now() - startedAt > TIMEOUT_MS) {
                            stopPolling();
                            this.showToast('Stiamo ancora finalizzando il pagamento. Verifica nella sezione Ordini tra poco.', 'info');
                        }
                    } catch (e) {
                        // non fermare il polling su errori temporanei
                        console.warn('Status polling error', e);
                    }
                }, POLL_MS);
            };

            try {
                // Totale 0: nessun passaggio da PayPal, si segue il percorso gratuito (devops#431).
                if (this.isFreeOrder) {
                    return this.handleCashPayment();
                }
                // Validazione Gift Card
                if (this.isGiftCard && !this.giftCardRecipientEmail) {
                    this.showErrorAlert('Inserisci l\'email del destinatario per completare l\'acquisto della Gift Card.');
                    return;
                }
                const paymentRequest = this.createPaymentRequest('paypal');

                // Con approveUrl si apre PayPal; se il server ha già completato l'ordine (totale 0) si va al
                // successo senza errore; «dati non validi» solo per risposte davvero incomplete (devops#431).
                const esito = await avviaPayPal({
                    chiama: () => fetch('https://api.elitefitness.it/api/payment/paypal/create', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${this.userToken}`,
                            'Idempotency-Key': this.getOrCreateCheckoutIdempotencyKey(),
                        },
                        body: JSON.stringify(paymentRequest)
                    }),
                    vaiAlSuccesso: (metodo) => this.vaiAlSuccessoCompletato(metodo),
                    mostraErrore: (messaggio) => this.showErrorAlert(messaggio),
                });
                if (esito.tipo !== 'approvazione') return;
                const { approveUrl, orderId } = esito;

                // Stato iniziale per la UI
                this.paypalState = 'AWAITING_APPROVAL';

                // Apri la finestra PayPal
                popup = window.open(approveUrl, '_blank', 'width=600,height=700');
                // Fallback in caso di popup bloccato
                if (!popup || popup.closed) {
                    window.location.href = approveUrl;
                }

                // Avvia il polling dello stato (copre sia chiusura popup sia redirect di ritorno)
                pollStatus(orderId);

                // Monitor chiusura popup per feedback rapido
                const closeWatch = setInterval(async () => {
                    if (!popup || popup.closed) {
                        clearInterval(closeWatch);
                        // Lettura immediata dello stato alla chiusura
                        try {
                            const res = await fetch(`https://api.elitefitness.it/api/payment/paypal/status/${orderId}`, {
                                headers: { Authorization: `Bearer ${this.userToken}` }
                            });
                            if (res.ok) {
                                const { state } = await res.json();
                                this.paypalState = state;
                            }
                        } catch (e) {
                            // eslint-disable-next-line no-console
                            console.warn('Immediate PayPal status fetch failed after popup close', e);
                        }
                    }
                }, 500);

            } catch (error) {
                console.error(error);
                this.showErrorAlert('Errore durante il pagamento con PayPal');
            }
        },

        isUserDataValid() {
            return this.user.email && this.user.password && this.user.firstName && this.user.lastName;
        },
        selectPaymentMethod(method) {
            this.selectedPayment = method.value;

            // ✅ MODIFICATO: Inizializza solo se termini accettati e usa $nextTick
            if (method.value == "CARD" && this.hasAcceptedTerms) {
                this.$nextTick(() => {
                    this.initializeStripeElements();
                });
            }

            // Mostra informazioni reception quando si seleziona pagamento in reception
            if (method.value == "CASH") {
                this.showReceptionScheduleInfo();
            }

            // ✅ MODIFICATO: Abilita pagamento solo se termini accettati
            this.isPaymentReady = this.hasAcceptedTerms;
        },
        
        // Helper functions for reception schedule
        translateDayOfWeek(dayOfWeek) {
            const translations = {
                'MONDAY': 'Lunedì',
                'TUESDAY': 'Martedì',
                'WEDNESDAY': 'Mercoledì',
                'THURSDAY': 'Giovedì',
                'FRIDAY': 'Venerdì',
                'SATURDAY': 'Sabato',
                'SUNDAY': 'Domenica'
            };
            return translations[dayOfWeek] || dayOfWeek;
        },
        
        formatTime(time) {
            if (!time) return '--:--';
            // Se il formato è hh:mm:ss, prendiamo solo hh:mm
            if (time.length > 5) {
                return time.substring(0, 5);
            }
            return time;
        },
        
        getServiceCenters() {
            if (!this.selectedService || !this.centers.length) {
                return [];
            }
            
            // Se il promo limita i centri, usa quelli
            if (this.promoAllowedCenters && this.promoAllowedCenters.length) {
                return this.centers.filter(c => 
                    this.promoAllowedCenters.includes(c.id?.toString())
                );
            }
            
            // Altrimenti usa i centri associati al servizio
            const serviceCenters = Array.isArray(this.selectedService.centersId)
                ? this.selectedService.centersId.map(id => id.toString())
                : [];
            
            return this.centers.filter(center => 
                serviceCenters.includes(center.id?.toString())
            );
        },
        
        formatReceptionSchedule(center) {
            const schedule = center.receptionPresidioSchedule;
            if (!schedule || !schedule.weeklySchedule || schedule.weeklySchedule.length === 0) {
                return null;
            }
            
            // Raggruppa gli slot per giorno
            const slotsByDay = {};
            schedule.weeklySchedule.forEach(slot => {
                if (!slotsByDay[slot.dayOfWeek]) {
                    slotsByDay[slot.dayOfWeek] = [];
                }
                slotsByDay[slot.dayOfWeek].push({
                    start: this.formatTime(slot.startTime),
                    end: this.formatTime(slot.endTime)
                });
            });
            
            // Formatta per la visualizzazione
            const formatted = [];
            const daysOrder = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
            
            daysOrder.forEach(day => {
                if (slotsByDay[day]) {
                    const daySlots = slotsByDay[day].map(s => `dalle ${s.start} alle ${s.end}`).join(', ');
                    formatted.push(`${this.translateDayOfWeek(day)}, ${daySlots}`);
                }
            });
            
            return formatted.length > 0 ? formatted.join('<br>') : null;
        },
        
        getAvailableDaysForCenter(center) {
            const schedule = center.receptionPresidioSchedule;
            if (!schedule || !schedule.weeklySchedule || schedule.weeklySchedule.length === 0) {
                return new Set();
            }
            
            // Ottieni i giorni della settimana che hanno orari configurati
            const availableDays = new Set();
            schedule.weeklySchedule.forEach(slot => {
                availableDays.add(slot.dayOfWeek);
            });
            
            return availableDays;
        },
        
        isDateHoliday(date, center) {
            const schedule = center.receptionPresidioSchedule;
            if (!schedule || !schedule.holidays) {
                return false;
            }
            
            const dateStr = date.toISOString().split('T')[0];
            return schedule.holidays.includes(dateStr);
        },
        
        isDateAvailable(date, center) {
            // Controlla se il giorno della settimana ha orari configurati
            const dayOfWeek = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'][date.getDay()];
            const availableDays = this.getAvailableDaysForCenter(center);
            
            // Il giorno è disponibile se ha orari settimanali E non è un giorno festivo
            return availableDays.has(dayOfWeek) && !this.isDateHoliday(date, center);
        },
        
        getTimeSlotsForDay(center, dayOfWeek) {
            const schedule = center.receptionPresidioSchedule;
            if (!schedule || !schedule.weeklySchedule) {
                return [];
            }
            
            return schedule.weeklySchedule.filter(slot => slot.dayOfWeek === dayOfWeek);
        },
        
        formatTimeSlots(timeSlots) {
            if (!timeSlots || timeSlots.length === 0) {
                return '';
            }
            
            // Formatta ogni slot nel formato "Dalle X alle Y (hh:mm)"
            return timeSlots.map(slot => {
                const startTime = slot.startTime ? slot.startTime.substring(0, 5) : '';
                const endTime = slot.endTime ? slot.endTime.substring(0, 5) : '';
                return `Dalle ${startTime} alle ${endTime}`;
            }).join('<br>');
        },
        
        async showReceptionScheduleInfo() {
            const serviceCenters = this.getServiceCenters();
            
            if (serviceCenters.length === 0) {
                Swal.fire({
                    icon: 'info',
                    title: 'Informazioni Reception',
                    html: 'Nessun centro associato al servizio selezionato.',
                    confirmButtonText: 'OK',
                    customClass: {
                        confirmButton: 'swal-confirm-button'
                    }
                });
                return;
            }
            
            // Prepara il contenuto HTML per ogni centro
            let htmlContent = '<div style="text-align: center;">';
            
            serviceCenters.forEach((center, index) => {
                const schedule = center.receptionPresidioSchedule;
                const centerName = center.name || `Centro ${index + 1}`;
                
                if (schedule && schedule.weeklySchedule && schedule.weeklySchedule.length > 0) {
                    const formattedSchedule = this.formatReceptionSchedule(center);
                    if (formattedSchedule) {
                        htmlContent += `<div style="margin-top: ${index > 0 ? '30px' : '0'}; margin-bottom: 15px; padding-top: ${index > 0 ? '20px' : '0'};">`;
                        htmlContent += `<div style="margin-bottom: 8px; color: #16195e; font-size: 0.85em; font-weight: 700;">${centerName}</div>`;
                        htmlContent += `<div style="width: 100%; height: 2px; background-color: #e83539; margin-bottom: 12px;"></div>`;
                        htmlContent += `<div style="margin-bottom: 10px; color: #16195e; font-size: 0.9em;">${formattedSchedule}</div>`;
                        htmlContent += `</div>`;
                    } else {
                        htmlContent += `<div style="margin-top: ${index > 0 ? '30px' : '0'}; margin-bottom: 15px; padding-top: ${index > 0 ? '20px' : '0'};">`;
                        htmlContent += `<div style="margin-bottom: 8px; color: #16195e; font-size: 0.85em; font-weight: 700;">${centerName}</div>`;
                        htmlContent += `<div style="width: 100%; height: 2px; background-color: #e83539; margin-bottom: 12px;"></div>`;
                        htmlContent += '<div style="margin-bottom: 10px; color: #16195e; font-size: 0.9em;">Nessun orario configurato</div>';
                        htmlContent += `</div>`;
                    }
                } else {
                    htmlContent += `<div style="margin-top: ${index > 0 ? '30px' : '0'}; margin-bottom: 15px; padding-top: ${index > 0 ? '20px' : '0'};">`;
                    htmlContent += `<div style="margin-bottom: 8px; color: #16195e; font-size: 0.85em; font-weight: 700;">${centerName}</div>`;
                    htmlContent += `<div style="width: 100%; height: 2px; background-color: #e83539; margin-bottom: 12px;"></div>`;
                    htmlContent += '<div style="margin-bottom: 10px; color: #16195e; font-size: 0.9em;">Nessun orario configurato per questo centro</div>';
                    htmlContent += `</div>`;
                }
            });
            
            htmlContent += '</div>';
            
            const result = await Swal.fire({
                icon: 'info',
                title: 'Quando puoi pagare',
                html: `<div style="text-align: center; margin-bottom: 15px; color: #16195e; font-size: 0.95em;">Puoi pagare in reception nelle seguenti fasce orarie</div>${htmlContent}`,
                showCancelButton: true,
                confirmButtonText: 'Giorni non presidiati',
                cancelButtonText: 'Ok',
                customClass: {
                    popup: 'swal-reception-popup',
                    actions: 'swal-reception-actions'
                },
                reverseButtons: false
            });
            
            if (result.isConfirmed) {
                this.showHolidaysCalendar(serviceCenters);
            }
        },
        
        async showHolidaysCalendar(serviceCenters) {
            if (!serviceCenters || serviceCenters.length === 0) {
                serviceCenters = this.getServiceCenters();
            }
            
            if (serviceCenters.length === 0) {
                return;
            }
            
            // Inizia dal mese corrente
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            currentDate.setDate(1); // Primo giorno del mese
            
            await this.showCalendarForMonth(serviceCenters, currentDate);
        },
        
        generateCalendarContent(serviceCenters, monthDate) {
            let htmlContent = '<div style="text-align: center;">';
            
            // Se ci sono più centri, mostra un calendario per ciascuno
            if (serviceCenters.length > 1) {
                serviceCenters.forEach((center, centerIndex) => {
                    const centerName = center.name || `Centro ${centerIndex + 1}`;
                    htmlContent += `<div style="margin-top: ${centerIndex > 0 ? '30px' : '0'}; margin-bottom: 15px;">`;
                    htmlContent += `<h4 style="margin: 0 0 8px 0; color: #16195e; font-weight: 600; font-size: 0.85em;">${centerName}</h4>`;
                    htmlContent += `<div style="width: 100%; height: 2px; background-color: #e83539; margin-bottom: 12px;"></div>`;
                    htmlContent += `</div>`;
                    htmlContent += this.generateCalendarHTML(center, monthDate);
                });
            } else {
                htmlContent += this.generateCalendarHTML(serviceCenters[0], monthDate);
            }
            
            htmlContent += '</div>';
            return htmlContent;
        },
        
        async showCalendarForMonth(serviceCenters, monthDate) {
            // Salva i serviceCenters nello stato per la navigazione
            this.tempServiceCenters = serviceCenters;
            this.tempCalendarDate = new Date(monthDate);
            
            // Assicurati che window.vueApp sia disponibile per i bottoni
            if (typeof window !== 'undefined') {
                window.vueApp = this;
            }
            
            const htmlContent = this.generateCalendarContent(serviceCenters, monthDate);
            
            await Swal.fire({
                icon: 'info',
                title: 'Giorni in cui puoi pagare',
                html: htmlContent,
                showCancelButton: false,
                confirmButtonText: 'Chiudi',
                width: '700px',
                customClass: {
                    confirmButton: 'swal-confirm-button',
                    popup: 'swal-calendar-popup'
                }
            });
        },
        
        async navigateCalendarMonth(direction) {
            if (!this.tempServiceCenters || !this.tempCalendarDate) {
                return;
            }
            
            const newDate = new Date(this.tempCalendarDate);
            if (direction === 'prev') {
                newDate.setMonth(newDate.getMonth() - 1);
            } else {
                newDate.setMonth(newDate.getMonth() + 1);
            }
            
            this.tempCalendarDate = newDate;
            
            // Aggiorna solo il contenuto HTML invece di chiudere e riaprire il popup
            const htmlContent = this.generateCalendarContent(this.tempServiceCenters, newDate);
            Swal.update({
                html: htmlContent
            });
        },
        
        generateCalendarHTML(center, monthDate) {
            const months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 
                          'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
            const daysOfWeek = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
            
            const year = monthDate.getFullYear();
            const month = monthDate.getMonth();
            const monthName = months[month];
            
            // Calcola il primo giorno del mese e quanti giorni ci sono
            const firstDay = new Date(year, month, 1).getDay();
            const daysInMonth = new Date(year, month + 1, 0).getDate();
            
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            let html = '<div style="margin-bottom: 20px;">';
            // Header con navigazione mese
            html += `<div style="display: flex; align-items: center; justify-content: center; gap: 15px; margin-bottom: 15px;">`;
            html += `<button type="button" class="swal-calendar-nav-chevron" onclick="window.vueApp.navigateCalendarMonth('prev')">‹</button>`;
            html += `<h5 style="margin: 0; color: #16195e; font-weight: 600; font-size: 0.85em;">${monthName} ${year}</h5>`;
            html += `<button type="button" class="swal-calendar-nav-chevron" onclick="window.vueApp.navigateCalendarMonth('next')">›</button>`;
            html += `</div>`;
            html += `<div class="swal-calendar-grid" style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 4px; border: 1px solid #ddd; border-radius: 8px; padding: 8px; background: #f9f9f9;">`;
            
            // Header giorni della settimana
            daysOfWeek.forEach(day => {
                html += `<div style="text-align: center; font-weight: normal; font-size: 0.7em; color: #666; padding: 5px;">${day}</div>`;
            });
            
            // Celle vuote prima del primo giorno
            for (let i = 0; i < firstDay; i++) {
                html += `<div style="aspect-ratio: 1; min-width: 35px;"></div>`;
            }
            
            // Giorni del mese
            for (let day = 1; day <= daysInMonth; day++) {
                const date = new Date(year, month, day);
                const isHoliday = this.isDateHoliday(date, center);
                const isAvailable = this.isDateAvailable(date, center);
                const isPast = date < today;
                
                // Controlla se il giorno della settimana ha orari configurati
                const dayOfWeek = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'][date.getDay()];
                const availableDays = this.getAvailableDaysForCenter(center);
                const hasWeeklySchedule = availableDays.has(dayOfWeek);
                const timeSlots = this.getTimeSlotsForDay(center, dayOfWeek);
                const timeSlotsFormatted = this.formatTimeSlots(timeSlots);
                
                let cellClass = '';
                let cellContent = '';
                
                if (isPast) {
                    cellClass = 'background: #f0f0f0; color: #999;';
                    cellContent = `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; padding: 2px;"><span style="font-size: 0.75em; font-weight: 600;">${day}</span></div>`;
                } else if (isHoliday || !hasWeeklySchedule) {
                    // Rosso con X se è festivo OPPURE se non ha orari settimanali configurati
                    cellClass = 'background: #dc2626; color: white; font-weight: 600;';
                    cellContent = `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; padding: 2px;"><span style="font-size: 0.75em;">${day}</span><span style="font-size: 0.85em;">✕</span></div>`;
                } else if (isAvailable) {
                    cellClass = 'background: #b3e5fc; color: #0277bd; font-weight: 600;';
                    cellContent = `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; padding: 2px;"><span style="font-size: 0.75em; font-weight: 600;">${day}</span><span class="swal-calendar-checkmark" style="font-size: 0.8em;">✓</span><span class="swal-calendar-times" style="font-size: 0.65em; line-height: 1.1; margin-top: 2px; text-align: center;">${timeSlotsFormatted}</span></div>`;
                } else {
                    // Questo caso non dovrebbe mai verificarsi, ma lo lasciamo come fallback
                    cellClass = 'background: #dc2626; color: white; font-weight: 600;';
                    cellContent = `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; padding: 2px;"><span style="font-size: 0.75em;">${day}</span><span style="font-size: 0.85em;">✕</span></div>`;
                }
                
                html += `<div class="swal-calendar-cell" style="${cellClass} min-height: 80px; min-width: 50px; display: flex; align-items: center; justify-content: center; border-radius: 4px; font-size: 0.9em;">${cellContent}</div>`;
            }
            
            html += `</div></div>`;
            
            return html;
        },
        // Mobile CTA: ensure step 2 is completed if not logged, otherwise start free trial directly
        onStartFreeTrialMobile() {
            /*
             * L'accesso prima dei consensi (devops #316). Con l'ordine opposto chi non era
             * loggato veniva rimandato alle caselle invece che al Passo 2 — e comunque non ci
             * arrivava, perché il pulsante restava disabilitato finché i consensi non erano
             * tutti spuntati. Adesso a sessione assente il pulsante è premibile e porta qui.
             */
            if (!this.userLogged) {
                // Force navigation to Step 2 (user data)
                this.step = 2;
                this.scrollToStep(2);
                return;
            }
            if (!this.hasAcceptedTerms) {
                this.scrollToTerms();
                return;
            }
            // Logged-in user: start the free trial
            this.handleFreeTrial();
        },
        /**
         * Firma e registra le accettazioni legali del socio già registrato.
         *
         * Prima di questa modifica le cinque caselle del checkout servivano solo ad abilitare il
         * pulsante: l'accettazione spariva al clic, senza lasciare traccia. Chi si registra firma da
         * sempre; chi era già a sistema no, ed è la platea più numerosa.
         *
         * Blocca il pagamento se non riesce, come fa la registrazione quando la firma fallisce:
         * proseguire vorrebbe dire incassare dichiarando un'accettazione che non siamo in grado di
         * dimostrare — cioè ricreare esattamente il problema che questo codice risolve.
         */
        async recordLegalAttestation() {
            if (!this.userLogged || !this.userToken) return;
            await submitLegalAttestation({
                authToken: this.userToken,
                acceptances: {
                    terms: this.acceptTerms,
                    privacy: this.acceptPrivacyPolicy,
                    regulation: this.acceptRegulation,
                    ethical: this.acceptMedicalCertDeclaration,
                    identityDocs: this.acceptIdentityDocsDeclaration,
                },
            });
        },

        async handlePayment() {
            // In cima e non dentro i rami: sotto ci sono prova gratuita, ordine a zero, wallet, carta
            // e PayPal, e l'accettazione va registrata una volta sola qualunque strada si prenda.
            try {
                await this.recordLegalAttestation();
            } catch (e) {
                // showErrorAlert è il meccanismo del componente: scrivere in una proprietà propria
                // avrebbe prodotto un errore che nessuno mostra, cioè un pagamento fermo e muto.
                this.showErrorAlert(
                    (e && e.message)
                        ? `Non è stato possibile registrare l'accettazione delle condizioni: ${e.message}`
                        : "Non è stato possibile registrare l'accettazione delle condizioni. Riprova.",
                );
                return;
            }

            if (this.userLogged && this.freeTrial) {
                this.handleFreeTrial();
                return;
            }

            // Prima di chiedere il pagamento: carrello già completato e codice sconto ancora valido (devops#431).
            if (!(await this.controlliPrimaDelPagamento())) {
                return;
            }
            
            // Se l'ordine è gratuito (totale = 0), usa automaticamente il metodo cash
            if (this.isFreeOrder) {
                this.handleCashPayment();
                return;
            }
            
            // Se il wallet copre tutto e l'utente ha selezionato di usarlo, processa direttamente
            if (this.useWalletCredit && this.walletCoversFullAmount && this.userLogged) {
                await this.handleWalletPayment();
                return;
            }
            
            // Altrimenti, usa il metodo di pagamento selezionato
            if (this.selectedPayment === "CARD") {
                this.handleCardPayment(); // Logica per pagamento con carta
            } else if (this.selectedPayment === "PAYPAL") {
                this.startPayPalPayment(); // Logica per pagamento PayPal
            } else if (this.selectedPayment === "CASH") {
                this.handleCashPayment(); // Logica per pagamento in contanti
            } else if (this.selectedPayment === "CASH_KIOSK") {
                this.handleKioskCashPayment(); // Incasso contanti al kiosk (Cashmatic)
            } else if (this.selectedPayment === "CARD_KIOSK") {
                this.handleKioskCardPayment(); // POS fisico Nexi (ECR-LAN)
            }
        },
        /**
         * Vai alla pagina di successo dopo un acquisto che il server dà per concluso, ricordando il carrello.
         * Se il socio torna indietro e ripete lo stesso acquisto, `controlliPrimaDelPagamento` lo avvisa invece di
         * lasciarlo pagare due volte in silenzio (devops#431).
         */
        vaiAlSuccessoCompletato(metodo) {
            this.ricordaCarrelloCompletato(metodo);
            this.$router.push({ path: '/success', query: { method: metodo, source: this.checkoutSource } });
        },
        storageSessione() {
            try {
                return window.sessionStorage;
            } catch {
                return null;
            }
        },
        /** Impronta del carrello com'è adesso; null se non si può costruire (la richiesta di pagamento può rifiutarsi). */
        firmaCarrelloAttuale() {
            try {
                return firmaCarrello(this.createPaymentRequest('stripe'));
            } catch {
                return null;
            }
        },
        ricordaCarrelloCompletato(metodo) {
            const storage = this.storageSessione();
            const firma = this.firmaCarrelloAttuale();
            if (storage && firma) registraCarrelloCompletato(storage, firma, metodo);
        },
        /**
         * Controlli da fare PRIMA di chiedere il pagamento. Restituisce true se si può procedere.
         * 1. Lo stesso carrello risulta già completato: lo si dice e si porta al successo (o si lascia scegliere
         *    di acquistare di nuovo — mai in silenzio).
         * 2. Il codice sconto applicato non vale più (tipicamente: già usato dopo un acquisto riuscito): la pagina
         *    lo scrive e mostra il prezzo pieno, invece di far nascere un ordine a prezzo pieno a cose fatte.
         */
        async controlliPrimaDelPagamento() {
            const storage = this.storageSessione();
            // L'impronta passa da createPaymentRequest, che avvisa se manca un trainer: la si costruisce solo se
            // c'è un acquisto ricordato con cui confrontarla, per non mostrare due volte lo stesso avviso.
            const firma = storage && haCarrelloRicordato(storage) ? this.firmaCarrelloAttuale() : null;
            const gia = firma ? carrelloGiaCompletato(storage, firma) : null;
            if (gia) {
                const scelta = await Swal.fire({
                    icon: 'info',
                    title: 'Acquisto già completato',
                    html: 'Questo acquisto risulta già completato da questo dispositivo pochi minuti fa: non serve pagare di nuovo.',
                    showDenyButton: true,
                    confirmButtonText: 'Vai alla conferma',
                    denyButtonText: 'Acquista di nuovo',
                    focusConfirm: true,
                });
                if (scelta.isConfirmed) {
                    this.$router.push({ path: '/success', query: { method: gia.metodo || undefined, source: this.checkoutSource } });
                    return false;
                }
                if (!scelta.isDenied) return false;
                dimenticaCarrelloCompletato(storage);
            }
            return this.ricontrollaCodiceSconto();
        },
        async ricontrollaCodiceSconto() {
            if (!this.userLogged || !this.promoCode || this.guestPromoPreviewActive) return true;
            const codice = this.sanitizePromoCode(this.discountCode);
            if (!codice || !this.selectedProduct?.id) return true;

            let giudizio;
            try {
                const response = await this.fetchPromoValidation(codice, this.selectedCenterId);
                let corpo = null;
                try { corpo = await response.json(); } catch { /* corpo non JSON: non verificabile */ }
                giudizio = giudicaRicontrolloCodice(response.status, corpo);
            } catch (e) {
                // Rete assente o richiesta fallita: a decidere resta il pagamento, il ricontrollo non lo ferma.
                console.warn('Ricontrollo del codice sconto non riuscito', e);
                return true;
            }
            if (giudizio.tipo !== 'non_valido') return true;

            // Lo sconto esce dal riepilogo e il codice resta nel campo; la chiave di idempotenza si rigenera perché
            // il carrello da pagare non è più lo stesso.
            this.removeDiscount();
            this.discountCode = codice;
            this.discountError = giudizio.messaggio;
            this.checkoutIdempotencyKey = null;
            await this.$nextTick();
            const totale = Number(this.selectedVariationPrice?.total || 0).toFixed(2).replace('.', ',');
            await Swal.fire({
                icon: 'warning',
                title: giudizio.giaUsato ? 'Codice sconto già utilizzato' : 'Codice sconto non più valido',
                html: `${giudizio.messaggio}<br>Senza lo sconto il totale è <b>${totale} €</b>. Controlla il riepilogo e, se vuoi procedere, conferma di nuovo.`,
                confirmButtonText: 'OK',
            });
            return false;
        },
        /** Il pulsante PayPal non passa da handlePayment: i controlli prima del pagamento valgono anche qui. */
        async avviaPayPalDalPulsante() {
            if (!(await this.controlliPrimaDelPagamento())) return;
            return this.startPayPalPayment();
        },
        getOrCreateCheckoutIdempotencyKey() {
            if (!this.checkoutIdempotencyKey) {
                this.checkoutIdempotencyKey = crypto.randomUUID ? crypto.randomUUID() : this.generateUUID();
            }
            return this.checkoutIdempotencyKey;
        },
        generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                const r = Math.random() * 16 | 0;
                const v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
    createPaymentRequest(paymentMethod) {
            const upsells = [];
            const additionals = [];
            const isRegistration = this.selectedProduct?.type === 'REGISTRATION';

            // Hard guard: Target Training requires trainer selection (both main product and upsell), tranne free target
            const targetMain = this.productIsTarget === true;
            const targetUpsell = this.requiresTarget === true && !this.isFreeTargetUpsell;
            if ((targetMain || targetUpsell) && !this.selectedTargetTrainerId) {
                this.showToast('Seleziona un trainer per il Target Training.', 'warning');
                throw new Error('Target trainer required');
            }
            if (this.requiresPersonal && !this.selectedPersonalUpsellTrainerId) {
                this.showToast('Seleziona un trainer per Elite Personal.', 'warning');
                throw new Error('Elite Personal upsell trainer required');
            }
            if (this.productIsPersonal && !this.selectedPersonalTrainerId) {
                this.showToast('Seleziona un trainer per Elite Personal.', 'warning');
                throw new Error('Elite Personal trainer required');
            }
            if (this.requiresPrecision && !this.selectedPrecisionUpsellTrainerId) {
                this.showToast('Seleziona un trainer per il Precision Training.', 'warning');
                throw new Error('Precision Training upsell trainer required');
            }

            if (!isRegistration && !this.skipInsuranceActive && this.requiresRegistration && this.registrationProduct && this.annualVariation == false && this.selectedProduct.type !== 'ENTRY_PACK') {
                upsells.push(this.registrationProduct.id);
            }
            if (!isRegistration && this.selectedProduct?.type !== 'ENTRY_PACK' && this.selectedProduct?.type !== 'GIFT_CARD' && this.requiresMembership && this.membershipProduct) {
                upsells.push(this.membershipProduct.id);
            }
            if (!isRegistration && this.selectedProduct?.type !== 'GIFT_CARD' && this.requiresStopAndGo && this.stopngoProduct) {
                upsells.push(this.stopngoProduct.id)
            }
            if (!isRegistration && this.selectedProduct?.type !== 'GIFT_CARD' && this.requiresBIA && this.biaProduct) {
                upsells.push(this.biaProduct.id);
            }
            if (!isRegistration && this.selectedProduct?.type !== 'GIFT_CARD' && this.requiresMandatoryUpsell && this.activeMandatoryProduct) {
                upsells.push(this.activeMandatoryProduct.id);
            }
            if (!isRegistration && this.selectedProduct?.type !== 'GIFT_CARD' && this.requiresTarget && this.targetProduct) {
                upsells.push(this.targetProduct.id);
            }
            if (!isRegistration && this.selectedProduct?.type !== 'GIFT_CARD' && this.requiresPersonal && this.personalProduct) {
                upsells.push(this.personalProduct.id);
            }
            if (!isRegistration && this.selectedProduct?.type !== 'GIFT_CARD' && this.requiresPrecision && this.precisionProduct) {
                upsells.push(this.precisionProduct.id);
            }

            // Detect alias promo: presence of referralCode implies alias
            const isAliasPromo = !!(this.referralCode && String(this.referralCode).trim());
            // If alias, send the real promo code from backend (promoCode.code); otherwise send the typed code
            const promoCodeToSend = this.sanitizePromoCode(
                isAliasPromo ? (this.promoCode?.code || this.discountCode) : this.discountCode
            );

            // Converti la data di inizio personalizzata in timestamp (millisecondi) se presente
            // La data viene interpretata come mezzanotte locale (00:00) del giorno selezionato
            let customStartDateTimestamp = null;
            if (this.customStartDate) {
                // Parse della data YYYY-MM-DD e creazione come mezzanotte locale
                const [year, month, day] = this.customStartDate.split('-').map(Number);
                const selectedDate = new Date(year, month - 1, day, 0, 0, 0, 0); // Mezzanotte locale
                customStartDateTimestamp = selectedDate.getTime();
            }

            let paymentRequest = {
                productId: this.selectedProductId,
                variationName: this.selectedVariationName,
                newUser: this.userLogged ? null : (() => {
                    const u = { ...this.user };
                    if (!this.isMinor) {
                        delete u.legalGuardian;
                    }
                    return u;
                })(),
                promoCode: promoCodeToSend,
                registerUser: !this.userLogged,
                email: this.userEmail,
                token: this.userToken,
                upsells, // Aggiungi i prodotti di upsell
                referralCode: this.referralCode,
                source: 'checkout',
                paymentMethod: paymentMethod || (this.selectedPayment === 'CASH' ? 'cash' : 'stripe'),
                customStartDate: customStartDateTimestamp, // Data di inizio personalizzata
                useWalletCredit: this.useWalletCredit && this.walletBalance > 0, // Usa credito Wallet
            };

            if (!isRegistration && this.selectedBIATrainerId) {
                additionals.push({
                    productId: this.biaProduct ? this.biaProduct.id : (this.selectedProductId),
                    additionals: (this.requiresBIA && this.biaProduct && this.selectedBiaPack)
                        ? biaAdditionals(this.selectedBIATrainerId, this.selectedBiaPack)
                        : { trainerId: this.selectedBIATrainerId }
                });
            }

            // Target Training come upsell
            if (!isRegistration && this.requiresTarget && this.targetProduct) {
                if (this.isFreeTargetUpsell) {
                    additionals.push({
                        productId: this.targetProduct.id,
                        additionals: { isFreeTarget: true }
                    });
                } else if (this.selectedTargetTrainerId) {
                    additionals.push({
                        productId: this.targetProduct.id,
                        additionals: targetAdditionals(this.selectedTargetTrainerId, this.selectedTargetPack, this.targetProduct)
                    });
                }
            }
            // Target Training come prodotto principale (requiresTarget è false in questo caso)
            else if (!isRegistration && this.productIsTarget && this.selectedTargetTrainerId) {
                additionals.push({
                    productId: this.selectedProductId,
                    additionals: { targetTrainerId: this.selectedTargetTrainerId }
                });
            }

            // Elite Personal come upsell (PERSONAL_TRAINING)
            if (!isRegistration && this.requiresPersonal && this.personalProduct && this.selectedPersonalUpsellTrainerId) {
                const vars = this.personalProduct.variations || [];
                const varName = this.selectedPersonalUpsellVariationName
                    || (vars.find(v => v.active !== false) || vars[0])?.variationName;
                additionals.push({
                    productId: this.personalProduct.id,
                    additionals: {
                        personalTrainerId: this.selectedPersonalUpsellTrainerId,
                        variationName: varName
                    }
                });
            }

            // Precision Training come upsell: OrderService legge `personalTrainerId` anche per
            // PRECISION_TRAINING, e gli additionals sono per prodotto, quindi non si scontra
            // con quelli di Elite Personal.
            if (!isRegistration && this.requiresPrecision && this.precisionProduct && this.selectedPrecisionUpsellTrainerId) {
                additionals.push({
                    productId: this.precisionProduct.id,
                    additionals: {
                        personalTrainerId: this.selectedPrecisionUpsellTrainerId
                    }
                });
            }

            if (!isRegistration && this.productIsPersonal && this.selectedPersonalTrainerId) {
                additionals.push({
                    productId: this.selectedProductId,
                    additionals: {
                        personalTrainerId: this.selectedPersonalTrainerId,
                        duration: this.selectedVariation?.attributes?.duration || 1
                    }
                });
            }

            if (!isRegistration && this.selectedMandatoryVariation && this.activeMandatoryProduct) {
                additionals.push({
                    productId: this.activeMandatoryProduct.id,
                    additionals: {
                        mandatoryVariation: this.selectedMandatoryVariation.variationName
                    }
                });
            }

            if(!isRegistration && this.requiresStopAndGo) {
                additionals.push({
                    productId: this.stopngoProduct.id,
                    additionals: {
                        variationName: this.selectedVariationName
                    }

                })
            }

            // Gift Card additionals
            if (this.selectedProduct?.type === 'GIFT_CARD' && this.giftCardRecipientEmail) {
                additionals.push({
                    productId: this.selectedProductId,
                    additionals: {
                        recipientEmail: this.giftCardRecipientEmail,
                        message: this.giftCardMessage || ''
                    }
                });
            }

            paymentRequest = {
                ...paymentRequest,
                additionals: additionals
            };

            // Legacy/LIMITED: centerId determina anche il perimetro di accesso.
            if (!this.isFollowPaidListPromo && this.selectedCenterId && this.selectedCenterId.trim()) {
                paymentRequest.centerId = this.selectedCenterId.trim();
            }
            // FOLLOW_PAID_LIST: il listino è separato dagli accessi. Il campo
            // viene inviato solo quando la promo identifica un unico centro.
            if (this.isFollowPaidListPromo && this.pricingCenterId && this.pricingCenterId.trim()) {
                paymentRequest.pricingCenterId = this.pricingCenterId.trim();
            }

            // Aggiungi dati gift se in modalità gift
            if (this.isGiftMode) {
                paymentRequest.isGift = true;
                paymentRequest.sendEmailToRecipient = this.sendEmailToGiftRecipient;
                if (this.sendEmailToGiftRecipient && this.giftRecipientEmail) {
                    paymentRequest.giftRecipientEmail = this.giftRecipientEmail;
                }
                if (this.giftMessage) {
                    paymentRequest.giftMessage = this.giftMessage;
                }
            }

            return paymentRequest;
        },
        async handleCashPayment() {
            // Validazione Gift Card
            if (this.isGiftCard && !this.giftCardRecipientEmail) {
                this.showErrorAlert('Inserisci l\'email del destinatario per completare l\'acquisto della Gift Card.');
                return;
            }
            
            // Validazione wallet se usato
            if (this.useWalletCredit && this.userLogged) {
                // Ricarica il saldo wallet per validazione aggiornata
                await this.loadWalletBalance();
                
                const total = this.selectedVariationPrice?.total || 0;
                if (this.walletBalance <= 0) {
                    this.showErrorAlert('Credito wallet non disponibile.');
                    return;
                }
                
                // Se il wallet copre tutto, usa handleWalletPayment
                if (this.walletBalance >= total) {
                    await this.handleWalletPayment();
                    return;
                }
            }

            try {
                this.isLoading = true;
                const paymentRequest = this.createPaymentRequest('cash');

                const response = await fetch('https://api.elitefitness.it/api/payment/cash/create', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.userToken}`,
                    },
                    body: JSON.stringify(paymentRequest),
                });
                
                if (!response.ok) {
                    let errorMsg = 'Errore durante il pagamento';
                    try {
                        const errorData = await response.json();
                        errorMsg = errorData.message || errorData.error || errorMsg;
                    } catch {
                        try {
                            errorMsg = await response.text();
                        } catch {
                            // Mantieni il messaggio di default
                        }
                    }
                    throw new Error(errorMsg);
                }
                
                const result = await response.json();
                console.log('Cash payment result:', result);
                
                // Se il wallet è stato usato, mostra messaggio appropriato
                if (this.useWalletCredit && result.walletAmountUsed > 0) {
                    const remaining = result.remainingAmount || 0;
                    if (remaining > 0) {
                        this.showSuccessAlert(`Pagamento parziale con Wallet: ${result.walletAmountUsed.toFixed(2)}€. Restano ${remaining.toFixed(2)}€ da pagare in struttura.`);
                    } else {
                        this.showSuccessAlert('Pagamento completato con credito Wallet!');
                    }
                } else {
                    this.showSuccessAlert('Pagamento in contanti registrato con successo!');
                }

                // Reindirizza alla pagina di successo con metodo CASH. Solo un ordine che il server ha già
                // completato (totale 0, Wallet) conta come acquisto concluso: in reception resta da pagare.
                if (result && result.status === 'completed') {
                    this.vaiAlSuccessoCompletato('CASH');
                } else {
                    this.$router.push({ path: '/success', query: { method: 'CASH', source: this.checkoutSource } });
                }
            } catch (error) {
                console.error('Errore durante il pagamento:', error);
                this.showErrorAlert(error.message || 'Si è verificato un errore durante il pagamento.');
            } finally {
                this.isLoading = false;
            }
        },
        // Incasso in contanti al kiosk: crea l'ordine (pending), incassa il
        // contante sul Cashmatic tramite il gateway (window.kioskPay), che poi
        // conferma gli ordini al backend via HMAC. Nessun token nel renderer.
        async handleKioskCashPayment() {
            if (!window.kioskPay) {
                this.showErrorAlert('Modulo di pagamento del kiosk non disponibile.');
                return;
            }
            // Se il wallet copre tutto, usa il flusso wallet standard.
            if (this.useWalletCredit && this.userLogged) {
                await this.loadWalletBalance();
                const total = this.selectedVariationPrice?.total || 0;
                if (this.walletBalance >= total) {
                    await this.handleWalletPayment();
                    return;
                }
            }
            try {
                this.isLoading = true;
                // 1. Crea l'ordine e ottieni orderIds + residuo da incassare.
                const paymentRequest = this.createPaymentRequest('cash');
                const response = await fetch('https://api.elitefitness.it/api/payment/cash/create', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${this.userToken}` },
                    body: JSON.stringify(paymentRequest),
                });
                if (!response.ok) {
                    let errorMsg = 'Errore durante la creazione dell\'ordine';
                    try { const e = await response.json(); errorMsg = e.message || e.error || errorMsg; } catch { /* default */ }
                    throw new Error(errorMsg);
                }
                const result = await response.json();
                const orderIds = result.orderIds || [];
                const remaining = Number(result.remainingAmount || 0);
                if (!orderIds.length) throw new Error('Ordine non creato correttamente.');

                // Wallet ha coperto tutto: nessun contante da incassare.
                if (remaining <= 0) {
                    this.showSuccessAlert('Pagamento completato con credito Wallet!');
                    this.$router.push({ path: '/success', query: { method: 'CASH_KIOSK', source: this.checkoutSource } });
                    return;
                }

                // 2. Incassa il contante sul Cashmatic (il gateway conferma al backend).
                const res = await window.kioskPay.payCash({ orderIds, amount: Math.round(remaining * 100) });
                if (res && res.collected && res.orderConfirmed) {
                    if (res.notDispensed && res.notDispensed > 0) {
                        this.showErrorAlert(`Incassato, ma resto non erogato: ${(res.notDispensed / 100).toFixed(2)}€. Rivolgersi alla reception.`);
                    }
                    this.$router.push({ path: '/success', query: { method: 'CASH_KIOSK', source: this.checkoutSource } });
                } else if (res && res.collected && !res.orderConfirmed) {
                    this.showErrorAlert('Incasso ricevuto ma conferma in sospeso. Rivolgersi alla reception.');
                    this.$router.push({ path: '/success', query: { method: 'CASH_KIOSK', source: this.checkoutSource } });
                } else {
                    const msg = (res && res.collect && res.collect.end)
                        ? `Pagamento non riuscito (${res.collect.end}).`
                        : ((res && res.error) || 'Pagamento non completato.');
                    this.showErrorAlert(msg);
                }
            } catch (error) {
                console.error('Errore pagamento kiosk:', error);
                this.showErrorAlert(error.message || 'Si è verificato un errore durante il pagamento.');
            } finally {
                this.isLoading = false;
            }
        },
        // Incasso con carta al kiosk sul POS Nexi (ECR-LAN): stesso schema dei contanti. Il main process
        // parla col terminale e, ad approvazione avvenuta, conferma al backend con metodo POS.
        async handleKioskCardPayment() {
            if (!window.kioskPay || !window.kioskPay.payCard) {
                this.showErrorAlert('Modulo di pagamento del kiosk non disponibile.');
                return;
            }
            const avail = await window.kioskPay.isCardAvailable().catch(() => null);
            if (!avail || !avail.available) {
                this.showErrorAlert('Il pagamento con carta (POS) non è disponibile su questo kiosk. Usa i contanti.');
                return;
            }
            // Se il wallet copre tutto, usa il flusso wallet standard.
            if (this.useWalletCredit && this.userLogged) {
                await this.loadWalletBalance();
                const total = this.selectedVariationPrice?.total || 0;
                if (this.walletBalance >= total) {
                    await this.handleWalletPayment();
                    return;
                }
            }
            try {
                this.isLoading = true;
                // 1. Crea l'ordine (in attesa) e ottieni orderIds + residuo da incassare.
                const paymentRequest = this.createPaymentRequest('cash');
                const response = await fetch('https://api.elitefitness.it/api/payment/cash/create', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${this.userToken}` },
                    body: JSON.stringify(paymentRequest),
                });
                if (!response.ok) {
                    let errorMsg = 'Errore durante la creazione dell\'ordine';
                    try { const e = await response.json(); errorMsg = e.message || e.error || errorMsg; } catch { /* default */ }
                    throw new Error(errorMsg);
                }
                const result = await response.json();
                const orderIds = result.orderIds || [];
                const remaining = Number(result.remainingAmount || 0);
                if (!orderIds.length) throw new Error('Ordine non creato correttamente.');

                // Wallet ha coperto tutto: nessuna carta da incassare.
                if (remaining <= 0) {
                    this.showSuccessAlert('Pagamento completato con credito Wallet!');
                    this.$router.push({ path: '/success', query: { method: 'CARD_KIOSK', source: this.checkoutSource } });
                    return;
                }

                // 2. Incassa sul POS. Finché il terminale lavora, né il timeout né «Chiudi» devono
                //    interrompere: l'overlay dice al socio cosa fare.
                const cents = Math.round(remaining * 100);
                kioskSession.card.amount = cents;
                kioskSession.card.message = '';
                kioskSession.cardActive = true;
                let res;
                try {
                    res = await window.kioskPay.payCard({ orderIds, amount: cents });
                } finally {
                    kioskSession.cardActive = false;
                }

                if (res && res.collected && res.orderConfirmed) {
                    this.$router.push({ path: '/success', query: { method: 'CARD_KIOSK', source: this.checkoutSource } });
                } else if (res && res.collected) {
                    // Carta addebitata ma conferma al server in sospeso: l'ordine si salda dalla reception.
                    this.showErrorAlert('Pagamento ricevuto ma conferma in sospeso. Rivolgersi alla reception.');
                    this.$router.push({ path: '/success', query: { method: 'CARD_KIOSK', source: this.checkoutSource } });
                } else {
                    this.showErrorAlert(this.kioskCardErrorMessage(res));
                }
            } catch (error) {
                console.error('Errore pagamento carta kiosk:', error);
                this.showErrorAlert(error.message || 'Si è verificato un errore durante il pagamento.');
            } finally {
                kioskSession.cardActive = false;
                this.isLoading = false;
            }
        },
        // Messaggio per il socio a partire dall'esito del gateway POS. L'esito INCERTO non invita mai a
        // riprovare: la carta potrebbe essere stata addebitata.
        kioskCardErrorMessage(res) {
            const c = (res && res.collect) || {};
            if (c.uncertain) {
                return 'Non siamo riusciti a confermare l\'esito del pagamento. NON riprovare: rivolgersi alla reception.';
            }
            switch (c.error) {
                case 'POS_RIFIUTATO': return 'Pagamento rifiutato dalla carta.' + (c.end ? ` (${c.end})` : '');
                case 'POS_NON_RAGGIUNGIBILE': return 'Il terminale POS non risponde. Usa i contanti o rivolgiti alla reception.';
                case 'POS_NESSUN_ACK':
                case 'POS_NAK': return 'Il terminale POS non ha accettato la richiesta. Riprova o usa i contanti.';
                case 'POS_OCCUPATO': return 'Il terminale POS è occupato. Riprova tra un momento.';
                case 'POS_NON_CONNESSO': return 'Il pagamento con carta (POS) non è disponibile su questo kiosk. Usa i contanti.';
                default: return (res && res.error) || 'Pagamento non completato.';
            }
        },
        async handleWalletPayment() {
            // Validazione: verifica che il wallet abbia abbastanza credito
            if (!this.useWalletCredit || this.walletBalance <= 0) {
                this.showErrorAlert('Credito wallet non disponibile.');
                return;
            }
            
            const total = this.selectedVariationPrice?.total || 0;
            if (this.walletBalance < total) {
                this.showErrorAlert('Credito wallet insufficiente per coprire l\'intero importo.');
                return;
            }
            
            // Validazione Gift Card
            if (this.isGiftCard && !this.giftCardRecipientEmail) {
                this.showErrorAlert('Inserisci l\'email del destinatario per completare l\'acquisto della Gift Card.');
                return;
            }
            
            try {
                this.isLoading = true;
                
                // Crea il payment request con useWalletCredit=true
                const paymentRequest = this.createPaymentRequest('cash');
                
                const response = await fetch('https://api.elitefitness.it/api/payment/cash/create', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.userToken}`,
                    },
                    body: JSON.stringify(paymentRequest),
                });
                
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Errore durante il pagamento con wallet: ${errorText}`);
                }
                
                const result = await response.json();
                console.log('Wallet payment result:', result);
                
                // Se il backend conferma che il pagamento è completato
                if (result.status === 'completed' || result.message?.includes('completato')) {
                    this.showSuccessAlert('Pagamento completato con credito Wallet!');
                    // Reindirizza alla pagina di successo
                    this.vaiAlSuccessoCompletato('WALLET');
                } else {
                    // Fallback: reindirizza comunque alla pagina di successo (senza ricordare il carrello come
                    // concluso: il server non l'ha detto)
                    this.showSuccessAlert('Pagamento completato con credito Wallet!');
                    this.$router.push({ path: '/success', query: { method: 'WALLET', source: this.checkoutSource } });
                }
            } catch (error) {
                console.error('Errore durante il pagamento con wallet:', error);
                this.showErrorAlert(error.message || 'Si è verificato un errore durante il pagamento con wallet.');
            } finally {
                this.isLoading = false;
            }
        },
        async register() {
            if (this.emailError) {
                this.showErrorAlert("L'email non è valida o è già in uso.");
                return;
            }

            if (this.passwordError) {
                this.showErrorAlert("La password non soddisfa i requisiti minimi di sicurezza.");
                return;
            }
            if (!this.hasAcceptedTermsSignup) {
                this.showErrorAlert('Per procedere accetta termini, privacy, regolamento, codice etico e dichiarazione sui documenti.');
                return;
            }
            
            // Se è Italia, il CF è obbligatorio e deve essere valido
            if (this.isItaly) {
                // Controlla che il CF sia presente
                if (!this.user.taxCode || this.user.taxCode.trim() === '') {
                    this.showErrorAlert('Il codice fiscale è obbligatorio per utenti italiani.');
                    this.taxCodeError = 'Il codice fiscale è obbligatorio';
                    return;
                }
                
                // Controlla che il CF abbia esattamente 16 caratteri
                if (this.user.taxCode.length !== 16) {
                    this.showErrorAlert('Il codice fiscale deve contenere esattamente 16 caratteri.');
                    this.taxCodeError = `Il codice fiscale deve contenere esattamente 16 caratteri. Caratteri inseriti: ${this.user.taxCode.length}`;
                    return;
                }
                
                // Valida sempre il CF prima del submit
                this.validateTaxCode();
                // Aspetta un momento per la validazione
                await new Promise(resolve => setTimeout(resolve, 100));
                
                // Se c'è un errore di validazione, blocca il submit
                if (this.taxCodeError) {
                    this.showErrorAlert('Il codice fiscale non è valido. Correggere gli errori prima di procedere.');
                    return;
                }
            }

            this.isLoading = true; // Attiva il caricamento
            try {
                // Registrazione utente
                const userPayload = { ...this.user };
                
                // Epurazione dei campi numeri di telefono: rimuove gli spazi
                if (userPayload.phoneNumber) {
                    userPayload.phoneNumber = userPayload.phoneNumber.replace(/\s+/g, '');
                }
                if (userPayload.mobileNumber) {
                    userPayload.mobileNumber = userPayload.mobileNumber.replace(/\s+/g, '');
                }
                if (userPayload.legalGuardian?.phoneNumber) {
                    userPayload.legalGuardian.phoneNumber = userPayload.legalGuardian.phoneNumber.replace(/\s+/g, '');
                }
                userPayload.dateOfBirth = dateOfBirthToApiIso(userPayload.dateOfBirth);
                
                // Invia i dati del tutore solo se minorenne e compilati
                if (!this.isMinor) {
                    delete userPayload.legalGuardian;
                }

                const acceptances = {
                    terms: true,
                    privacy: true,
                    regulation: true,
                    ethical: true,
                    identityDocs: true
                };
                const challengePayload = {
                    email: String(userPayload.email || '').trim().toLowerCase(),
                    firstName: String(userPayload.firstName || '').trim().toUpperCase(),
                    lastName: String(userPayload.lastName || '').trim().toUpperCase(),
                    dateOfBirth: userPayload.dateOfBirth,
                    placeOfBirth: (userPayload.placeOfBirth || '').trim().toUpperCase() || undefined,
                    taxCode: String(userPayload.taxCode || '').trim().toUpperCase(),
                    gender: userPayload.gender,
                    address: (userPayload.address || '').trim().toUpperCase() || undefined,
                    city: String(userPayload.city || '').trim().toUpperCase(),
                    postalCode: String(userPayload.postalCode || '').trim(),
                    province: String(userPayload.province || '').trim().toUpperCase(),
                    country: String(userPayload.country || '').trim(),
                    phoneNumber: String(userPayload.phoneNumber || '').replace(/\s+/g, '').toUpperCase(),
                    mobileNumber: (userPayload.mobileNumber || '').replace(/\s+/g, '').toUpperCase() || undefined,
                    postConfirmationRoute: this.buildReturnUrl(),
                    acceptances
                };
                if (this.referralCode && String(this.referralCode).trim()) {
                    challengePayload.referralCode = String(this.referralCode).trim();
                }
                if (this.isMinor && userPayload.legalGuardian) {
                    const g = userPayload.legalGuardian;
                    challengePayload.legalGuardian = {
                        firstName: String(g.firstName || '').trim().toUpperCase(),
                        lastName: String(g.lastName || '').trim().toUpperCase(),
                        taxCode: String(g.taxCode || '').trim().toUpperCase(),
                        relationship: String(g.relationship || '').trim(),
                        email: String(g.email || '').trim().toLowerCase(),
                        phoneNumber: String(g.phoneNumber || '').replace(/\s+/g, '').toUpperCase()
                    };
                }

                const signingExtras = await buildRegistrationSigningAttachments({ challengePayload });

                const response = await fetch('https://api.elitefitness.it/api/auth/register', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        ...userPayload,
                        ...signingExtras,
                        // Use encoded, complete checkout URL so the email verification can return here
                        postConfirmationRoute: this.buildReturnUrl(),
                        // Passa il referral code per "Invita un Amico"
                        referralCode: this.referralCode || undefined
                    }),
                });

                if (!response.ok) {
                    let errorMsg = 'Errore durante la registrazione';
                    try {
                        const errorData = await response.json();
                        errorMsg = errorData?.message || errorData?.error || errorMsg;
                    } catch (_) {
                        try {
                            errorMsg = await response.text();
                        } catch (parseErr) {
                            // Fallback silenzioso per ESLint: mantieni il messaggio di default
                            console.warn('Register error response not parseable as text:', parseErr);
                        }
                    }
                    throw new Error(errorMsg);
                }

                console.log('Registrazione completata.');

            } catch (error) {
                console.error('Errore durante la registrazione:', error);
                // Rilancia l'eccezione per far fallire la Promise e permettere al chiamante di gestire l'errore
                // Il chiamante mostrerà l'errore tramite showErrorAlert()
                throw error;
            } finally {
                this.isLoading = false; // Disattiva il caricamento
            }
        },
        updateDateOfBirth(date) {
            // Normalizza a Date per il calcolo dell'età
            try {
                this.user.dateOfBirth = date instanceof Date ? date : new Date(date);
            } catch (_) { /* no-op */ }
            console.log('Data di nascita aggiornata:', this.user.dateOfBirth);
            
            // Valida il codice fiscale se presente e se è Italia
            if (this.isItaly && this.user.taxCode && this.user.taxCode.length === 16) {
                this.validateTaxCode();
            }
        },
        
        onGenderChange() {
            // Valida il codice fiscale se presente e se è Italia
            if (this.isItaly && this.user.taxCode && this.user.taxCode.length === 16) {
                this.validateTaxCode();
            }
        },
        
        onFirstNameChange() {
            // Valida il codice fiscale se presente e se è Italia
            if (this.isItaly && this.user.taxCode && this.user.taxCode.length === 16) {
                this.validateTaxCode();
            }
        },
        
        onLastNameChange() {
            // Valida il codice fiscale se presente e se è Italia
            if (this.isItaly && this.user.taxCode && this.user.taxCode.length === 16) {
                this.validateTaxCode();
            }
        },
        
        // Metodi per autocompletamento ISTAT utente principale
        onPlaceOfBirthInput() {
            this.clearPlaceOfBirthTimeout();
            if (this.user.placeOfBirth.length >= 2) {
                this.placeOfBirthSearchTimeout = setTimeout(() => {
                    this.searchPlaceOfBirth(this.user.placeOfBirth);
                }, 300);
            } else {
                this.showPlaceOfBirthSuggestions = false;
                this.placeOfBirthSuggestions = [];
            }
        },
        
        onPlaceOfBirthFocus() {
            if (this.placeOfBirthSuggestions.length > 0) {
                this.showPlaceOfBirthSuggestions = true;
            }
        },
        
        onPlaceOfBirthBlur() {
            setTimeout(() => {
                this.showPlaceOfBirthSuggestions = false;
            }, 200);
        },
        
        async searchPlaceOfBirth(query) {
            if (!query || query.length < 2) return;
            
            this.isLoadingPlaceOfBirth = true;
            try {
                const response = await fetch(`https://api.elitefitness.it/api/open/istat/comuni/search?nome=${encodeURIComponent(query)}`);
                const result = await response.json();
                
                if (result.success && result.data) {
                    this.placeOfBirthSuggestions = result.data;
                    this.showPlaceOfBirthSuggestions = true;
                } else {
                    this.placeOfBirthSuggestions = [];
                    this.showPlaceOfBirthSuggestions = false;
                }
            } catch (error) {
                console.error('Errore nella ricerca luogo di nascita ISTAT:', error);
                this.placeOfBirthSuggestions = [];
                this.showPlaceOfBirthSuggestions = false;
            } finally {
                this.isLoadingPlaceOfBirth = false;
            }
        },
        
        selectPlaceOfBirth(suggestion) {
            this.user.placeOfBirth = suggestion.nome;
            this.showPlaceOfBirthSuggestions = false;
            this.placeOfBirthSuggestions = [];
        },
        
        clearPlaceOfBirthTimeout() {
            if (this.placeOfBirthSearchTimeout) {
                clearTimeout(this.placeOfBirthSearchTimeout);
                this.placeOfBirthSearchTimeout = null;
            }
        },
        
        onCityInput() {
            this.clearCityTimeout();
            // Abilita autocompletamento ISTAT solo se la nazione è Italy
            if (!this.isItaly) {
                this.showCitySuggestions = false;
                this.citySuggestions = [];
                return;
            }
            if (this.user.city.length >= 2) {
                this.citySearchTimeout = setTimeout(() => {
                    this.searchCities(this.user.city);
                }, 300);
            } else {
                this.showCitySuggestions = false;
                this.citySuggestions = [];
            }
        },
        
        onCityFocus() {
            // Mostra suggerimenti solo se è Italy
            if (this.isItaly && this.citySuggestions.length > 0) {
                this.showCitySuggestions = true;
            }
        },
        
        onCityBlur() {
            setTimeout(() => {
                this.showCitySuggestions = false;
            }, 200);
        },
        
        async searchCities(query) {
            if (!query || query.length < 2) return;
            
            this.isLoadingCities = true;
            try {
                const response = await fetch(`https://api.elitefitness.it/api/open/istat/comuni/search?nome=${encodeURIComponent(query)}`);
                const result = await response.json();
                
                if (result.success && result.data) {
                    this.citySuggestions = result.data;
                    this.showCitySuggestions = true;
                } else {
                    this.citySuggestions = [];
                    this.showCitySuggestions = false;
                }
            } catch (error) {
                console.error('Errore nella ricerca città ISTAT:', error);
                this.citySuggestions = [];
                this.showCitySuggestions = false;
            } finally {
                this.isLoadingCities = false;
            }
        },
        
        selectCity(suggestion) {
            this.user.city = suggestion.nome;
            this.showCitySuggestions = false;
            this.citySuggestions = [];
            
            // Aggiorna automaticamente i campi correlati
            if (suggestion.provincia && suggestion.provincia.nome) {
                this.user.province = suggestion.provincia.nome;
            }
            if (suggestion.cap && suggestion.cap.length > 0) {
                this.user.postalCode = suggestion.cap[0];
            }
        },
        
        clearCityTimeout() {
            if (this.citySearchTimeout) {
                clearTimeout(this.citySearchTimeout);
                this.citySearchTimeout = null;
            }
        },
        
        onPostalCodeInput() {
            this.clearPostalCodeTimeout();
            // Abilita autocompletamento ISTAT solo se la nazione è Italy
            if (!this.isItaly) {
                this.showPostalCodeSuggestions = false;
                this.postalCodeSuggestions = [];
                return;
            }
            if (this.user.postalCode.length >= 3) {
                this.postalCodeSearchTimeout = setTimeout(() => {
                    this.searchPostalCodes(this.user.postalCode);
                }, 300);
            } else {
                this.showPostalCodeSuggestions = false;
                this.postalCodeSuggestions = [];
            }
        },
        
        onPostalCodeFocus() {
            // Mostra suggerimenti solo se è Italy
            if (this.isItaly && this.postalCodeSuggestions.length > 0) {
                this.showPostalCodeSuggestions = true;
            }
        },
        
        onPostalCodeBlur() {
            setTimeout(() => {
                this.showPostalCodeSuggestions = false;
            }, 200);
        },
        
        async searchPostalCodes(query) {
            if (!query || query.length < 3) return;
            
            this.isLoadingPostalCodes = true;
            try {
                const response = await fetch(`https://api.elitefitness.it/api/open/istat/cap/search?codice=${encodeURIComponent(query)}`);
                const result = await response.json();
                
                if (result.success && result.data) {
                    this.postalCodeSuggestions = result.data;
                    this.showPostalCodeSuggestions = true;
                } else {
                    this.postalCodeSuggestions = [];
                    this.showPostalCodeSuggestions = false;
                }
            } catch (error) {
                console.error('Errore nella ricerca CAP ISTAT:', error);
                this.postalCodeSuggestions = [];
                this.showPostalCodeSuggestions = false;
            } finally {
                this.isLoadingPostalCodes = false;
            }
        },
        
        selectPostalCode(suggestion) {
            this.user.postalCode = suggestion.codice;
            this.showPostalCodeSuggestions = false;
            this.postalCodeSuggestions = [];
            
            // Aggiorna automaticamente i campi correlati
            if (suggestion.comune && suggestion.comune.nome) {
                this.user.city = suggestion.comune.nome;
            }
            if (suggestion.provincia && suggestion.provincia.nome) {
                this.user.province = suggestion.provincia.nome;
            }
        },
        
        clearPostalCodeTimeout() {
            if (this.postalCodeSearchTimeout) {
                clearTimeout(this.postalCodeSearchTimeout);
                this.postalCodeSearchTimeout = null;
            }
        },
        
        onProvinceInput() {
            this.clearProvinceTimeout();
            // Abilita autocompletamento ISTAT solo se la nazione è Italy
            if (!this.isItaly) {
                this.showProvinceSuggestions = false;
                this.provinceSuggestions = [];
                return;
            }
            if (this.user.province.length >= 2) {
                this.provinceSearchTimeout = setTimeout(() => {
                    this.searchProvinces(this.user.province);
                }, 300);
            } else {
                this.showProvinceSuggestions = false;
                this.provinceSuggestions = [];
            }
        },
        
        onProvinceFocus() {
            // Mostra suggerimenti solo se è Italy
            if (this.isItaly && this.provinceSuggestions.length > 0) {
                this.showProvinceSuggestions = true;
            }
        },
        
        onProvinceBlur() {
            setTimeout(() => {
                this.showProvinceSuggestions = false;
            }, 200);
        },
        
        async searchProvinces(query) {
            if (!query || query.length < 2) return;
            
            this.isLoadingProvinces = true;
            try {
                const response = await fetch(`https://api.elitefitness.it/api/open/istat/province/search?nome=${encodeURIComponent(query)}`);
                const result = await response.json();
                
                if (result.success && result.data) {
                    this.provinceSuggestions = result.data;
                    this.showProvinceSuggestions = true;
                } else {
                    this.provinceSuggestions = [];
                    this.showProvinceSuggestions = false;
                }
            } catch (error) {
                console.error('Errore nella ricerca province ISTAT:', error);
                this.provinceSuggestions = [];
                this.showProvinceSuggestions = false;
            } finally {
                this.isLoadingProvinces = false;
            }
        },
        
        selectProvince(suggestion) {
            this.user.province = suggestion.nome;
            this.showProvinceSuggestions = false;
            this.provinceSuggestions = [];
        },
        
        clearProvinceTimeout() {
            if (this.provinceSearchTimeout) {
                clearTimeout(this.provinceSearchTimeout);
                this.provinceSearchTimeout = null;
            }
        },
        
        // Metodi per dropdown nazione con ricerca
        async loadAllCountries() {
            this.isLoadingCountries = true;
            try {
                const response = await fetch('https://api.elitefitness.it/api/open/istat/countries/all');
                const result = await response.json();
                
                if (result.success && result.data) {
                    this.allCountries = result.data;
                    // Ordina per nome
                    this.allCountries.sort((a, b) => a.name.localeCompare(b.name));
                } else {
                    this.allCountries = [];
                }
            } catch (error) {
                console.error('Errore nel caricamento paesi:', error);
                this.allCountries = [];
            } finally {
                this.isLoadingCountries = false;
            }
        },
        
        toggleCountryDropdown(event) {
            // Previeni la propagazione
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            
            if (!this.showCountryDropdown) {
                this.openCountryDropdown();
            } else {
                this.closeCountryDropdown();
            }
        },
        
        openCountryDropdown() {
            this.showCountryDropdown = true;
            this.countrySearchQuery = '';
            // Carica i paesi se non sono ancora stati caricati
            if (this.allCountries.length === 0) {
                this.loadAllCountries();
            }
            // Aggiungi listener per click esterni solo dopo che il DOM è stato aggiornato
            this.$nextTick(() => {
                // Focus sul campo di ricerca
                if (this.$refs.countrySearchInput) {
                    this.$refs.countrySearchInput.focus();
                }
                // Aggiungi listener per click esterni con un delay per evitare che il click corrente lo chiuda
                setTimeout(() => {
                    document.addEventListener('mousedown', this.handleClickOutside, true);
                }, 250);
            });
        },
        
        closeCountryDropdown() {
            this.showCountryDropdown = false;
            this.countrySearchQuery = '';
            // Rimuovi listener per click esterni
            document.removeEventListener('mousedown', this.handleClickOutside, true);
        },
        
        handleClickOutside(event) {
            // Non chiudere se il dropdown non è aperto
            if (!this.showCountryDropdown) {
                return;
            }
            
            // Verifica se il click è dentro il container o il dropdown
            const container = this.$refs.countryContainer;
            const dropdown = this.$refs.countryDropdown;
            
            if (!container) {
                return;
            }
            
            // Se il click è dentro il container o il dropdown, non fare nulla
            if (container.contains(event.target) || (dropdown && dropdown.contains(event.target))) {
                return;
            }
            
            // Se siamo qui, il click è fuori, quindi chiudi
            this.closeCountryDropdown();
        },
        
        
        filterCountries() {
            // Il filteredCountries computed si aggiorna automaticamente
            // Questo metodo può essere usato per logica aggiuntiva se necessaria
        },
        
        selectCountry(country, event) {
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            this.user.country = country.name;
            this.closeCountryDropdown();
            // Se il paese selezionato non è Italia, pulisci i suggerimenti ISTAT
            if (country.code !== 'IT') {
                this.citySuggestions = [];
                this.postalCodeSuggestions = [];
                this.provinceSuggestions = [];
                this.showCitySuggestions = false;
                this.showPostalCodeSuggestions = false;
                this.showProvinceSuggestions = false;
                // Pulisci anche l'errore CF se non è Italia
                if (!this.isItaly) {
                    this.taxCodeError = null;
                }
            }
            // Se diventa Italia e c'è già un CF inserito, valida
            if (country.code === 'IT' && this.user.taxCode && this.user.taxCode.length === 16) {
                this.validateTaxCode();
            }
        },
        
        // Metodi per validazione codice fiscale
        clearTaxCodeValidationTimeout() {
            if (this.taxCodeValidationTimeout) {
                clearTimeout(this.taxCodeValidationTimeout);
                this.taxCodeValidationTimeout = null;
            }
        },
        
        onTaxCodeInput() {
            // Converti a maiuscolo
            this.user.taxCode = this.user.taxCode.toUpperCase().replace(/[^A-Z0-9]/g, '');
            
            // Se non è Italia, non validare
            if (!this.isItaly) {
                this.taxCodeError = null;
                return;
            }
            
            // Se il CF è vuoto, pulisci l'errore
            if (!this.user.taxCode || this.user.taxCode.trim() === '') {
                this.taxCodeError = null;
                this.clearTaxCodeValidationTimeout();
                return;
            }
            
            // Se il CF ha raggiunto 16 caratteri, valida immediatamente (senza debounce)
            if (this.user.taxCode.length === 16) {
                this.clearTaxCodeValidationTimeout();
                // Valida immediatamente
                this.validateTaxCode();
            } else if (this.user.taxCode.length < 16) {
                // Durante la digitazione (prima di raggiungere 16 caratteri), pulisci l'errore
                this.taxCodeError = null;
                this.clearTaxCodeValidationTimeout();
            } else {
                // Se supera 16 caratteri, mostra errore immediato
                this.clearTaxCodeValidationTimeout();
                this.taxCodeError = 'Il codice fiscale deve contenere esattamente 16 caratteri';
            }
        },
        
        onTaxCodeBlur() {
            this.clearTaxCodeValidationTimeout();
            
            // Se non è Italia, non validare
            if (!this.isItaly) {
                this.taxCodeError = null;
                return;
            }
            
            // Valida quando l'utente esce dal campo
            if (this.user.taxCode && this.user.taxCode.trim() !== '') {
                // Se ha meno di 16 caratteri, mostra errore immediato
                if (this.user.taxCode.length < 16) {
                    this.taxCodeError = `Il codice fiscale deve contenere esattamente 16 caratteri. Caratteri inseriti: ${this.user.taxCode.length}`;
                    return;
                }
                // Se ha 16 caratteri, valida completamente
                this.validateTaxCode();
            }
        },
        
        validateTaxCode() {
            if (!this.isItaly) {
                this.taxCodeError = null;
                return;
            }
            
            if (!this.user.taxCode || this.user.taxCode.trim() === '') {
                this.taxCodeError = null;
                return;
            }
            
            try {
                const userData = {
                    firstName: this.user.firstName,
                    lastName: this.user.lastName,
                    dateOfBirth: this.user.dateOfBirth,
                    gender: this.user.gender
                };
                
                const result = validateItalianTaxCode(this.user.taxCode, userData);
                
                if (!result.valid) {
                    // Usa il messaggio dettagliato se disponibile, altrimenti l'errore generico
                    this.taxCodeError = result.message || result.error;
                    // Aggiorna il CF con la versione pulita se disponibile
                    if (result.cleanTaxCode && result.cleanTaxCode !== this.user.taxCode) {
                        this.user.taxCode = result.cleanTaxCode;
                    }
                } else {
                    this.taxCodeError = null;
                    // Aggiorna il CF con la versione pulita se disponibile
                    if (result.cleanTaxCode && result.cleanTaxCode !== this.user.taxCode) {
                        this.user.taxCode = result.cleanTaxCode;
                    }
                }
            } catch (error) {
                console.error('Errore nella validazione del codice fiscale:', error);
                this.taxCodeError = 'Errore nella validazione del codice fiscale';
            }
        },
        
        // Metodi per autocompletamento ISTAT tutore legale
        onLegalGuardianCityInput() {
            this.clearLegalGuardianCityTimeout();
            if (this.user.legalGuardian.city.length >= 2) {
                this.legalGuardianCitySearchTimeout = setTimeout(() => {
                    this.searchLegalGuardianCities(this.user.legalGuardian.city);
                }, 300);
            } else {
                this.showLegalGuardianCitySuggestions = false;
                this.legalGuardianCitySuggestions = [];
            }
        },
        
        onLegalGuardianCityFocus() {
            if (this.legalGuardianCitySuggestions.length > 0) {
                this.showLegalGuardianCitySuggestions = true;
            }
        },
        
        onLegalGuardianCityBlur() {
            setTimeout(() => {
                this.showLegalGuardianCitySuggestions = false;
            }, 200);
        },
        
        async searchLegalGuardianCities(query) {
            if (!query || query.length < 2) return;
            
            this.isLoadingLegalGuardianCities = true;
            try {
                const response = await fetch(`https://api.elitefitness.it/api/open/istat/comuni/search?nome=${encodeURIComponent(query)}`);
                const result = await response.json();
                
                if (result.success && result.data) {
                    this.legalGuardianCitySuggestions = result.data;
                    this.showLegalGuardianCitySuggestions = true;
                } else {
                    this.legalGuardianCitySuggestions = [];
                    this.showLegalGuardianCitySuggestions = false;
                }
            } catch (error) {
                console.error('Errore nella ricerca città tutore ISTAT:', error);
                this.legalGuardianCitySuggestions = [];
                this.showLegalGuardianCitySuggestions = false;
            } finally {
                this.isLoadingLegalGuardianCities = false;
            }
        },
        
        selectLegalGuardianCity(suggestion) {
            this.user.legalGuardian.city = suggestion.nome;
            this.showLegalGuardianCitySuggestions = false;
            this.legalGuardianCitySuggestions = [];
            
            // Aggiorna automaticamente i campi correlati
            if (suggestion.provincia && suggestion.provincia.nome) {
                this.user.legalGuardian.province = suggestion.provincia.nome;
            }
            if (suggestion.cap && suggestion.cap.length > 0) {
                this.user.legalGuardian.postalCode = suggestion.cap[0];
            }
        },
        
        clearLegalGuardianCityTimeout() {
            if (this.legalGuardianCitySearchTimeout) {
                clearTimeout(this.legalGuardianCitySearchTimeout);
                this.legalGuardianCitySearchTimeout = null;
            }
        },
        
        onLegalGuardianPostalCodeInput() {
            this.clearLegalGuardianPostalCodeTimeout();
            if (this.user.legalGuardian.postalCode.length >= 3) {
                this.legalGuardianPostalCodeSearchTimeout = setTimeout(() => {
                    this.searchLegalGuardianPostalCodes(this.user.legalGuardian.postalCode);
                }, 300);
            } else {
                this.showLegalGuardianPostalCodeSuggestions = false;
                this.legalGuardianPostalCodeSuggestions = [];
            }
        },
        
        onLegalGuardianPostalCodeFocus() {
            if (this.legalGuardianPostalCodeSuggestions.length > 0) {
                this.showLegalGuardianPostalCodeSuggestions = true;
            }
        },
        
        onLegalGuardianPostalCodeBlur() {
            setTimeout(() => {
                this.showLegalGuardianPostalCodeSuggestions = false;
            }, 200);
        },
        
        async searchLegalGuardianPostalCodes(query) {
            if (!query || query.length < 3) return;
            
            this.isLoadingLegalGuardianPostalCodes = true;
            try {
                const response = await fetch(`https://api.elitefitness.it/api/open/istat/cap/search?codice=${encodeURIComponent(query)}`);
                const result = await response.json();
                
                if (result.success && result.data) {
                    this.legalGuardianPostalCodeSuggestions = result.data;
                    this.showLegalGuardianPostalCodeSuggestions = true;
                } else {
                    this.legalGuardianPostalCodeSuggestions = [];
                    this.showLegalGuardianPostalCodeSuggestions = false;
                }
            } catch (error) {
                console.error('Errore nella ricerca CAP tutore ISTAT:', error);
                this.legalGuardianPostalCodeSuggestions = [];
                this.showLegalGuardianPostalCodeSuggestions = false;
            } finally {
                this.isLoadingLegalGuardianPostalCodes = false;
            }
        },
        
        selectLegalGuardianPostalCode(suggestion) {
            this.user.legalGuardian.postalCode = suggestion.codice;
            this.showLegalGuardianPostalCodeSuggestions = false;
            this.legalGuardianPostalCodeSuggestions = [];
            
            // Aggiorna automaticamente i campi correlati
            if (suggestion.comune && suggestion.comune.nome) {
                this.user.legalGuardian.city = suggestion.comune.nome;
            }
            if (suggestion.provincia && suggestion.provincia.nome) {
                this.user.legalGuardian.province = suggestion.provincia.nome;
            }
        },
        
        clearLegalGuardianPostalCodeTimeout() {
            if (this.legalGuardianPostalCodeSearchTimeout) {
                clearTimeout(this.legalGuardianPostalCodeSearchTimeout);
                this.legalGuardianPostalCodeSearchTimeout = null;
            }
        },
        
        onLegalGuardianProvinceInput() {
            this.clearLegalGuardianProvinceTimeout();
            if (this.user.legalGuardian.province.length >= 2) {
                this.legalGuardianProvinceSearchTimeout = setTimeout(() => {
                    this.searchLegalGuardianProvinces(this.user.legalGuardian.province);
                }, 300);
            } else {
                this.showLegalGuardianProvinceSuggestions = false;
                this.legalGuardianProvinceSuggestions = [];
            }
        },
        
        onLegalGuardianProvinceFocus() {
            if (this.legalGuardianProvinceSuggestions.length > 0) {
                this.showLegalGuardianProvinceSuggestions = true;
            }
        },
        
        onLegalGuardianProvinceBlur() {
            setTimeout(() => {
                this.showLegalGuardianProvinceSuggestions = false;
            }, 200);
        },
        
        async searchLegalGuardianProvinces(query) {
            if (!query || query.length < 2) return;
            
            this.isLoadingLegalGuardianProvinces = true;
            try {
                const response = await fetch(`https://api.elitefitness.it/api/open/istat/province/search?nome=${encodeURIComponent(query)}`);
                const result = await response.json();
                
                if (result.success && result.data) {
                    this.legalGuardianProvinceSuggestions = result.data;
                    this.showLegalGuardianProvinceSuggestions = true;
                } else {
                    this.legalGuardianProvinceSuggestions = [];
                    this.showLegalGuardianProvinceSuggestions = false;
                }
            } catch (error) {
                console.error('Errore nella ricerca province tutore ISTAT:', error);
                this.legalGuardianProvinceSuggestions = [];
                this.showLegalGuardianProvinceSuggestions = false;
            } finally {
                this.isLoadingLegalGuardianProvinces = false;
            }
        },
        
        selectLegalGuardianProvince(suggestion) {
            this.user.legalGuardian.province = suggestion.nome;
            this.showLegalGuardianProvinceSuggestions = false;
            this.legalGuardianProvinceSuggestions = [];
        },
        
        clearLegalGuardianProvinceTimeout() {
            if (this.legalGuardianProvinceSearchTimeout) {
                clearTimeout(this.legalGuardianProvinceSearchTimeout);
                this.legalGuardianProvinceSearchTimeout = null;
            }
        },
        toggleFreeTrialMode() {
            if (this.selectedProduct?.type === 'REGISTRATION') {
                // Disallow free trial for REGISTRATION
                this.freeTrial = false;
                this.showToast('La prova gratuita non è disponibile per questo prodotto.', 'warning');
                return;
            }
            this.freeTrial = !this.freeTrial;
            if (this.freeTrial) {
                this.selectedVariationName = null;
                this.selectedVariation = null;
            }
            this.syncUrl();
        },
        generateFreeTierMessage(center) {
            const freeTierTimeSlots = center.freeTierTimeSlots;
            if (!freeTierTimeSlots || freeTierTimeSlots.length === 0) {
                return " non è disponibile in nessuna fascia oraria.";
            }

            let message = " è disponibile ";
            let groupedSlots = [];
            let tempGroup = [freeTierTimeSlots[0]];

            for (let i = 1; i < freeTierTimeSlots.length; i++) {
                const prev = freeTierTimeSlots[i - 1];
                const current = freeTierTimeSlots[i];

                if (prev.startTime === current.startTime && prev.endTime === current.endTime) {
                    tempGroup.push(current);
                } else {
                    groupedSlots.push(tempGroup);
                    tempGroup = [current];
                }
            }
            groupedSlots.push(tempGroup);

            const dayTranslation = {
                "MONDAY": "lunedì",
                "TUESDAY": "martedì",
                "WEDNESDAY": "mercoledì",
                "THURSDAY": "giovedì",
                "FRIDAY": "venerdì",
                "SATURDAY": "sabato",
                "SUNDAY": "domenica"
            };

            let slotMessages = groupedSlots.map(group => {
                let days = group.map(slot => dayTranslation[slot.dayOfWeek]);
                let startTime = group[0].startTime.replace(":00", "");
                let endTime = group[0].endTime.replace(":00", "");
                return `dal ${days[0]} al ${days[days.length - 1]}, dalle ${startTime} alle ${endTime}`;
            });

            message += slotMessages.join("; e ") + ".";
            return message;
        },
        generateFreeTierCourse(service) {
            const freeTierTimeSlots = service.timeSlots;
            if (!freeTierTimeSlots || freeTierTimeSlots.length === 0) {
                return " non è disponibile in nessuna fascia oraria.";
            }

            let message = " è disponibile ";
            let groupedSlots = [];
            let tempGroup = [freeTierTimeSlots[0]];

            for (let i = 1; i < freeTierTimeSlots.length; i++) {
                const prev = freeTierTimeSlots[i - 1];
                const current = freeTierTimeSlots[i];

                if (prev.startTime === current.startTime && prev.endTime === current.endTime &&
                    new Date(prev.dayOfWeek).getDay() + 1 === new Date(current.dayOfWeek).getDay()) {
                    tempGroup.push(current);
                } else {
                    groupedSlots.push(tempGroup);
                    tempGroup = [current];
                }
            }
            groupedSlots.push(tempGroup);

            const dayTranslation = {
                "MONDAY": "Lunedì",
                "TUESDAY": "Martedì",
                "WEDNESDAY": "Mercoledì",
                "THURSDAY": "Giovedì",
                "FRIDAY": "Venerdì",
                "SATURDAY": "Sabato",
                "SUNDAY": "Domenica"
            };

            let slotMessages = groupedSlots.map(group => {
                let days = group.map(slot => dayTranslation[slot.dayOfWeek]);
                let startTime = group[0].startTime.replace(":00", "");
                let endTime = group[0].endTime.replace(":00", "");
                return `il ${days.join(", ")}, dalle ${startTime} alle ${endTime}`;
            });

            message += slotMessages.join(", ") + ".";
            return message;
        },

        async updatePricesByTrainerInfo(trainerId) {
            try {
                if (!trainerId) return;
                console.log("updatePricesByTrainerInfo", trainerId);
                console.log("Selected trainers - BIA:", this.selectedBIATrainerId, "Target:", this.selectedTargetTrainerId, "Personal:", this.selectedPersonalTrainerId);

                let trainerData = null;
                // Usa dati in cache da API open (funziona senza login)
                const cached = this.trainerCustomPrices?.find(t => (t.id || t.trainerId) === trainerId);
                if (cached) {
                    trainerData = {
                        targetTrainingPrice: cached.targetTrainingPrice,
                        personalTrainingPrice: cached.personalTrainingPrice,
                        personalTrainingPackagePrice: cached.personalTrainingPackagePrice,
                        precisionTrainingPrice: cached.precisionTrainingPrice,
                        biaPrice: cached.biaPrice,
                    };
                } else {
                    // Fallback: API open senza auth
                    const response = await fetch(`https://api.elitefitness.it/api/open/trainerInfo/${trainerId}`);
                    if (!response.ok) {
                        throw new Error(`Failed to fetch trainer info: ${response.statusText}`);
                    }
                    trainerData = await response.json();
                }
                console.log("Trainer pricing data:", trainerData);

                // Mappa delle configurazioni per ogni tipo di servizio
                const serviceConfigs = [
                    {
                        name: 'BIA (Main Product)',
                        condition: () => this.selectedProduct?.type === 'BIA',
                        priceField: 'biaPrice',
                        updateLogic: (price) => {
                            if (price > 0) {
                                this.selectedProduct.price = price;
                                console.log("BIA Main Product Updated:", this.selectedProduct);
                            }
                        }
                    },
                    {
                        name: 'BIA (Upsell)',
                        condition: () => this.biaProduct && this.selectedBIATrainerId === trainerId,
                        priceField: 'biaPrice',
                        updateLogic: (price) => {
                            if (price > 0) {
                                this.biaProduct.price = price;
                                console.log("BIA Upsell Updated:", this.biaProduct.price);
                            }
                        }
                    },
                    {
                        name: 'Target Training (Main Product)',
                        condition: () => this.selectedProduct?.type === 'GYM' && 
                                        this.selectedProduct?.metadata?.type === 'TARGET_TRAINING' && 
                                        this.selectedTargetTrainerId === trainerId,
                        priceField: 'targetTrainingPrice',
                        updateLogic: (price) => {
                            if (price > 0) {
                                this.selectedProduct.price = price;
                                if (this.selectedVariation) {
                                    this.selectedVariation.price = price;
                                }
                                console.log("Target Main Product Updated:", this.selectedProduct);
                            }
                        }
                    },
                    {
                        name: 'Target Training (Upsell)',
                        condition: () => this.targetProduct && this.selectedTargetTrainerId === trainerId,
                        priceField: 'targetTrainingPrice',
                        updateLogic: (price) => {
                            if (price > 0) {
                                this.targetProduct.price = price;
                                console.log("Target Upsell Updated:", this.targetProduct.price);
                            }
                        }
                    },
                    {
                        name: 'Personal Training (Upsell)',
                        condition: () => this.personalProduct && this.requiresPersonal && this.selectedPersonalUpsellTrainerId === trainerId,
                        priceField: 'personalTrainingPrice',
                        updateLogic: (price) => {
                            if (price <= 0) return;
                            const packagePrice = Number(trainerData?.personalTrainingPackagePrice || 0);
                            const variations = this.personalProduct?.variations || [];
                            variations.forEach((variation) => {
                                const dur = variation.attributes?.duration || 1;
                                variation.price = this._personalPackVariationPrice(price, packagePrice, dur);
                            });
                            this.personalProduct.price = price;
                            console.log("Personal Upsell Updated:", this.personalProduct.price);
                        }
                    },
                    {
                        name: 'Personal Training',
                        condition: () => this.selectedProduct?.type === 'GYM' && 
                                        this.selectedProduct?.metadata?.type === 'PERSONAL_TRAINING' && 
                                        this.selectedPersonalTrainerId === trainerId,
                        priceField: 'personalTrainingPrice',
                        updateLogic: (price) => {
                            if (price > 0) {
                                this.selectedProduct.price = price;
                                const packagePrice = Number(trainerData?.personalTrainingPackagePrice || 0);

                                this.selectedProduct.variations?.forEach((variation) => {
                                    const duration = variation.attributes.duration;
                                    variation.price = this._personalPackVariationPrice(price, packagePrice, duration);
                                });

                                if (this.selectedVariation) {
                                    const dur = this.selectedVariation.attributes?.duration;
                                    this.selectedVariation.price = this._personalPackVariationPrice(
                                        price, packagePrice, dur);
                                }

                                console.log("Personal Training Updated:", this.selectedProduct);
                            }
                        }
                    },
                    {
                        name: 'Precision Training (Upsell)',
                        condition: () => this.precisionProduct && this.requiresPrecision
                                        && this.selectedPrecisionUpsellTrainerId === trainerId,
                        priceField: 'precisionTrainingPrice',
                        updateLogic: (price) => {
                            if (price <= 0) return;
                            // Prezzo flat, come per Precision prodotto principale: niente duration
                            this.precisionProduct.price = price;
                            this.precisionProduct.variations?.forEach(variation => {
                                variation.price = price;
                            });
                            console.log("Precision Upsell Updated:", this.precisionProduct.price);
                        }
                    },
                    {
                        name: 'Precision Training',
                        condition: () => this.selectedProduct?.type === 'GYM' && 
                                        this.selectedProduct?.metadata?.type === 'PRECISION_TRAINING' && 
                                        this.selectedPersonalTrainerId === trainerId,
                        priceField: 'precisionTrainingPrice',
                        updateLogic: (price) => {
                            if (price > 0) {
                                this.selectedProduct.price = price;
                                // Prezzo flat: non usare duration come per i pacchetti Elite Personal
                                this.selectedProduct.variations?.forEach(variation => {
                                    variation.price = price;
                                });
                                if (this.selectedVariation) {
                                    this.selectedVariation.price = price;
                                }
                                console.log("Precision Training Updated:", this.selectedProduct);
                            }
                        }
                    }
                ];

                // Esegui aggiornamenti per tutti i servizi applicabili
                serviceConfigs.forEach(config => {
                    if (config.condition()) {
                        const price = trainerData[config.priceField];
                        if (price !== undefined && price !== null) {
                            console.log(`Updating ${config.name} with price:`, price);
                            config.updateLogic(price);
                        } else {
                            console.log(`No price found for ${config.name} (field: ${config.priceField})`);
                        }
                    }
                });

            } catch (error) {
                console.error('Error updating prices by trainer info:', error);
                // Non bloccare l'interfaccia per errori di pricing
            }
        },

        scrollToTerms() {
            const el = document.getElementById('terms-section')
                || document.getElementById('terms-section-free-trial')
                || document.getElementById('terms-section-free-trial-mobile')
                || document.querySelector('.terms-section');
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const offset = 80;
            const top = rect.top + scrollTop - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        },

        // ✅ AGGIUNTO: Metodo per scroll alle checkbox su mobile
        scrollToCheckboxes() {
            this.scrollToTerms();
        },

        showEmailVerificationAlert() {
            Swal.fire({
                title: 'Ti abbiamo inviato un\'email con un link per verificare il tuo indirizzo.',
                text: 'Controlla la posta in arrivo (e la cartella spam) e segui le istruzioni per completare la verifica.',
                icon: 'info',
                iconHtml: '<i class="fa-solid fa-envelope"></i>',
                showConfirmButton: false,
                showCancelButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                customClass: {
                    popup: 'swal2-popup',
                    title: 'swal2-title',
                    content: 'swal2-content',
                    confirmButton: 'swal2-confirm',
                    cancelButton: 'swal2-cancel'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    // Apre Gmail
                    window.open('https://mail.google.com/', '_blank');
                }
            })
        },
        showErrorAlert(message) {
            Swal.fire({
                title: 'Errore',
                text: message,
                icon: 'error',
                confirmButtonText: 'OK',
                showCancelButton: false,
                allowOutsideClick: false,
                allowEscapeKey: true,
                allowEnterKey: true,
                customClass: {
                    popup: 'swal2-popup',
                    title: 'swal2-title',
                    content: 'swal2-content',
                    confirmButton: 'swal2-confirm'
                }
            })
        },
        showInfoAlert(message) {
            Swal.fire({
                title: 'Info',
                text: message,
                icon: 'info',
                confirmButtonText: 'OK',
                showCancelButton: false,
                allowOutsideClick: true,
                allowEscapeKey: true,
                allowEnterKey: true,
                customClass: {
                    popup: 'swal2-popup',
                    title: 'swal2-title',
                    content: 'swal2-content',
                    confirmButton: 'swal2-confirm'
                }
            })
        },
        showSuccessAlert(message) {
            Swal.fire({
                title: 'Successo',
                text: message,
                icon: 'success',
                confirmButtonText: 'OK',
                showCancelButton: false,
                allowOutsideClick: true,
                allowEscapeKey: true,
                allowEnterKey: true,
                customClass: {
                    popup: 'swal2-popup',
                    title: 'swal2-title',
                    content: 'swal2-content',
                    confirmButton: 'swal2-confirm'
                }
            })
        },
    },
};
</script>


<style scoped>
/* ============================================================
   REDESIGN CHECKOUT — sistema condiviso con ServicesFlow.vue
   Tre superfici, tre significati:
     bianco + ombra  = si tocca
     tinta piatta    = si legge
     blu scuro       = raggruppa
   Il rosso e' il segno di conferma (spunte, numeri dei passi):
   mai su bordi o superfici, dove leggerebbe come "campo errato".
   Tutte le classi nuove hanno prefisso co-: questo file ridefinisce
   gia' .form-control, .toast, .dropdown-menu e usa .container, quindi
   la cascata Bootstrap e' la trappola principale.
   ============================================================ */
.co-root {
    --blue: #2e348c;
    --blue-900: #262b7a;
    --group: #232878;
    --ink: #16195e;
    --ink-soft: #4a4f85;
    --surface: #fff;
    --pressed: #f7f8ff;
    --tile: #eceef8;
    --read: #dfe3f5;
    --hairline: #c9cfe8;
    --red: #e83539;

    background-color: var(--blue);
    min-height: 100dvh;
    padding: 0 0 24px;
    font-family: 'Montserrat', sans-serif;
    overflow-x: hidden;
    text-align: left;
}
.co-icon-defs { position: absolute; }

.co-topbar {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 16px 24px 30px;
    max-width: 1160px;
    margin: 0 auto;
}
.co-topbar > .co-back { grid-column: 1; justify-self: start; }
.co-topbar > .user-info-nav { grid-column: 2; }
.co-topbar-right { grid-column: 3; justify-self: end; }
/* Sotto i 1100px lo spazio non basta per tre zone: il nome torna in coda. */
@media (max-width: 1100px) {
    .co-topbar { grid-template-columns: auto 1fr; }
    .co-topbar .user-info-nav { display: none; }
}
.co-back {
    width: 44px; height: 44px;
    display: grid; place-items: center;
    background: rgba(255, 255, 255, .14);
    border: none; border-radius: 12px;
    color: #fff; cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.co-back svg { width: 22px; height: 22px; }
.co-back:active { background: rgba(255, 255, 255, .3); }
/* Il file del logo e' quadrato 1000x1000: sotto i ~48px il lettering evapora. */
.co-logo { height: 56px; width: auto; display: block; }

.co-shell { max-width: 1160px; margin: 0 auto; padding: 0 24px; }
.co-step-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.35rem; font-weight: 700; color: #fff;
    margin: 0 0 14px; text-align: left;
}

/* ---- barra dei passi ---- */
.co-progress {
    display: flex; align-items: center; gap: 12px;
    padding: 6px 0 28px;
}
/* La barra copre l'intera larghezza del contenitore: l'ultimo passo chiude
   sul bordo destro della panoramica, cosi' intestazione, passi e riepilogo
   condividono lo stesso margine. */
.co-pill { display: flex; align-items: center; gap: 9px; opacity: .5; }
.co-pill.is-now, .co-pill.is-done { opacity: 1; }
.co-pill-label {
    font-size: .82rem; font-weight: 700; letter-spacing: .06em;
    text-transform: uppercase; color: #fff; white-space: nowrap;
}
.co-dot {
    width: 30px; height: 30px; border-radius: 999px;
    display: grid; place-items: center;
    border: 2px solid rgba(255, 255, 255, .45);
    font-size: .88rem; font-weight: 800; color: #fff;
}
.co-dot svg { width: 15px; height: 15px; }
/* Numero rosso su pastiglia bianca, come nella versione attuale. */
.co-pill.is-now .co-dot { background: #fff; border-color: #fff; color: var(--red); }
.co-pill.is-done .co-dot { background: var(--red); border-color: var(--red); color: #fff; }
.co-progress-sep { flex: 1; height: 1px; background: rgba(255, 255, 255, .22); }

/* ---- corpo a due colonne, con il riepilogo di lato ---- */
.co-body {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 340px;
    gap: 24px;
    align-items: start;
}
.co-col-main { min-width: 0; }
.co-col-side { min-width: 0; }

/* Il primo elemento della colonna sinistra e' la barra dei passi, non piu' il
   titolo: i due box devono partire dalla stessa quota, senza compensazioni.
   Lo scarto che serviva ad allineare i testi ora disallineerebbe barra e
   riepilogo. */

@media (max-width: 1100px) {
    /* Sotto questa soglia la colonna laterale non ha piu' spazio: il riepilogo
       diventa il foglio sticky in basso (vedi .mobile-summary). */
    .co-body { grid-template-columns: minmax(0, 1fr); }
    .co-col-side { display: none; }
}

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

body {
    font-family: 'Montserrat', sans-serif;
}

h2,
h3,
h4 {
    font-family: 'Montserrat', sans-serif;
}

.step-header {
    display: flex;
    align-items: center;
    gap: 15px;
    text-align: left;
    margin-bottom: 40px;
}

.step-circle {
    font-family: 'Montserrat', sans-serif;
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
    max-width: 50px;
    max-height: 50px;
    background-color: white;
    color: #e83539;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
}

.step-title {
    color: white;
    font-size: 2rem;
    font-weight: 700;
    margin: 0px;
    padding: 0px;
}

.step-content {
    margin-bottom: 24px;
    margin-left: 0;
    /* Nessun margine a sinistra su dispositivi piccoli */
}

@media (min-width: 768px) {
    .step-content {
        margin-left: 0;
        /* Il rientro serviva ad allineare il contenuto sotto il cerchio numerato
           dello step, che non esiste piu': ora disallineerebbe rispetto al
           titolo e alla barra superiore. */
    }
}


.duration-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

@media (max-width: 767px) {
    .duration-grid {
        grid-template-columns: 1fr;
    }
}

.trainer-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.duration-option {
    font-family: 'Montserrat', sans-serif;
    background-color: var(--surface);
    border: none;
    border-radius: 18px;
    box-shadow: 0 6px 0 rgba(0, 0, 0, .20);
    padding: 14px 16px;
    text-align: left;
    color: var(--ink);
    cursor: pointer;
    transition: transform 90ms ease, box-shadow 90ms ease, background-color 90ms ease;
    position: relative;
    min-height: 86px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
}
/* Anello INSET: non sposta il layout come un bordo, e l'ombra colorata cambia
   la sagoma della card, cosi' la scelta si distingue anche da lontano.
   Rosso come la spunta: un solo colore per "questo l'ho scelto io". */
.duration-option.selected {
    box-shadow: 0 6px 0 var(--red), inset 0 0 0 3px var(--red);
    background-color: #fffafa;
    color: var(--blue);
}
.duration-option:active {
    transform: translateY(4px);
    box-shadow: 0 2px 0 rgba(0, 0, 0, .20);
    background-color: var(--pressed);
}
.duration-option.selected:active {
    box-shadow: 0 2px 0 var(--red), inset 0 0 0 3px var(--red);
}
.duration-option.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: 0 2px 0 rgba(0, 0, 0, .10);
}

/* La regola base era andata persa nel refactoring: senza position:relative
   la spunta assoluta si ancora al primo antenato posizionato, cioe' fuori
   dalla card. */
.trainer-option {
    position: relative;
    width: 100%;
}
.trainer-option.selected {
    box-shadow: 0 6px 0 var(--red), inset 0 0 0 3px var(--red);
    background-color: #fbfcff;
    background-color: #292D7D;
}

.duration-title {
    font-size: 1rem; /* leggermente più piccolo */
    /* Font-size su dispositivi mobili */
    font-weight: 600;
}

.trainer-title {
    font-size: 1rem;
    font-weight: 500;
}

@media (min-width: 768px) {
    .duration-title {
        font-size: 1.3rem; /* ridotta anche su desktop */
    }
}

.duration-price {
    font-size: 1.3rem; /* ulteriormente ridotta */
    font-weight: 600;
    margin-top: 4px;
}

.checkmark {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: var(--red);
    color: #fff;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .85rem;
}

h4 {
    margin: 0px;
    padding: 0px;
}

h2,
h3,
p,
ul {
    color: white;
}

ul {
    padding: 0;
}

.terms {
    font-size: 0.9rem;
    text-align: center;
    margin: 20px 0;
}

.terms a {
    color: white;
    text-decoration: underline;
}

.complete-payment-btn {
    background-color: #b2003b;
    width: 100%;
    max-width: 100% !important;
    margin: 20px auto;
    padding: 10px;
    border: none;
    color: white;
    font-size: 1.2rem;
    cursor: pointer;
}

.complete-payment-btn:disabled {
    background-color: #e83539;
    cursor: not-allowed;
}

.btn-custom {
    font-family: 'Montserrat', sans-serif;
    background-color: #fff;
    color: var(--ink);
    border: none;
    padding: 18px 28px;
    font-size: 1.02rem;
    font-weight: 700;
    letter-spacing: .03em;
    text-transform: uppercase;
    cursor: pointer;
    transition: transform 90ms ease, box-shadow 90ms ease, background-color 90ms ease;
    border-radius: 16px;
    box-shadow: 0 6px 0 rgba(0, 0, 0, .22);
    width: 100%;
    max-width: 340px;
    margin: 0 auto;
    -webkit-tap-highlight-color: transparent;
}
.btn-custom:active {
    transform: translateY(4px);
    box-shadow: 0 2px 0 rgba(0, 0, 0, .22);
    background-color: #f2f4ff;
}

@media (hover: hover) and (pointer: fine) {
    .btn-custom:hover { background-color: #f2f4ff; }
}

/* La sottolineatura torna a significare "link": qui serviva solo a dare
   evidenza, ma su undici valori inerti li faceva sembrare cliccabili. */
.highlight {
    font-weight: 600;
    color: white;
    text-decoration: none;
    font-variant-numeric: tabular-nums;
}

/* Dentro il riepilogo, ora chiaro, restavano bianchi i link della sezione
   consensi della prova gratuita e il testo degli avvisi a fondo rosso, che
   la regola-ombrello qui sopra ridipingeva di blu. */
.overview a { color: var(--blue); }
.overview .terms-label,
.overview .terms-label a,
.overview .terms-warning,
.overview .terms-warning a { color: var(--ink); }
.overview .terms-warning { color: var(--ink-soft); }
.overview .alert-danger,
.overview .alert-danger p,
.overview .alert-danger span,
.overview .alert-danger div { color: #fff !important; }

/* ---- riepilogo: superficie di lettura, non di tocco ----
   Tinta piatta e senza ombra: si distingue sia dal blu ambiente sia dalle card
   bianche premibili. Prima era testo bianco su blu, indistinguibile dal resto. */
.overview {
    background: var(--read);
    color: var(--ink);
    border-radius: 20px;
    padding: 20px 22px;
}
.overview h2 {
    font-size: 1.05rem;
    font-weight: 700;
    color: var(--ink);
    margin: 0 0 10px;
    letter-spacing: 0;
}
.overview,
.overview p, .overview li, .overview span, .overview div,
.overview h2, .overview h3, .overview h4 { color: var(--ink-soft) !important; }
.overview strong, .overview b, .overview h2, .overview h4 { color: var(--ink) !important; }
.overview .list-unstyled li { padding: 4px 0; font-size: .95rem; }
/* Dettaglio promo: questa sezione viene montata solo quando il checkout arriva
   con un codice promozionale. Dichiara il contrasto localmente per non dipendere
   dal testo bianco della radice .co-root o da .text-white di Bootstrap. */
.overview .co-promo-discount-breakdown,
.overview .co-promo-discount-breakdown .co-promo-discount-list,
.overview .co-promo-discount-breakdown .discount-item-description,
.overview .co-promo-discount-breakdown .discount-item-description span {
    color: var(--ink-soft) !important;
}
.overview .co-promo-discount-breakdown .co-promo-free-benefit,
.overview .co-promo-discount-breakdown .co-promo-free-benefit span {
    color: var(--ink) !important;
}
/* La sottolineatura torna a significare "link": i valori sono solo in evidenza,
   con cifre a larghezza fissa per incolonnarsi. */
.overview .highlight {
    font-weight: 600;
    color: var(--ink);
    text-decoration: none;
    font-variant-numeric: tabular-nums;
}
.overview hr { border-color: var(--hairline); opacity: 1; }

/* Codice sconto dentro il riepilogo: superficie chiara, quindi input bianco
   e azione blu. Il bottone rosso pieno apparteneva al vecchio fondo blu. */
.overview .input-group { border-radius: 12px; overflow: hidden; }
.overview .form-control.discount {
    background: #fff;
    border: 1px solid var(--hairline);
    border-right: none;
    color: var(--ink) !important;
    font-size: .88rem;
    padding: 12px 14px;
    height: auto;
}
.overview .form-control.discount::placeholder { color: var(--ink-soft); opacity: 1; }
.overview .input-group .btn {
    background-color: var(--blue) !important;
    border-color: var(--blue) !important;
    color: #fff !important;
    font-weight: 700;
    font-size: .82rem;
    letter-spacing: .04em;
    padding: 12px 16px;
    border-radius: 0 12px 12px 0 !important;
}
.overview .input-group .btn.btn-outline-danger {
    background-color: transparent !important;
    color: var(--blue) !important;
    border-left: 1px solid var(--hairline) !important;
}

/* Codice sconto: la stessa barra chiara e arrotondata sia nel contenuto sia nel riepilogo. */
.co-discount-bar {
    border-radius: 12px;
    overflow: hidden;
    background: var(--surface);
    box-shadow: 0 4px 0 rgba(0, 0, 0, .16);
}
.co-discount-bar .form-control.discount {
    flex: 1 1 auto;
    min-width: 0;
    height: 48px;
    margin-bottom: 0;
    padding: 12px 14px;
    border: 0;
    border-radius: 0;
    background: var(--surface);
    color: var(--ink) !important;
    font-size: .88rem;
}
.co-discount-bar .form-control.discount::placeholder {
    color: var(--ink-soft);
    opacity: 1;
}
.co-discount-bar .btn {
    min-width: 92px;
    padding: 0 16px;
    border: 0 !important;
    border-radius: 0 !important;
    background: var(--red) !important;
    color: #fff !important;
    font-size: .82rem;
    font-weight: 700;
    letter-spacing: .04em;
}
.co-discount-bar .btn:not(.btn-outline-danger):hover {
    background: #cc2e31 !important;
}
.co-discount-bar .btn.btn-outline-danger {
    background: var(--surface) !important;
    color: var(--blue) !important;
    border-left: 1px solid var(--hairline) !important;
}
.co-sum { display: flex; flex-direction: column; gap: 2px; margin-bottom: 10px; }
.co-sum-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 14px;
    padding: 3px 0;
}
.co-sum-label { color: var(--ink-soft) !important; font-size: .93rem; }
.overview .badge-included,
.co-sum-value .badge-included {
    color: #fff !important;
    background-color: var(--blue) !important;
}
.co-sum-value {
    color: var(--ink) !important;
    font-weight: 600;
    font-size: .95rem;
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}
.overview .total-row, .overview h3 { color: var(--ink); }

/* Il totale e' il numero su cui si decide: staccato da una linea e piu' pesante
   dell'etichetta, invece di essere due elementi della stessa dimensione. */
.overview h4.fw-bold {
    font-size: 1.85rem;
    font-weight: 800;
    letter-spacing: -.01em;
    color: var(--ink);
    font-variant-numeric: tabular-nums;
}
.overview .row:has(h4.fw-bold) {
    border-top: 1px solid var(--hairline);
    margin-top: 14px;
    padding-top: 12px;
    align-items: baseline;
}
.overview .row:has(h4.fw-bold) .col:first-child h4 {
    font-size: .82rem;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: var(--ink-soft);
}



/* Upsell nel riepilogo: una riga = label (+ wrap) + prezzo, così "(obbligatorio)" non stacca il prezzo */
.checkout-upsell-lines {
    margin-top: 0.25rem;
}
.checkout-upsell-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.65rem;
    margin-bottom: 0.4rem;
}
.checkout-upsell-label {
    flex: 1 1 auto;
    min-width: 0;
    text-align: left;
    padding-right: 0.35rem;
    line-height: 1.35;
}
.checkout-upsell-mandatory-tag {
    font-weight: normal;
    white-space: nowrap;
    margin-left: 0.2rem;
}
.checkout-upsell-amount {
    flex: 0 0 auto;
    text-align: right;
    white-space: nowrap;
}
@media (min-width: 992px) {
    .checkout-upsell-row {
        align-items: baseline;
    }
}

form input,
#card-element {
    color: black;
    margin-bottom: 10px;
    height: 48px;
    padding: 0 10px;
    border-radius: 12px;
}

form select {
    color: white;
    margin-bottom: 10px;
    height: 48px;
    padding: 0 10px;
    border-radius: 12px;
}

select::after {
    color: white;
}

.form-select {
    appearance: none;
    font-family: 'Montserrat', sans-serif;
    background-color: rgba(255, 255, 255, 0);
    border: 2px solid;
    border-color: white;
    color: white;
    border-radius: 0px;
    width: 100%;
    background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="%23FFFFFF" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 5.646a.5.5 0 0 1 .708 0L8 11.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>');
    background-size: 24px;
}

.form-select-selected {
    border-color: #e83539 !important;
}

.form-control {
    font-family: 'Montserrat', sans-serif;
    background-color: rgba(255, 255, 255, 0);
    border: 2px solid;
    border-color: white;
    color: white;
    min-height: 44px;
}

.form-control::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.discount {
    color: rgb(19, 19, 19) !important;
    background-color: white;
    border-radius: 0px;
    height: 45px;
}

.custom-placeholder::-webkit-input-placeholder {
    /* Chrome, Safari, Edge */
    color: #232323;
}

.custom-placeholder:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #232323;
}

.custom-placeholder::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #232323;
}

.custom-placeholder::placeholder {
    /* Standard */
    color: #232323;
}


.white-container {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    background-color: rgba(255, 255, 255, 0.207);
    border-radius: 0px;
    color: #ffffff;
    padding: 10px;
    margin-bottom: 25px;
}

.white-container:hover {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    background-color: rgba(255, 255, 255, 0.352);
    border-radius: 0px;
    color: #ffffff;
    padding: 10px;
    margin-bottom: 25px;
}

/* Auth buttons row */
.auth-choice .auth-btn {
    font-size: 0.95rem;
    font-weight: 600;
    padding: 10px 12px;
    border-radius: 12px;
}
.auth-choice .btn-danger {
    background-color: #e83539;
    border: none;
}
.auth-choice .btn-danger:hover {
    background-color: #cc2e31;
}

/* ============================================================
   Modulo di registrazione — superficie di lettura e scrittura.

   Era l'ultima parte rimasta col linguaggio vecchio: campi trasparenti
   con bordo bianco su fondo blu, mentre tutto cio' che si compila nel
   checkout sta ormai su superficie chiara. Qui il pannello diventa
   chiaro e OGNI elemento interno dichiara il proprio colore: i figli
   ereditavano il bianco della pagina e sparirebbero.
   ============================================================ */
.registration-form {
    background: var(--surface);
    border-radius: 20px;
    padding: 22px 22px 26px;
    color: var(--ink);
    box-shadow: 0 6px 0 rgba(0, 0, 0, .16);
}
.registration-form h4,
.registration-form h5,
.registration-form label,
.registration-form span,
.registration-form p {
    color: var(--ink);
}
.registration-form h4 {
    font-size: 1.05rem;
    font-weight: 700;
    letter-spacing: .01em;
}
.registration-form h4 b { color: var(--red); }
.registration-form a { color: var(--blue); text-decoration: underline; }

/* campi */
.registration-form .form-control,
.registration-form .form-select,
.registration-form .country-search-input,
.registration-form :deep(.dp__input) {
    background-color: #fff;
    border: 1px solid var(--hairline) !important;
    border-radius: 12px !important;
    color: var(--ink) !important;
    height: 48px;
}
.registration-form .form-control::placeholder,
.registration-form .country-search-input::placeholder,
.registration-form :deep(.dp__input::placeholder) {
    color: var(--ink-soft);
    opacity: 1;
}
.registration-form .form-control:focus,
.registration-form .form-select:focus,
.registration-form .country-search-input:focus,
.registration-form :deep(.dp__input:focus) {
    background-color: #fff;
    border-color: var(--blue) !important;
    box-shadow: none !important;
}
.registration-form .form-control.is-invalid {
    border-color: var(--red) !important;
}
.registration-form :deep(.dp__input_icon) { color: var(--ink-soft); }
.registration-form .toggle-password {
    color: var(--blue);
    background: transparent;
}

/* tendine di completamento */
.registration-form .suggestion-item,
.registration-form .country-dropdown-item {
    background: #fff;
    color: var(--ink);
}
.registration-form .suggestion-item:hover,
.registration-form .country-dropdown-item:hover,
.registration-form .country-dropdown-item.selected {
    background: var(--tile);
    color: var(--ink);
}
.registration-form .no-results,
.registration-form .loading-dots { color: var(--ink-soft); }
.registration-form .country-dropdown-icon { color: var(--ink-soft); }

/* consensi */
.registration-form .terms-label { color: var(--ink); }
.registration-form .terms-warning { color: var(--ink-soft); font-style: normal; }
.registration-form .terms-warning a { color: var(--blue); }

/* messaggi di errore */
.registration-form .text-danger,
.registration-form .invalid-feedback { color: var(--red) !important; }

/* selettore del genere, che vive in un componente a parte */
.registration-form :deep(.gender-option) {
    background-color: #fff;
    border: 1px solid var(--hairline);
    border-radius: 12px;
    color: var(--ink);
}
.registration-form :deep(.gender-option.selected) {
    box-shadow: inset 0 0 0 3px var(--red);
    border-color: var(--red);
    background-color: #fffafa;
}
.registration-form :deep(.gender-title) { color: var(--ink); }

/* Il selettore attivo si riconosce: prima "Accedi" restava pieno anche
   con il modulo di registrazione aperto sotto. */
.auth-choice .auth-btn.is-muted {
    background-color: transparent;
    border: 2px solid rgba(255, 255, 255, .45);
    color: #fff;
}
.auth-choice .auth-btn.is-current {
    background-color: #fff;
    border: none;
    color: var(--ink);
    box-shadow: 0 4px 0 rgba(0, 0, 0, .18);
}
.auth-choice .auth-btn.is-muted:hover {
    background-color: rgba(255, 255, 255, .12);
}

/* Stili per il layout di pagamento */
/* Wallet Credit Section Styles */
.wallet-credit-section {
    margin-bottom: 24px;
}

.wallet-credit-box {
    background: linear-gradient(135deg, rgba(74, 222, 128, 0.1) 0%, rgba(34, 197, 94, 0.15) 100%);
    border: 2px solid rgba(74, 222, 128, 0.5);
    border-radius: 12px;
    padding: 16px 20px;
    color: white;
}

.wallet-credit-header {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 8px;
    color: rgba(255, 255, 255, 0.9);
}

.wallet-credit-balance {
    font-size: 1.8rem;
    font-weight: 700;
    color: #4ade80;
    margin-bottom: 12px;
}

.wallet-credit-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
}

.wallet-credit-checkbox .custom-checkbox {
    appearance: none;
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    min-height: 28px !important;
    border-radius: 999px;
    background-color: #fff;
    border: 2px solid var(--ink-soft) !important;
    border-radius: 10px;
    outline: none;
    cursor: pointer;
    transition: background-color 90ms ease, border-color 90ms ease;
    position: relative;
    flex: 0 0 28px;
}
/* Spunta rossa: e' il segno di conferma del marchio, coerente con i passi. */
.custom-checkbox:checked {
    background-color: var(--red) !important;
    border-color: var(--red) !important;
}
.custom-checkbox:focus-visible {
    outline: 3px solid #fff;
    outline-offset: 3px;
}
/* Sul pannello blu il bordo grigio-blu sparirebbe nel fondo. */
.upsell-box .custom-checkbox,
.mandatory-upsell-box .custom-checkbox {
    border-color: rgba(255, 255, 255, .55) !important;
}
.upsell-box .custom-checkbox:checked,
.mandatory-upsell-box .custom-checkbox:checked {
    border-color: var(--red) !important;
}

.wallet-credit-label {
    font-size: 0.95rem;
    color: white;
    cursor: pointer;
    margin: 0;
}

.wallet-credit-info {
    font-size: 0.85rem;
    color: #4ade80;
    padding: 8px 12px;
    background: rgba(74, 222, 128, 0.15);
    border-radius: 6px;
    margin-top: 8px;
}

.payment-method-section {
    margin-bottom: 32px;
}

.payment-section-title {
    margin: 0 0 14px;
    font-family: 'Montserrat', sans-serif;
    font-size: 1.1rem;
    line-height: 1.2;
    font-weight: 700;
    letter-spacing: .01em;
    color: #fff;
}

.payment-grid {
    display: flex;
    justify-content: space-between;
    gap: 12px;
}

.payment-option {
    background-color: var(--surface);
    border: none;
    border-radius: 16px;
    box-shadow: 0 6px 0 rgba(0, 0, 0, .20);
    color: var(--ink);
    padding: 14px 12px;
    text-align: center;
    cursor: pointer;
    transition: transform 90ms ease, box-shadow 90ms ease, background-color 90ms ease;
    flex-grow: 1;
    font-weight: 700;
    font-family: "Montserrat", sans-serif;
    -webkit-tap-highlight-color: transparent;
}
.payment-option:active {
    transform: translateY(4px);
    box-shadow: 0 2px 0 rgba(0, 0, 0, .20);
    background-color: var(--pressed);
}

.payment-option.selected {
    box-shadow: 0 6px 0 var(--red), inset 0 0 0 3px var(--red);
    background-color: #fffafa;
    color: var(--blue);
}

.payment-card-section #card-element {
    margin-top: 2px;
}

.payment-request-section {
    padding-top: 8px !important;
}

.paypal-payment-section {
    padding-top: 20px !important;
}

.payment-submit-section {
    margin-top: 16px !important;
}

.payment-info {
    margin-top: 10px;
    font-size: 1.2rem;
    color: white;
    background-color: #e83539;
    padding: 15px;
}

.complete-payment-btn {
    background-color: #b2003b;
    width: 100%;
    margin: 20px auto;
    padding: 10px;
    border: none;
    color: white;
    font-size: 1.2rem;
    cursor: pointer;
}

.complete-payment-btn:disabled {
    background-color: #e83539;
    cursor: not-allowed;
}

.checkbox-container {
    display: flex;
    align-items: center;
    gap: 14px;
    font-family: 'Montserrat', sans-serif;
    padding: 14px 16px;
    border-radius: 16px;
    border: none;
    background-color: var(--surface);
    color: var(--ink);
    box-shadow: 0 4px 0 rgba(0, 0, 0, .16);
    margin-top: 16px;
}
.checkbox-container .custom-label { color: var(--ink) !important; font-weight: 700; }
.checkbox-container .custom-description { color: var(--ink-soft) !important; margin: 2px 0 0; font-size: .88rem; }

.terms-checkbox {
    display: flex;
    align-items: center;
    /* Allinea verticalmente al centro */
    gap: 5px;
    /* Spazio tra checkbox e testo */
    font-family: 'Montserrat', sans-serif;
    padding: 5px;
    border-radius: 0px;
    border: 0px;
    margin-top: 5px;
}

.upsell-checkbox-container {
    display: flex;
    align-items: center;
    gap: 14px;
    font-family: 'Montserrat', sans-serif;
    padding: 4px 0;
    background-color: transparent;
    color: #fff;
}
.upsell-checkbox-container .custom-label,
.upsell-checkbox-container label { color: #fff !important; font-weight: 700; }
.upsell-checkbox-container p,
.upsell-checkbox-container .custom-description { color: rgba(255, 255, 255, .72) !important; }
.upsell-checkbox-container .highlight { color: #fff !important; }

.custom-checkbox {
    appearance: none;
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    min-height: 28px !important;
    flex: 0 0 28px;
    background-color: #fff;
    border: 2px solid var(--ink-soft) !important;
    border-radius: 999px;
    outline: none;
    cursor: pointer;
    transition: background-color 90ms ease, border-color 90ms ease;
    position: relative;
}

.custom-checkbox:checked {
    background-color: var(--red);
    border-color: var(--red) !important;
}

/* Segno di spunta disegnato: prima era il glifo f00c di Font Awesome 5,
   mentre in pagina e' caricato il kit v6. */
.custom-checkbox:checked::before {
    content: '';
    position: absolute;
    top: 46%;
    left: 50%;
    width: 6px;
    height: 11px;
    border: solid #fff;
    border-width: 0 2.5px 2.5px 0;
    transform: translate(-50%, -55%) rotate(45deg);
}

.terms-cb {
    appearance: none;
    width: 20px !important;
    height: 20px !important;
    min-width: 20px !important;
    min-height: 20px !important;
    background-color: #2e348c;
    border: 2px solid rgba(255, 255, 255, 0.144) !important;
    outline: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
    position: relative;
}


.text-container {
    display: flex;
    flex-direction: column;
    /* Dispone il titolo sopra e la descrizione sotto */
}

/* Stili per il componente di selezione data di inizio */
.start-date-container {
    margin-top: 16px;
    padding: 14px 16px;
    border-radius: 16px;
    border: none;
    background-color: var(--surface);
    color: var(--ink);
    box-shadow: 0 4px 0 rgba(0, 0, 0, .16);
    font-family: 'Montserrat', sans-serif;
}
.start-date-container label,
.start-date-container .custom-label { color: var(--ink) !important; font-weight: 700; }
.start-date-container p { color: var(--ink-soft) !important; }

.start-date-container.has-selected-date {
    border-color: #e83539;
}

.start-date-header {
    margin-bottom: 15px;
}

.start-date-title {
    color: var(--ink);
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0 0 5px 0;
}

.start-date-description {
    margin: 0;
    font-size: 0.9rem;
    color: var(--ink-soft);
    font-weight: 400;
    line-height: 1.4;
}

.start-date-selector {
    position: relative;
}

.start-date-picker-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.start-date-picker-input {
    padding: 12px 20px 12px 50px;
    background-color: rgba(255, 255, 255, 0.05);
    border: 0;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 2px solid #e83539;
    border-radius: 12px;
    color: white;
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    width: auto;
    min-width: 200px;
    transition: all 0.3s ease;
    outline: none;
}

.start-date-picker-input:hover {
    background-color: rgba(255, 255, 255, 0.08);
}

.start-date-picker-input:focus {
    background-color: rgba(255, 255, 255, 0.08);
    border-bottom: 2px solid #e83539;
    outline: none;
}

/* Stili specifici per il componente Datepicker nella sezione start-date */
.start-date-selector :deep(.dp__input) {
    padding: 12px 20px 12px 46px !important;
    background-color: #fff !important;
    border: 1px solid var(--hairline) !important;
    border-radius: 12px !important;
    color: var(--ink) !important;
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    width: auto !important;
    min-width: 200px !important;
    transition: all 0.3s ease;
    outline: none !important;
    box-shadow: none !important;
}

.start-date-selector :deep(.dp__input:hover) {
    background-color: #f7f8ff !important;
}

.start-date-selector :deep(.dp__input:focus) {
    background-color: #fff !important;
    border: 2px solid var(--blue) !important;
    outline: none !important;
    box-shadow: none !important;
}

.start-date-selector :deep(.dp__input::placeholder) {
    color: var(--ink-soft) !important;
    opacity: 1;
}

/* Gestione icona calendario nel Datepicker */
.start-date-selector :deep(.dp__input_wrap) {
    position: relative;
    display: inline-block;
    width: auto;
}

.start-date-selector :deep(.dp__input_icon) {
    left: 15px !important;
    color: var(--ink-soft) !important;
}

.start-date-selector :deep(.dp__input_icon svg) {
    width: 18px;
    height: 18px;
}

.start-date-picker-input::placeholder {
    color: rgba(255, 255, 255, 0.8);
}

/* Stili legacy mantenuti per compatibilità */
.start-date-button {
    padding: 12px 20px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 0;
    border-bottom: 2px solid #e83539;
    color: white;
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    transition: all 0.3s ease;
}

.start-date-button:hover {
    background-color: rgba(255, 255, 255, 0.15);
}

.start-date-button.has-date {
    border-bottom-color: #e83539;
}

.start-date-text {
    flex: 1;
    text-align: left;
}

.start-date-icons {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.start-date-reset {
    cursor: pointer;
    font-size: 0.9rem;
    opacity: 0.8;
    transition: opacity 0.2s ease;
}

.start-date-reset:hover {
    opacity: 1;
}

.start-date-calendar-icon {
    font-size: 1rem;
    opacity: 0.8;
}

.custom-label {
    color: white;
    font-size: 1.2rem;
    font-weight: 600;
    cursor: pointer;
}

.terms-label {
    color: white;
    font-size: 0.8rem;
    font-weight: 500;
    cursor: pointer;
}

.terms-label a {
    color: #ffffff;
    font-size: 0.8rem;
    font-weight: 500;
    cursor: pointer;
}

/* Gli stessi consensi, dentro il modulo di registrazione, stanno su bianco. */
.registration-form .terms-label { color: var(--ink); }
.registration-form .terms-label a {
    color: var(--blue);
    font-weight: 700;
    text-decoration: underline;
}
.registration-form .terms-cb {
    background-color: #fff;
    border: 2px solid var(--ink-soft) !important;
    border-radius: 999px;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    min-height: 24px !important;
}
.registration-form .terms-cb:checked {
    background-color: var(--red);
    border-color: var(--red) !important;
}
.registration-form .terms-checkbox { padding: 5px 0; }
/* Il pulsante di conferma era bianco su bianco: sul pannello chiaro
   l'azione principale deve pesare quanto pesa. */
.registration-form .btn-custom {
    background-color: var(--blue) !important;
    border: none !important;
    color: #fff !important;
    border-radius: 14px !important;
    box-shadow: 0 5px 0 rgba(0, 0, 0, .2) !important;
    font-weight: 700;
}
.registration-form .btn-custom:disabled {
    background-color: var(--hairline) !important;
    color: var(--ink-soft) !important;
    box-shadow: none !important;
}

.custom-description {
    margin-top: 5px;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.8);
    /* Colore bianco trasparente */
    font-weight: 400;
    line-height: 1.4;
    margin-bottom: 0px !important;
}

@media (max-width: 767px) {
    .back-button {
        display: none !important;
    }

    .user-info-nav {
        display: none !important;
    }
}

.back-button {
    position: absolute;
    top: 20px;
    left: 20px;
    cursor: pointer;
    z-index: 1000;
    transition: transform 0.3s ease;
    margin: 20px;
    padding-bottom: 10px;
    /* Assicurati che sia visibile sopra gli altri elementi */
}

.back-button i {
    font-size: 24px;
    color: white;
    transition: transform 0.2s ease;
}

.back-button:hover {
    transform: scale(1.05);
    border-bottom: 2px solid #e83539;
    /* Leggera animazione al passaggio del mouse */
}

.co-topbar-right { display: flex; align-items: center; gap: 18px; }
/* In flusso dentro la barra: prima era absolute con z-index 1000 e, ad utente
   autenticato, il nome finiva sopra il logo. */
.user-info-nav {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* Chi si e' autenticato lo sa gia': l'informazione e' di servizio, quindi
   sta sotto al resto per dimensione e contrasto. */
.user-name {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.3;
    text-align: center;
}
.user-name-label {
    font-size: .68rem;
    font-weight: 500;
    letter-spacing: .02em;
    text-transform: none;
    color: rgba(255, 255, 255, .7);
}
.user-name-value {
    font-size: .82rem;
    font-weight: 700;
    letter-spacing: .04em;
    color: #fff;
}

.user-avatar {
    width: 30px;
    height: 30px;
    border: 2px solid #e83539;
    /* Bordo rosso */
    border-radius: 50%;
    /* Cerchio perfetto */
    background-color: #ffffff34;
    color: white;
    text-align: center;
    /* Colore di sfondo (può essere sostituito con l'immagine dell'avatar) */
}

.user-name {
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    color: white;
}

.dropdown-menu {
    position: absolute;
    top: 50px;
    right: 0;
    background-color: #333892;
    /* Blu coerente con l'app */
    color: white;
    border-radius: 4px;
    padding: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    min-width: 150px;
    display: flex;
    flex-direction: column;
}

.menu-item {
    font-family: 'Montserrat', sans-serif;
    text-decoration: none;
    color: white;
    padding: 10px;
    transition: background-color 0.3s ease;
}

.menu-item:hover {
    background-color: #1c1f60;
    /* Blu più scuro per hover */
    border-radius: 4px;
}

.loading-dots {
    display: inline-flex;
    gap: 2px;
}

.loading-dots span {
    animation: blink 1.4s infinite;
}

.loading-dots span:nth-child(2) {
    animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes blink {

    0%,
    100% {
        opacity: 0.3;
    }

    50% {
        opacity: 1;
    }
}

.form-group {
    position: relative;
}

.toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: rgb(41, 45, 125);
    padding: 5px;
    border: none;
    color: white;
    font-weight: 600;
    cursor: pointer;
    font-size: 0.9rem;
    padding: 0;
}

:deep(.dp__input) {
    background-color: rgba(255, 255, 255, 0);
    border: 2px solid white;
    color: white;
    height: 48px;
    border-radius: 12px;
}

:deep(.dp__input::placeholder) {
    color: rgba(255, 255, 255, 0.6);
}

:deep(.dp__input:focus) {
    border-color: #e83539;
    box-shadow: 0 0 0 0.25rem rgba(232, 53, 57, 0.25);
}

:deep(.dp__main) {
    font-family: 'Montserrat', sans-serif;
}

:deep(.dp__active) {
    background-color: #e83539 !important;
}

/* Contenitore principale dei toast */
.toast-container {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;
    /* Evita interazioni con altri elementi */
}

/* Stile base dei toast */
.toast {
    margin: 10px 0;
    padding: 15px 20px;
    border-radius: 5px;
    color: white;
    font-size: 14px;
    font-weight: bold;
    min-width: 250px;
    max-width: 400px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    opacity: 1;
    pointer-events: all;
    /* Permette interazioni solo con il toast */
    transition: opacity 0.5s ease-in-out;
}

/* Tipi di toast */
.toast-success {
    background-color: #4CAF50;
    /* Verde per successi */
}

.toast-error {
    background-color: #f44336;
    /* Rosso per errori */
}

.toast-warning {
    background-color: #FF9800;
    /* Arancione per avvisi */
}

.toast-info {
    background-color: #2196F3;
    /* Blu per informazioni */
}

/* Effetti di comparsa/scomparsa */
.toast.fade-out {
    opacity: 0;
}

.alert-primary {
    background: #ffffff2e;
    color: white;
    border-radius: 0px;
}

.alert-danger {
    background: #e83539;
    color: white;
    border-radius: 0px;
    border: 0px;
}

/* Voce non dovuta: si dichiara, non si cancella. La barratura sul contenitore
   copriva etichetta e prezzi insieme (text-decoration si eredita e non si somma),
   rendendo illeggibile quanto si stesse pagando. */
.badge-included {
    display: inline-block;
    background-color: #2e348c !important;
    color: #fff !important;
    opacity: 1;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    border-radius: 999px;
    padding: 3px 12px;
    white-space: nowrap;
}

/* Il prezzo della riga upsell non deve finire sopra il testo.
   La riga e' col-10/col-2: due dodicesimi di un telefono da 390px sono ~62px, e «500.00€» ne
   chiede ~79 — sbordava a sinistra, sopra la colonna che su Elite Personal contiene anche i due
   menu (pacchetto e trainer). Segnalato dal banco il 16/09 con la foto: il prezzo era scritto
   sopra il menu del pacchetto. Misurato: sovrapposizione su 12 combinazioni di 12 fra 320 e
   430px e fra 100% e 160% di scala del testo.
   Qui la colonna del prezzo si dimensiona sul proprio contenuto e il testo prende il resto.
   Il `min-width: 0` sulla colonna del testo e' la riga che conta davvero: senza, un <select>
   largo non si lascia comprimere (default `min-width: auto` degli elementi flex) e continua a
   spingere fuori il prezzo. Il `min-width: 11rem` fa invece andare il prezzo a capo quando il
   testo e' ingrandito, invece di strizzare i menu fino a renderli inutilizzabili.
   Vale per tutte e cinque le righe upsell, non solo per Elite Personal: stesso schema. */
.upsell-box > .col-2 {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    padding-left: .25rem;
}
.upsell-box > .col-10 {
    flex: 1 1 0;
    width: auto;
    min-width: 11rem;
}
.upsell-box .highlight {
    white-space: nowrap;
}

.upsell-box {
    background-color: var(--group);
    border: none;
    border-radius: 18px;
    padding: 16px 18px;
    margin-top: 8px;
}

.mandatory-upsell-box {
    background-color: var(--group);
    border: none;
    border-radius: 18px;
    padding: 16px 18px;
}

/* Testi un po' più compatti negli upsell */
.upsell-box .custom-label {
    font-size: 0.95rem;
}
.upsell-box .custom-description {
    font-size: 0.9rem;
}
.upsell-box select.form-select {
    font-size: 0.95rem;
    padding: 6px 8px;
}

/* Box selezione centro - bianco, squadrato, scritte blu */
.center-select-box {
    background-color: var(--surface);
    border-radius: 16px;
    border: none;
    box-shadow: 0 4px 0 rgba(0, 0, 0, .16);
    padding: 16px 18px;
    color: var(--ink);
}
.center-select-box .center-select-label { color: var(--ink) !important; }
.center-select-box .center-select-hint { color: var(--ink-soft) !important; font-size: .86rem; }
.center-select-box .center-select-label {
    color: #292D7D;
    font-family: 'Montserrat', sans-serif;
    display: block;
    margin-bottom: 6px;
}
.center-select-box .center-select-hint {
    color: #292D7D;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    margin-bottom: 12px;
}
.center-select-box .center-select-input {
    color: #292D7D !important;
    background-color: white !important;
    border: 2px solid #292D7D;
}
.center-select-box .center-select-input option {
    background-color: white;
    color: #292D7D;
}

.custom-select {
    background-color: rgba(255, 255, 255, .10);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, .45) !important;
    border-radius: 12px !important;
    padding: 12px 14px;
    font-family: 'Montserrat', sans-serif;
}
.custom-select:focus {
    border-color: #fff !important;
    box-shadow: none !important;
    outline: none;
}
/* Dentro una superficie chiara il controllo si adegua. */
.center-select-box .custom-select,
.start-date-container .custom-select {
    background-color: #fff;
    color: var(--ink);
    border: 1px solid var(--hairline) !important;
}

.custom-select option {
    background-color: rgb(63 66 138);
    /* Cambia il colore di sfondo delle opzioni */
    color: white;
    /* Cambia il colore del testo delle opzioni */
}

.discount-item-description {
    margin-bottom: 5px;
    border-bottom: 1px solid red;
    text-align: end;
}

.discount-error-message {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: -8px;
    margin-bottom: 12px;
    padding: 8px 12px;
    border-radius: 4px;
    background: rgba(220, 53, 69, 0.12);
    color: #f1aeb5;
    font-size: 0.9rem;
}

/* I titoli dei gruppi compaiono sul fondo blu solo quando una promo divide
   le durate in offerta da quelle a listino: il token --ink e' pensato per
   superfici chiare e qui produceva blu su blu. */
.duration-group-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    font-weight: 700;
    margin: 0 0 10px;
    color: var(--surface);
}

.duration-group-title--muted {
    margin-top: 22px;
    font-weight: 600;
    color: var(--surface);
}

.duration-group-title span {
    font-weight: 400;
    color: var(--read);
}

/* Iniziative commerciali (devops#466): stesse card del checkout (superficie bianca, raggio 18, ombra a gradino)
   e accento rosso come la scelta della durata. Bootstrap mette .text-white con !important sul contenitore: senza
   i colori espliciti con !important qui dentro il testo resterebbe bianco sul fondo chiaro. */
.initiative-note {
    margin: 14px 0;
    padding: 12px 16px;
    border-radius: 18px;
    background-color: var(--surface);
    box-shadow: 0 6px 0 rgba(0, 0, 0, .20), inset 0 0 0 2px var(--red);
    font-family: 'Montserrat', sans-serif;
    font-size: 0.95rem;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 8px;
    overflow-wrap: anywhere;
}
.initiative-note,
.initiative-note span { color: var(--ink) !important; }
.initiative-note strong { color: var(--red) !important; font-weight: 800; }
.initiative-note span:last-child { color: var(--red) !important; font-weight: 800; font-size: 1.1rem; }

.upgrade-proposal {
    margin: 14px 0;
    padding: 16px 18px;
    border-radius: 18px;
    background-color: var(--surface);
    box-shadow: 0 6px 0 rgba(0, 0, 0, .20);
    font-family: 'Montserrat', sans-serif;
    overflow-wrap: anywhere;
}
.upgrade-proposal,
.upgrade-proposal p { color: var(--ink-soft) !important; }
.upgrade-proposal strong { color: var(--ink) !important; font-weight: 800; }
.upgrade-proposal p strong { color: var(--red) !important; }

.upgrade-proposal p {
    margin: 6px 0 0;
}

.upgrade-proposal-actions {
    margin-top: 14px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.upgrade-proposal-cta {
    font-family: 'Montserrat', sans-serif;
    border: none;
    border-radius: 14px;
    padding: 12px 20px;
    background-color: var(--red);
    color: #fff !important;
    font-weight: 700;
    box-shadow: 0 4px 0 rgba(0, 0, 0, .22);
    cursor: pointer;
}
.upgrade-proposal-cta:active { transform: translateY(3px); box-shadow: 0 1px 0 rgba(0, 0, 0, .22); }

.upgrade-proposal-later {
    font-family: 'Montserrat', sans-serif;
    border: none;
    background: transparent;
    padding: 12px 8px;
    color: var(--ink-soft) !important;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
}

.duration-price-list {
    text-decoration: line-through;
    opacity: 0.55;
    font-weight: 400;
    font-size: 0.85em;
    margin-right: 6px;
}

/* Riga degli omaggi: informativa, non deve competere col prezzo. */
.duration-gift {
    font-size: 0.78rem;
    font-weight: 600;
    opacity: 0.85;
}

.discount-exclusive-note {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: -8px;
    margin-bottom: 12px;
    padding: 8px 12px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.75);
    font-size: 0.85rem;
}

@media (min-width: 1200px) {
    .border-left-white {
        border-left: 3px solid;
        border-color: white;
    }
    /* Keep the right overview visible and scrolling with the page */
    .overview {
        position: sticky;
        top: 20px; /* offset below top UI */
        max-height: calc(100vh - 40px);
        overflow-y: auto;
    }
}

@media (max-width: 767px) {
    .border-top-white {
        border-top: 3px solid;
        border-color: white;
        padding-top: 30px;
    }
}

.announcement-bar {
    background-color: #e83539;
    color: white;
    font-weight: 500;
}

/* ✅ AGGIUNTO: Stili per il messaggio termini richiesti */
.terms-required-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 40px 20px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 20px;
    color: white;
    font-family: 'Montserrat', sans-serif;
}

.terms-icon {
    font-size: 2rem; /* ridotta dimensione del cerchio alert */
    color: #e83539;
    margin-bottom: 12px;
}

.terms-required-message h4 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 15px;
    color: white;
}

.terms-required-message p {
    font-size: 1rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.8);
    max-width: 400px;
    margin-bottom: 20px;
}

/* RIMOSSI stili per freccia rossa e istruzione mobile */

.free-order-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 40px 20px;
    background-color: #d4edda;
    border: 2px solid #28a745;
    border-radius: 8px;
    margin-bottom: 30px;
    font-family: 'Montserrat', sans-serif;
}

.free-order-icon {
    font-size: 48px;
    color: #28a745;
    margin-bottom: 15px;
}

.free-order-message h4 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 15px;
    color: #155724;
}

.free-order-message p {
    font-size: 1rem;
    line-height: 1.5;
    color: #155724;
    max-width: 500px;
    margin-bottom: 0;
}

.paypal-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 15px 18px;
    background-color: #FFC439;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    color: #111;
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
}

.paypal-button:hover:not(:disabled) {
    background-color: #FFB347;
}

.paypal-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
}

.paypal-button img {
    width: 24px;
    height: 24px;
}

.terms-warning {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.8rem;
    font-style: italic;
    color: white;
}

.terms-warning a {
    color: white;
    text-decoration: underline;
}

/* Scorciatoia per le cinque conferme: stesso linguaggio delle checkbox
   sottostanti, ma dichiaratamente un comando e non un consenso in piu'. */
.terms-select-all {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin-top: 6px;
    padding: 10px 18px 10px 12px;
    background: rgba(255, 255, 255, .10);
    border: 2px solid rgba(255, 255, 255, .35);
    border-radius: 999px;
    color: #fff;
    font-family: 'Montserrat', sans-serif;
    font-size: .88rem;
    font-weight: 700;
    cursor: pointer;
    transition: background-color .15s ease, border-color .15s ease;
}
.terms-select-all:hover {
    background: rgba(255, 255, 255, .18);
    border-color: rgba(255, 255, 255, .55);
}
.terms-select-all--light {
    background: var(--tile);
    border-color: var(--hairline);
    color: var(--ink);
}
.terms-select-all--light:hover {
    background: var(--read);
    border-color: var(--blue);
}
.terms-select-all-box {
    width: 24px;
    height: 24px;
    border-radius: 999px;
    display: grid;
    place-items: center;
    background: #fff;
    border: 2px solid var(--ink-soft);
    transition: background-color .15s ease, border-color .15s ease;
}
.terms-select-all-box svg {
    width: 13px;
    height: 13px;
    fill: none;
    stroke: #fff;
    stroke-width: 3.2;
    stroke-linecap: round;
    stroke-linejoin: round;
    opacity: 0;
    transition: opacity .12s ease;
}
.terms-select-all-box.is-on {
    background: var(--red);
    border-color: var(--red);
}
.terms-select-all-box.is-on svg { opacity: 1; }

/* Separatore con tre puntini trasparenti */
.divider-dots {
    text-align: center;
    opacity: 0.4;
    color: rgba(255,255,255,0.6);
    letter-spacing: 10px;
    margin: 14px 0 6px 0;
    user-select: none;
}

/* Mobile summary fixed bar */
.mobile-summary {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--blue-900);
    border-top: 1px solid rgba(255, 255, 255, .18);
    z-index: 1000;
    padding-bottom: env(safe-area-inset-bottom);
}
/* Compare quando la colonna laterale sparisce, cioe' allo stesso breakpoint
   del layout: usare .d-xl-none legava la barra alla soglia di Bootstrap
   (1200px) invece che a quella vera del riepilogo (1100px). */
.co-sticky-summary { display: none; }
@media (max-width: 1100px) {
    .co-sticky-summary { display: block; }
    /* Compensa l'ingombro della barra: senza, copre gli ultimi elementi. */
    .co-root { padding-bottom: calc(84px + env(safe-area-inset-bottom)); }
}
.mobile-summary-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
}
.mobile-summary .msb-label {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: white;
}
.mobile-summary .msb-total {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    color: white;
    margin-right: 10px;
}
.mobile-summary-panel {
    max-height: 60vh;
    overflow-y: auto;
    padding: 12px 16px 80px 16px; /* extra bottom padding to avoid overlap */
    border-top: 1px solid rgba(255,255,255,0.2);
}
/* Nel riepilogo sticky il fondo e' blu: il dettaglio della promo diventa una
   superficie di lettura chiara, come la panoramica desktop. */
.mobile-summary .co-promo-discount-breakdown {
    background: var(--read);
    border-radius: 12px;
    padding: 10px 12px;
    margin-left: 0;
    margin-right: 0;
}
.mobile-summary .co-promo-discount-breakdown,
.mobile-summary .co-promo-discount-breakdown .co-promo-discount-list,
.mobile-summary .co-promo-discount-breakdown .discount-item-description,
.mobile-summary .co-promo-discount-breakdown .discount-item-description span {
    color: var(--ink-soft) !important;
}
.mobile-summary .co-promo-discount-breakdown .co-promo-free-benefit,
.mobile-summary .co-promo-discount-breakdown .co-promo-free-benefit span {
    color: var(--ink) !important;
}
.mobile-summary .panel-content h3 {
    margin-top: 4px;
}

/* Slide up transition */
.slide-up-enter-active, .slide-up-leave-active {
    transition: transform 0.25s ease, opacity 0.25s ease;
}
.slide-up-enter-from, .slide-up-leave-to {
    transform: translateY(8px);
    opacity: 0;
}

/* Ensure right overview hidden on mobile (safety) */
@media (max-width: 1199px) {
    .overview {
        display: none !important;
    }
}
/* Custom styles for Stop&Go SweetAlert */
:deep(.swal2-stopgo-actions){
    gap:16px !important;
}
:deep(.btn-stopgo-confirm){
    background:#e83539 !important;
    color:#fff !important;
    border:none !important;
    padding:12px 30px !important;
    font-family:'Montserrat',sans-serif;
    font-weight:600;
    font-size:15px;
    border-radius:0 !important;
    cursor:pointer;
    box-shadow:none !important;
    outline:none !important;
    text-shadow:none !important;
    transition:background .15s ease-in-out, color .15s ease-in-out;
}
:deep(.btn-stopgo-confirm:hover){
    background:#cf2f33 !important; /* leggermente più scuro */
}
:deep(.btn-stopgo-cancel){
    background:rgba(255,255,255,0.15) !important;
    color:#fff !important;
    border:1px solid rgba(255,255,255,0.4) !important;
    padding:12px 30px !important;
    font-family:'Montserrat',sans-serif;
    font-weight:600;
    font-size:15px;
    border-radius:0 !important;
    cursor:pointer;
    box-shadow:none !important;
    outline:none !important;
    text-shadow:none !important;
    backdrop-filter:blur(0px);
    transition:background .15s ease-in-out, border-color .15s ease-in-out;
}
:deep(.btn-stopgo-cancel:hover){
    background:rgba(255,255,255,0.22) !important;
    border-color:rgba(255,255,255,0.55) !important;
}
</style>
<style>
/* L'aspetto degli SweetAlert vive in assets/css/sweetalert.css: quel file
   e' importato in main.js dopo i componenti e chiude la cascata, quindi
   qualsiasi regola swal scritta qui verrebbe comunque sovrascritta.
   Restano sotto solo le regole strutturali del calendario. */

.swal-calendar-nav-chevron {
    background: transparent !important;
    border: none !important;
    color: #2e348c !important;
    font-size: 1.5em !important;
    cursor: pointer !important;
    padding: 5px 10px !important;
    transition: opacity 0.2s ease !important;
    font-weight: bold !important;
}

.swal-calendar-nav-chevron:hover {
    opacity: 0.7 !important;
}

.swal-calendar-nav-chevron:active {
    opacity: 0.5 !important;
}

/* Mobile styles for calendar */
@media (max-width: 768px) {
    .swal-calendar-popup {
        padding: 10px !important;
    }
    
    .swal-calendar-grid {
        padding: 0 !important;
        border-radius: 4px !important;
    }
    
    .swal-calendar-cell {
        min-height: auto !important;
        min-width: auto !important;
        aspect-ratio: 1 !important;
    }
    
    .swal-calendar-times {
        display: none !important;
    }
    
    .swal-calendar-checkmark {
        display: none !important;
    }
}

/* Desktop: keep times visible */
@media (min-width: 769px) {
    .swal-calendar-times {
        display: block !important;
    }
}

/* Stili per dropdown autocompletamento ISTAT */
.suggestion-item {
    padding: 12px 15px;
    cursor: pointer;
    border-bottom: 1px solid rgba(232, 53, 57, 0.1);
    color: #333;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    transition: background-color 0.2s ease;
}

.suggestion-item:hover {
    background-color: rgba(232, 53, 57, 0.1);
}

.suggestion-item:last-child {
    border-bottom: none;
}

/* Dropdown per utente principale */
.place-of-birth-suggestions-dropdown,
.city-suggestions-dropdown,
.postal-code-suggestions-dropdown,
.province-suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    background-color: rgba(255, 255, 255, 0.95);
    border: 2px solid #e83539;
    border-top: none;
    border-radius: 0 0 5px 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.place-of-birth-loading,
.city-loading,
.postal-code-loading,
.province-loading {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.95);
    border: 2px solid #e83539;
    border-top: none;
    border-radius: 0 0 5px 5px;
    padding: 12px 15px;
    color: #333;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 10px;
}

.place-of-birth-loading i,
.city-loading i,
.postal-code-loading i,
.province-loading i {
    color: #e83539;
}

/* Dropdown per tutore legale */
.legal-guardian-city-suggestions-dropdown,
.legal-guardian-postal-code-suggestions-dropdown,
.legal-guardian-province-suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    background-color: rgba(255, 255, 255, 0.95);
    border: 2px solid #e83539;
    border-top: none;
    border-radius: 0 0 5px 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.legal-guardian-city-loading,
.legal-guardian-postal-code-loading,
.legal-guardian-province-loading {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.95);
    border: 2px solid #e83539;
    border-top: none;
    border-radius: 0 0 5px 5px;
    padding: 12px 15px;
    color: #333;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 10px;
}

.legal-guardian-city-loading i,
.legal-guardian-postal-code-loading i,
.legal-guardian-province-loading i {
    color: #e83539;
}

/* Miglioramento per i campi con autocompletamento */
.form-group.position-relative {
    margin-bottom: 15px;
}

.form-group.position-relative .form-control {
    margin-bottom: 0;
}

/* Stili per dropdown nazione */
.country-dropdown-container {
    position: relative;
}

.country-dropdown-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: white;
    transition: transform 0.2s ease;
}

.country-dropdown-icon.open {
    transform: translateY(-50%) rotate(180deg);
}

.country-dropdown-search {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.95);
    border: 2px solid #e83539;
    border-top: none;
    border-radius: 0 0 5px 5px;
    z-index: 1000;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.country-search-input {
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    margin-bottom: 0;
}

.country-dropdown-list {
    max-height: 300px;
    overflow-y: auto;
}

.country-dropdown-item {
    padding: 12px 15px;
    cursor: pointer;
    color: #333;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s ease;
}

.country-dropdown-item:hover,
.country-dropdown-item.selected {
    background-color: rgba(232, 53, 57, 0.1);
    color: #e83539;
}

.country-dropdown-item:last-child {
    border-bottom: none;
}

.country-dropdown-search .no-results {
    padding: 12px 15px;
    color: #666;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    text-align: center;
}

/* Stili per lo step REGALO */
.gift-section {
    font-family: 'Montserrat', sans-serif;
}

.gift-section h3 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    color: white;
    font-size: 1.3rem;
}

.gift-section p {
    font-family: 'Montserrat', sans-serif;
    color: rgba(255, 255, 255, 0.85);
    font-size: 1rem;
    line-height: 1.5;
}

.gift-radio-container {
    display: flex;
    align-items: center;
    gap: 15px;
    font-family: 'Montserrat', sans-serif;
    padding: 15px;
    border-radius: 0px;
    border: 2px solid white;
    cursor: pointer;
    transition: background-color 0.3s ease, border-color 0.3s ease;
}

.gift-radio-container:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.gift-radio-container.radio-selected {
    box-shadow: inset 0 0 0 3px var(--red);
    border-color: transparent;
    background-color: rgba(232, 53, 57, 0.1);
}

.custom-radio {
    appearance: none;
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    min-height: 40px !important;
    background-color: #2e348c;
    border: 2px solid rgba(255, 255, 255, 0.144) !important;
    border-radius: 50% !important;
    outline: none;
    cursor: pointer;
    transition: background-color 0.3s ease, border-color 0.3s ease;
    position: relative;
    flex-shrink: 0;
}

.custom-radio:checked {
    background-color: #e83539;
    border-color: #e83539 !important;
}

.custom-radio:checked::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-color: white;
    border-radius: 50%;
}

.gift-radio-label {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: white;
    cursor: pointer;
    flex: 1;
    margin: 0;
}

.gift-recipient-fields {
    margin-top: 1.5rem;
}

.gift-recipient-fields .form-label {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: white;
    display: block;
    margin-bottom: 0.5rem;
}

.gift-recipient-fields .form-control {
    font-family: 'Montserrat', sans-serif;
    background-color: rgba(255, 255, 255, 0);
    border: 2px solid white;
    border-radius: 12px;
    color: white;
    min-height: 44px;
    padding: 10px 15px;
    width: 100%;
}

.gift-recipient-fields .form-control:focus {
    background-color: rgba(255, 255, 255, 0.05);
    border-color: white;
    color: white;
    outline: none;
    box-shadow: none;
}

.gift-recipient-fields .form-control::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.gift-recipient-fields textarea.form-control {
    min-height: 100px;
    resize: vertical;
}

.gift-recipient-fields .text-danger {
    color: #e83539;
}
</style>
